// scv-drawer.js — the slideout cart engine, extracted VERBATIM from
// sections/cart-set-view-next.liquid (29 Jul) after the section hit the
// 256KB source cap. Inputs rendered by the section before this loads:
//   #set-cart-config, #scv-journey-pairs (+ the other JSON islands),
//   window.__scvCfgUrls (bootstrap next to scv-cart-hook.js).

(function(){
  // Gate: only show when ?setcart=1 is in the URL
  // Set cart always active

  var container = document.getElementById('set-cart-view');
  var inner = document.getElementById('set-cart-inner');
  if (!container || !inner) return;

  var cfg;
  try { cfg = JSON.parse(document.getElementById('set-cart-config').textContent); } catch(e){ return; }

  // Geo-aware free-shipping thresholds + standard ship rates. Both populated from
  // Mirrors the live Shopify shipping rates (Settings → Shipping). Keyed by currency, geo-picked
  // below via window.Shopify.currency.active. Update here if you change Shopify shipping.
  // free-ship threshold per currency (0 = always-free zone, e.g. EUR/SGD/IE). The one
  // copy lives in flash-sale-state (__emFlashSaleConfig.freeShipThresholds); this map
  // only covers a page where that config never rendered.
  var FREE_SHIP_MAP = (window.__emFlashSaleConfig && window.__emFlashSaleConfig.freeShipThresholds)
    || { AUD: 140, USD: 99, CAD: 100, GBP: 50, NZD: 150, EUR: 0, SGD: 0 };
  // standard shipping rate per currency (0 = always-free zone):
  var SHIPPING_RATE_MAP = { AUD: 14.99, USD: 9.99, CAD: 13, GBP: 7, NZD: 16, EUR: 0, SGD: 0 };
  var FREE_SHIP = 150;
  var STANDARD_SHIPPING = 15;
  var S = '$';
  var bundleConfig = null;
  // Locale: "mum" everywhere (AU/NZ/UK/IE/SG English) except US/CA which use "mom".
  // Set at runtime from window.Shopify.country.iso_code; defaults to mum.
  var IS_MOM = false;
  var MUM_LOWER = 'mum', MUM_TITLE = 'Mum', MUM_UPPER = 'MUM', MUM_PLURAL = 'mums';

  // Journey product-pair map: shorts ↔ leggings + seedDefault per stage.
  // Pair variant maps come from the #scv-journey-pairs JSON island (the only
  // Liquid this file needed — extracted 29 Jul so the whole drawer engine can
  // live as an asset under Shopify's 256KB section cap).
  var __PAIR_DATA = {};
  try { __PAIR_DATA = JSON.parse(document.getElementById('scv-journey-pairs').textContent || '{}'); } catch (e) {}
  function __pairEntry(handle) {
    return { handle: handle, variantsBySize: __PAIR_DATA[handle] || {} };
  }
  var __JOURNEY_PAIRS = {
    'pregnancy': {
      shorts:   __pairEntry('shorts-mat-pocket-black'),
      leggings: __pairEntry('7-8-mat-pocket-leggings-black'),
      seedDefault: '7-8-mat-pocket-leggings-black',
      rangeLabel: 'maternity'
    },
    'postpartum-recovery': {
      shorts:   __pairEntry('pregnancy-recovery-emama-shorts-pockets'),
      leggings: __pairEntry('pregnancy-recovery-emama-7-8-leggings-pockets'),
      seedDefault: 'pregnancy-recovery-emama-7-8-leggings-pockets',
      rangeLabel: 'postpartum'
    },
    'breastfeeding': {
      crop: __pairEntry('emama-longline-crop'),
      seedDefault: 'emama-longline-crop',
      rangeLabel: 'breastfeeding'
    },
    'mum-uniform': {
      shorts:   __pairEntry('shorts-shaper-move-pockets-black'),
      leggings: __pairEntry('7-8-shaper-move-leggings-pockets-black'),
      seedDefault: '7-8-shaper-move-leggings-pockets-black',
      rangeLabel: 'mum-uniform'
    }
  };
  // ── Multi-variant (Colour x Size) helpers ──────────────────────────────────
  // A cart line's size/colour must NOT be read from variant_title directly: for a
  // Colour x Size product that title is e.g. "Beige / L". Resolve the SIZE from the
  // line's option named "size" (or a size-shaped value, or the size part of a
  // "Colour / Size" title); resolve the COLOUR similarly. Single-option (legacy)
  // lines fall straight through to variant_title.
  var __SIZE_SET = { XXS:1, XS:1, S:1, M:1, L:1, XL:1, XXL:1, XXXL:1 };
  function __variantSize(it) {
    var ov = it && it.options_with_values;
    if (ov && ov.length) {
      for (var i = 0; i < ov.length; i++) { if (/size/i.test(ov[i].name || '')) return String(ov[i].value || '').trim().toUpperCase(); }
      for (var j = 0; j < ov.length; j++) { var v2 = String(ov[j].value || '').trim().toUpperCase(); if (__SIZE_SET[v2]) return v2; }
    }
    var vt = String((it && it.variant_title) || '').trim();
    if (vt.indexOf(' / ') >= 0) { var ps = vt.split(' / '); for (var k = 0; k < ps.length; k++) { var pu = ps[k].trim().toUpperCase(); if (__SIZE_SET[pu]) return pu; } }
    return vt.toUpperCase();
  }
  function __variantColour(it) {
    var ov = it && it.options_with_values;
    if (ov && ov.length) { for (var i = 0; i < ov.length; i++) { if (/colou?r/i.test(ov[i].name || '')) return String(ov[i].value || '').trim(); } }
    var vt = String((it && it.variant_title) || '').trim();
    if (vt.indexOf(' / ') >= 0) { var ps = vt.split(' / '); for (var k = 0; k < ps.length; k++) { var pu = ps[k].trim().toUpperCase(); if (!__SIZE_SET[pu]) return ps[k].trim(); } }
    return null;
  }

  // Pick the user's most-frequent variant size from the cart (so "add the
  // leggings too" matches the size of what they already bought).  Returns
  // null when the cart has no items / no recognisable size.
  function __pickCartSize(cart) {
    if (!cart || !cart.items || !cart.items.length) return null;
    var counts = {};
    cart.items.forEach(function(it) {
      var s = __variantSize(it);
      if (s) counts[s] = (counts[s] || 0) + it.quantity;
    });
    var best = null, bestN = 0;
    for (var s in counts) if (counts[s] > bestN) { best = s; bestN = counts[s]; }
    return best;
  }
  // Resolve a target handle + cart size to a PURCHASABLE variant id.
  // EXACT size only — the old chain (exact → M → first variant) silently added
  // sizes the customer never picked. No exact purchasable match → null, and the
  // caller must fall back to PDP navigation (see-range), never another size.
  // Map values are {id, a: available, s: in-stock-now, sku}.
  function __resolveVariantFor(targetHandle, size) {
    var map = null;
    for (var k in __JOURNEY_PAIRS) {
      var p = __JOURNEY_PAIRS[k];
      [p.shorts, p.leggings, p.crop].forEach(function(entry){
        if (entry && entry.handle === targetHandle) map = entry.variantsBySize;
      });
    }
    if (!map || !size) return null;
    var e = map[size];
    return (e && e.a) ? e.id : null;
  }
  // Expose for the global click delegate (sits in an earlier IIFE and needs
  // these helpers to handle 'add-other' quick-adds).
  window.__JOURNEY_PAIRS = __JOURNEY_PAIRS;
  window.__resolveVariantFor = __resolveVariantFor;
  window.__pickCartSize = __pickCartSize;
  function __itemKindOf(it) {
    var s = ((it && (it.handle || it.product_title)) || '').toLowerCase();
    if (!s) return 'other';
    if (s.indexOf('long-line-crop') >= 0 || s.indexOf('longline-crop') >= 0 || s.indexOf('longline crop') >= 0 || s.indexOf('nursing crop') >= 0) return 'crop';
    // 7-8 = 7/8 leggings; check leggings keywords (incl. "fl-" full-length).
    if (s.indexOf('leggings') >= 0 || s.indexOf('7-8') >= 0 || /\bfl-/.test(s)) return 'leggings';
    if (s.indexOf('shorts') >= 0) return 'shorts';
    return 'other';
  }
  function __rangeLabelFor(sg) {
    var pair = __JOURNEY_PAIRS[sg];
    if (!pair || !pair.rangeLabel) return sg;
    if (sg === 'mum-uniform') return IS_MOM ? 'mom-uniform' : 'mum-uniform';
    return pair.rangeLabel;
  }
  function localizeMum(s) {
    if (!IS_MOM || !s) return s || '';
    return String(s)
      .replace(/\bMUMS\b/g, 'MOMS').replace(/\bMUM\b/g, 'MOM')
      .replace(/\bMums\b/g, 'Moms').replace(/\bMum\b/g, 'Mom')
      .replace(/\bmums\b/g, 'moms').replace(/\bmum\b/g, 'mom');
  }
  console.log('[scv freeship] build 2026-05-04T19:30 loaded (UI kill-switch=' + EM_FREESHIP_UI_ENABLED + ')');
  // ── Free shipping unlock offer (Klaviyo email+SMS capture in exchange for free ship) ──
  var EM_FREESHIP_UI_ENABLED = false;
  var FREESHIP_KLAVIYO_ACCOUNT = 'WUdCSm';
  // Subscribes to "Freeship Pack Captures" list (R7RNmM) — NOT the main Newsletter list (TqAnf9).
  // This isolates freeship signups from the Welcome Series flow that fires on Newsletter signups.
  // After 48h, a separate Klaviyo flow ("Freeship → Newsletter Promotion") moves them into TqAnf9.
  var FREESHIP_KLAVIYO_LIST_ID = 'R7RNmM';
  var FREESHIP_TIMER_MS = 10 * 60 * 1000;
  var FREESHIP_HARD_EXPIRY_MS = 24 * 60 * 60 * 1000;
  var FREESHIP_LS_USED = 'em_freeship_used';
  var FREESHIP_LS_OFFER_STARTED = 'em_freeship_offer_started_at';
  var FREESHIP_LS_OFFER_EXPIRED = 'em_freeship_offer_expired';
  // Single underscore prefix = "hidden from checkout summary" per Shopify convention.
  // Double underscore (__) gets silently wiped by some Shopify internal cleanup, so we use _.
  var FREESHIP_ATTR_UNLOCKED = '_em_freeship_unlocked_at';
  var FREESHIP_ATTR_EMAIL = '_em_freeship_email';
  var FREESHIP_ATTR_PHONE = '_em_freeship_phone';
  function lsGet(k){ try { return window.localStorage.getItem(k); } catch(e){ return null; } }
  function lsSet(k,v){ try { window.localStorage.setItem(k,v); } catch(e){} }
  // Country dial codes — used to normalize phone input to E.164 for Klaviyo SMS.
  var DIAL_CODE_BY_COUNTRY = { AU:'61', NZ:'64', US:'1', CA:'1', GB:'44', IE:'353', SG:'65' };
  function defaultDialCode(){
    var cc = (window.Shopify && window.Shopify.country && window.Shopify.country.iso_code) || 'AU';
    return DIAL_CODE_BY_COUNTRY[cc] || '61';
  }
  function normalizePhoneE164(raw){
    if (!raw) return '';
    var s = String(raw).trim();
    if (s.charAt(0) === '+') {
      var rest = s.slice(1).replace(/\D+/g,'');
      return rest.length >= 7 ? '+' + rest : '';
    }
    var digits = s.replace(/\D+/g,'');
    if (!digits) return '';
    if (digits.charAt(0) === '0') digits = digits.slice(1);
    var dial = defaultDialCode();
    var combined = dial + digits;
    return combined.length >= 7 ? '+' + combined : '';
  }
  function isValidEmail(e){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(e||'').trim()); }
  function freeshipKlaviyoSubscribe(email, phoneE164){
    // Use Klaviyo's hosted form-subscribe endpoint — same one their signup widgets use.
    // Avoids the JSON:API client-subscription quirks where 'subscriptions' field gets rejected
    // depending on account-level schema settings.
    var fd = new FormData();
    fd.append('g', FREESHIP_KLAVIYO_LIST_ID);
    fd.append('email', email);
    fd.append('$source', 'Cart Free Shipping Offer');
    fd.append('$consent', 'web');
    if (phoneE164) {
      fd.append('phone_number', phoneE164);
      fd.append('sms_consent', 'true');
    }
    return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      body: fd
    }).then(function(r) {
      return r.text().then(function(body) {
        if (!r.ok) console.warn('[scv freeship] klaviyo error', r.status, body);
        else console.log('[scv freeship] klaviyo subscribed', r.status, body);
        return r;
      });
    });
  }
  // Fires a Klaviyo "Free Shipping Pack Unlocked" event with rich context. Used in Klaviyo flows
  function freeshipKlaviyoFireUnlockEvent(email, phoneE164, unlockedAtMs, cart, ctx){
    ctx = ctx || {};
    var country = (window.Shopify && window.Shopify.country && window.Shopify.country.iso_code) || '';
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
    var items = (cart && cart.items) || [];
    var bundleQtyTotal = items.reduce(function(s, i){ return s + (i.quantity || 0); }, 0);
    var packTier = getTier(bundleQtyTotal).current || cartRungQtys()[0];
    var ugcByProductId = ctx.ugcByProductId || {};
    var lineItems = items.map(function(it){
      var pid = String(it.product_id || '');
      var productImg = (it.featured_image && it.featured_image.url) || it.image || '';
      var ugcImg = ugcByProductId[pid] || '';
      // image_url = UGC (real mum wearing) if available, else product photo. Template stays simple.
      return {
        title: it.product_title || '',
        variant_title: it.variant_title || '',
        qty: it.quantity || 0,
        unit_price: (it.price || 0) / 100,
        line_total: (it.line_price || 0) / 100,
        image_url: ugcImg || productImg,
        ugc_image_url: ugcImg,
        product_image_url: productImg,
        product_url: it.url ? ('https://' + location.host + it.url) : '',
        product_id: it.product_id || null,
        variant_id: it.variant_id || null
      };
    });
    var expiresAtMs = unlockedAtMs + FREESHIP_HARD_EXPIRY_MS;
    var body = {
      data: {
        type: 'event',
        attributes: {
          metric: { data: { type: 'metric', attributes: { name: 'Free Shipping Pack Unlocked' } } },
          profile: { data: { type: 'profile', attributes: {
            email: email,
            phone_number: phoneE164,
            properties: {
              last_freeship_unlock_at: new Date(unlockedAtMs).toISOString(),
              freeship_market: country,
              freeship_pack_tier: packTier,
              freeship_stage: ctx.stage || null,
              freeship_size: ctx.user_size || null
            }
          } } },
          properties: {
            pack_size: bundleQtyTotal,
            pack_tier: packTier,
            market: country,
            currency: currency,
            currency_symbol: S,
            cart_total: (cart && cart.total_price) ? (cart.total_price / 100) : null,
            cart_token: (cart && cart.token) || '',
            cart_url: 'https://' + location.host + '/cart',
            home_url: 'https://' + location.host,
            shipping_rate_saved: STANDARD_SHIPPING,
            free_ship_threshold: FREE_SHIP,
            unlocked_at: new Date(unlockedAtMs).toISOString(),
            expires_at: new Date(expiresAtMs).toISOString(),
            stage: ctx.stage || '',
            user_size: ctx.user_size || '',
            user_base_sizes: ctx.user_base_sizes || [],
            ugc_count: Object.keys(ugcByProductId).length,
            line_item_count: lineItems.length,
            line_items: lineItems
          },
          time: new Date(unlockedAtMs).toISOString()
        }
      }
    };
    return fetch('https://a.klaviyo.com/client/events/?company_id=' + FREESHIP_KLAVIYO_ACCOUNT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/vnd.api+json',
        'revision': '2024-10-15'
      },
      body: JSON.stringify(body)
    }).then(function(r){
      return r.text().then(function(t){
        if (!r.ok) console.warn('[scv freeship] klaviyo event error', r.status, t);
        else console.log('[scv freeship] klaviyo event fired', r.status);
        return r;
      });
    });
  }

  function freeshipWriteCartAttrs(email, phoneE164, unlockedAtMs){
    var attrs = {};
    attrs[FREESHIP_ATTR_UNLOCKED] = String(unlockedAtMs);
    attrs[FREESHIP_ATTR_EMAIL] = email;
    attrs[FREESHIP_ATTR_PHONE] = phoneE164;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function(r) { return r.json(); }).then(function(cart) {
      console.log('[scv freeship] cart attrs after write:', cart && cart.attributes);
      return cart;
    });
  }
  function freeshipFmtCountdown(ms){
    var t = Math.max(0, Math.floor(ms/1000));
    var m = Math.floor(t/60);
    var s = t - m*60;
    return (m<10?'0'+m:m) + ':' + (s<10?'0'+s:s);
  }

  // Bundle eligibility — primary source: client-side tag fetch from /products/{handle}.js.
  // The discount function checks the 'bundle-test' tag, so we read the same data.
  // Tags are cached per handle on first fetch; loadAndRender awaits this before render.
  var tagCache = {};
  // Seed tagCache with the 7 pair-product tags rendered at page load — saves
  // an extra fetch when the optimistic-add helper splices a new line in.
  try {
    var __pairTagsEl = document.getElementById('scv-pair-product-tags');
    if (__pairTagsEl) {
      var __pairTags = JSON.parse(__pairTagsEl.textContent || '{}');
      for (var __ph in __pairTags) tagCache[__ph] = __pairTags[__ph] || [];
    }
  } catch(__e3) {}
  // Per-variant data lookup for the optimistic-add helper (handle, image,
  // price + RRP in cents, etc.).  Same 7 pair products as the meta seed.
  var __pairVariantData = {};
  try {
    var __pvdEl = document.getElementById('scv-pair-variant-data');
    if (__pvdEl) __pairVariantData = JSON.parse(__pvdEl.textContent || '{}');
  } catch(__e4) {}
  function ensureTagsForCart(cart) {
    if (!cart || !cart.items) return Promise.resolve();
    var seen = {}; var fetches = [];
    cart.items.forEach(function(it) {
      if (it.handle && !seen[it.handle] && !(it.handle in tagCache)) {
        seen[it.handle] = true;
        fetches.push(
          fetch('/products/' + it.handle + '.js')
            .then(function(r) { return r.ok ? r.json() : null; })
            .then(function(p) { tagCache[it.handle] = (p && p.tags) || []; })
            .catch(function() { tagCache[it.handle] = []; })
        );
      }
    });
    return Promise.all(fetches);
  }
  /**
   * Publish the cart's bundle-eligible quantity for the PDP price ladder,
   * which marks the rung the CART already qualifies for.
   *
   * Deliberately NOT inside render(): render bails early on several cart
   * states, so a shopper arriving with a pre-existing cart got no value at
   * all and the ladder fell back to the page's own quantity — always showing
   * "1 item" as her current price. Called from loadAndRender instead, after
   * ensureTagsForCart resolves, so isBundleEligible has real tags to read.
   * Counts bundle-eligible lines only, so the Mum Club membership line is
   * excluded for free. Read-only; nothing in the drawer reads it back.
   */
  function publishBundleQty(cart) {
    try {
      var q = 0;
      if (cart && cart.items) cart.items.forEach(function (it) { if (isBundleEligible(it)) q += it.quantity; });
      if (window.__emCartBundleQty === q) return;
      window.__emCartBundleQty = q;
      window.dispatchEvent(new CustomEvent('em:cart:bundle-qty', { detail: { qty: q } }));
    } catch (e) {}
  }

  // Fallbacks (for any pre-fetch render): per-variant server-rendered map + cfg.stages handles
  var bundleEligibility = {};
  try {
    var __eligEl = document.getElementById('scv-bundle-eligibility');
    if (__eligEl) {
      JSON.parse(__eligEl.textContent || '[]').forEach(function(e){ bundleEligibility[e.variant_id] = !!e.include; });
    }
  } catch(__e) {}
  var bundleEligibleHandles = {};
  if (cfg && cfg.stages) {
    Object.keys(cfg.stages).forEach(function(s) {
      var sd = cfg.stages[s];
      if (sd && sd.products) sd.products.forEach(function(p) { if (p.handle) bundleEligibleHandles[p.handle] = true; });
    });
  }
  function isBundleEligible(item) {
    if (!item) return false;
    // Primary: tag from /products/{handle}.js — exact match for what the discount function checks
    if (item.handle && tagCache[item.handle] && tagCache[item.handle].indexOf('bundle-test') >= 0) return true;
    // Fallbacks if tags not yet fetched (first paint hedge)
    if (item.handle && bundleEligibleHandles[item.handle]) return true;
    if (bundleEligibility[item.variant_id] === true) return true;
    return false;
  }
  // Product metafield map (server-rendered) — keyed by variant_id.  Two
  var productMeta = {};
  try {
    var __metaEl = document.getElementById('scv-product-meta');
    if (__metaEl) productMeta = JSON.parse(__metaEl.textContent || '{}');
  } catch(__e) {}
  try {
    var __pairMetaEl = document.getElementById('scv-pair-product-meta');
    if (__pairMetaEl) {
      var __pairMeta = JSON.parse(__pairMetaEl.textContent || '{}');
      for (var __vid in __pairMeta) {
        if (!productMeta[__vid]) productMeta[__vid] = __pairMeta[__vid];
      }
    }
  } catch(__e2) {}
  function metaFor(vid) { return productMeta[vid] || productMeta[String(vid)] || {}; }
  // Variant unit price (in dollars) for a cart line item.
  function variantUnitDollars(it) {
    var p = (it.price != null) ? it.price : (it.line_price / Math.max(1, it.quantity));
    return (p || 0) / 100;
  }
  // ── Membership pricing toggle ── ON (default) = member/bundle prices; OFF = full (variant) prices.
  if (typeof window.__mcMember === 'undefined') window.__mcMember = true;
  // Existing active member (from their membership_sync metafield) → always member pricing, no join needed.
  function mcIsActiveMember() {
    var m = window.__mcCustomerMembership;
    if (!m || !m.status) return false;
    if (m.status === 'active') return true;
    if (m.status === 'grace') { var g = m.graceUntil ? Date.parse(m.graceUntil) : 0; return g > Date.now(); }
    return false;
  }
  function mcUnit(it, bq) {
    return window.__mcMember ? clampToVariant(priceForQty(bq), variantUnitDollars(it)) : variantUnitDollars(it);
  }
  var MC_MEMBERSHIP_PRICE = (typeof window.__mcMembershipPrice === 'number' && window.__mcMembershipPrice > 0) ? window.__mcMembershipPrice : 9.99; // real membership product price (Liquid), 9.99 fallback
  function mcMoney(n) { return S + (Number.isInteger(n) ? n : (Math.round(n * 100) / 100).toFixed(2)); }
  // Member/bundle subtotal of the items (excludes the membership line) — independent of the toggle,
  // so we can always compute the saving in either view.
  function mcMemberItemsTotal(cart) {
    if (!bundleConfig || !bundleConfig.tiers || !cart || !cart.items) return Math.ceil(((cart && cart.total_price) || 0) / 100);
    var bq = 0;
    cart.items.forEach(function(it){ if (!mcIsMembershipLine(it) && isBundleEligible(it)) bq += it.quantity; });
    var tier = priceForQty(bq), sum = 0;
    cart.items.forEach(function(it){
      if (mcIsMembershipLine(it)) return;
      sum += (isBundleEligible(it) ? clampToVariant(tier, variantUnitDollars(it)) : variantUnitDollars(it)) * it.quantity;
    });
    return Math.ceil(sum);
  }
  // Mum Club join product — added to the cart when the toggle is ON, removed when OFF.
  // Hidden from the cart UI + totals (visual handled later).
  //  • Paid mode: the subscription variant (a real monthly charge).
  //  • Free mode: the "Mum Club Deal" product when it's Active+published — $0, NO selling plan,
  //    so member pricing applies at checkout with no charge. Flip that product Active/Draft to switch.
  var MC_MEMBERSHIP_VARIANT_PAID = 47749639798947;
  var MC_MEMBERSHIP_SELLING_PLAN = 3281453219;
  // Hardcoded so a leftover free line is recognised (hidden + cleaned up) even when the product is
  // Draft — Liquid returns null for a draft product's variant id, so we can't rely on __mcFreeDealVariant.
  var MC_FREE_DEAL_VARIANT = 47760720724131;
  var MC_FREE = (window.__mcFreeDealActive === true);
  var MC_MEMBERSHIP_VARIANT = MC_FREE ? MC_FREE_DEAL_VARIANT : MC_MEMBERSHIP_VARIANT_PAID;
  // Always recognise BOTH variants as membership lines so the cart hides them and a mode switch
  // cleanly removes whichever is stale — regardless of which product is currently Active/Draft.
  function mcIsMembershipLine(it) { return !!it && (it.variant_id === MC_MEMBERSHIP_VARIANT_PAID || it.variant_id === MC_FREE_DEAL_VARIANT); }
  // Reconcile the membership subscription line with the toggle state, then re-render.
  // In-flight guard: /cart/add.js INCREMENTS an existing line, so two overlapping
  // reconciles (drawer open + mutation observer, or a fast toggle off→on against a
  // stale cart snapshot) used to double-add the membership. While one membership
  // mutation is in flight, further reconciles wait for the fresh cart it triggers.
  var mcMembershipPostInFlight = false;
  function mcMembershipPost(url, body) {
    if (mcMembershipPostInFlight) return;
    mcMembershipPostInFlight = true;
    var done = function() { mcMembershipPostInFlight = false; loadAndRender(); };
    var xhr = new XMLHttpRequest();
    xhr.open('POST', url, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.onload = done; xhr.onerror = done;
    xhr.send(JSON.stringify(body));
  }
  // Session opt-out: a non-member who toggles OFF stays off for the session. Default is ON.
  function mcOptedOff() { try { return sessionStorage.getItem('mc_off') === '1'; } catch (e) { return false; } }
  // Default ON: reconcile the membership line to the desired state on every cart load —
  //  • active member → never carry the join product (remove if present; they already pay)
  //  • non-member, not opted out, has bundle items → membership IN cart (auto-added)
  //  • non-member opted out → membership removed
  // Only acts on a real mismatch (no-op when already in sync → no render loop).
  function mcReconcileMembership(cart) {
    if (!cart || !cart.items) return;
    if (mcMembershipPostInFlight) return; // a membership mutation is pending — reconcile against ITS fresh cart instead
    var line = cart.items.filter(mcIsMembershipLine)[0];
    if (mcIsActiveMember()) { if (line) mcMembershipPost('/cart/change.js', { id: line.key, quantity: 0 }); return; }
    var want = !mcOptedOff() && cart.items.some(isBundleEligible);
    var lineIsRight = line && line.variant_id === MC_MEMBERSHIP_VARIANT;
    if (want && lineIsRight && line.quantity !== 1) {
      // Self-heal: the membership must only ever be in the cart ONCE. Any
      // historical duplicate (however it got there) is normalised on load.
      mcMembershipPost('/cart/change.js', { id: line.key, quantity: 1 });
    } else if (want && !line) {
      var addBody = { id: MC_MEMBERSHIP_VARIANT, quantity: 1 };
      if (!MC_FREE) addBody.selling_plan = MC_MEMBERSHIP_SELLING_PLAN; // free product has no selling plan
      mcMembershipPost('/cart/add.js', { items: [addBody] });
    } else if (want && line && !lineIsRight) {
      // Stale variant from the other mode is in the cart — drop it; next reconcile adds the right one.
      mcMembershipPost('/cart/change.js', { id: line.key, quantity: 0 });
    } else if (!want && line) {
      mcMembershipPost('/cart/change.js', { id: line.key, quantity: 0 });
    }
  }
  // Mum Club "learn more" modal — DYNAMIC to the current cart (totals stashed in window.__mcTotals each render).
  function mcLearnCopy() {
    var t = window.__mcTotals || {};
    var hasCart = (t.full || 0) > 0;
    var h =
      '<div style="font-size:21px;font-weight:800;color:#1f2937;line-height:1.25;margin-bottom:4px;">join the emamaco community of 350k+ ' + MUM_PLURAL + '</div>'
      + '<div style="font-size:15px;color:#6b7280;margin-bottom:18px;">get ' + MUM_LOWER + '-worthy pricing</div>';
    if (MC_FREE) {
      // Free mode — member pricing on us, no subscription. Keep the door open to a future paid tier.
      // Nothing here says it is ever paid (Mark, 2026-10-10: "remove mention of it being paid").
      h += '<div style="font-size:14px;color:#1f2937;line-height:1.6;margin-bottom:12px;"><strong>' + MUM_TITLE + ' Club is free. No fee and no ongoing commitment to join.</strong></div>'
      + '<div style="font-size:14px;color:#6b7280;line-height:1.6;margin-bottom:18px;">Just turn on ' + MUM_LOWER + ' club in your cart!</div>';
    }
    if (hasCart && !(t.save > 0)) {
      // No discount yet: the pack prices she can reach, not "You save $0".
      var lq = packTierQtys();
      h += '<div style="background:#fbf7ef;border:1px solid #ecd9cf;border-radius:10px;padding:14px 16px;margin-bottom:16px;">'
        + '<div style="font-size:13px;font-weight:700;color:#1f2937;margin-bottom:8px;">' + MUM_TITLE + ' Club pack prices, mix any styles:</div>'
        + lq.map(function(q) {
            return '<div style="display:flex;justify-content:space-between;font-size:14px;color:#374151;padding:2px 0;"><span>' + q + ' pieces</span><span style="font-weight:700;">' + formatWholeMoney(priceForQty(q)) + ' each</span></div>';
          }).join('')
        + (t.nudge ? '<div style="font-size:14px;font-weight:800;color:#15803d;padding:7px 0 0;margin-top:5px;border-top:1px solid #e6d6ca;">You have ' + t.nudge.have + '. Add ' + t.nudge.add + ' more to start.</div>' : '')
        + '</div>';
    } else if (hasCart) {
      h += '<div style="background:#fbf7ef;border:1px solid #ecd9cf;border-radius:10px;padding:14px 16px;margin-bottom:16px;">'
        + '<div style="font-size:13px;font-weight:700;color:#1f2937;margin-bottom:8px;">Your cart today:</div>'
        + '<div style="display:flex;justify-content:space-between;font-size:14px;color:#374151;padding:2px 0;"><span>Regular price</span><span>' + mcMoney(t.full) + '</span></div>'
        + '<div style="display:flex;justify-content:space-between;font-size:14px;color:#374151;padding:2px 0;"><span>' + MUM_TITLE + ' Club price</span><span style="font-weight:700;">' + mcMoney(t.member) + '</span></div>'
        + '<div style="display:flex;justify-content:space-between;font-size:16px;font-weight:800;color:#15803d;padding:7px 0 0;margin-top:5px;border-top:1px solid #e6d6ca;"><span>You save</span><span>' + mcMoney(t.save) + '</span></div>'
        + '</div>';
    }
    if (!MC_FREE) {
    var mcDisc = (window.__mcMembershipCompareAt > window.__mcMembershipPrice && window.__mcMembershipPrice > 0);
    h += (mcDisc
      ? '<div style="background:#fef2f2;border:1px solid #fecaca;border-radius:10px;padding:13px 15px;margin-bottom:14px;"><div style="font-size:14px;font-weight:800;color:#dc2626;">⚡ Limited offer — lock in your rate</div><div style="font-size:14px;color:#374151;margin-top:5px;line-height:1.5;">Join now for <strong>' + mcMoney(window.__mcMembershipPrice) + '/month</strong> instead of <span style="text-decoration:line-through;color:#9ca3af;">' + mcMoney(window.__mcMembershipCompareAt) + '</span> — and you keep this lower rate for as long as you stay a member. Once it\'s gone, it\'s gone.</div></div>'
      : '<div style="font-size:14px;color:#1f2937;line-height:1.6;margin-bottom:6px;"><strong>Mum Club costs ' + mcMoney(MC_MEMBERSHIP_PRICE) + '/month. Cancel Anytime.</strong></div>')
      + '<div style="font-size:14px;color:#6b7280;line-height:1.6;margin-bottom:18px;">That means today’s saving alone covers your membership many times over.</div>'
      + '<div style="font-weight:800;color:#1f2937;margin-bottom:8px;">You also get:</div>'
      + '<ul style="margin:0 0 16px;padding-left:18px;color:#374151;line-height:1.6;">'
      +   '<li style="margin-bottom:5px;">Member pricing on every order</li>'
      +   '<li style="margin-bottom:5px;">Early access to drops and restocks</li>'
      +   '<li style="margin-bottom:5px;">Members-only giveaways</li>'
      +   '<li style="margin-bottom:5px;">No codes needed</li>'
      + '</ul>'
      + '<div style="font-size:12px;color:#9ca3af;line-height:1.5;margin-bottom:16px;">Cancel anytime. No lock-in. Billed monthly until cancelled. <a href="/pages/mum-club-membership-terms" style="color:#b5894e;text-decoration:underline;">Full terms</a>.</div>'
      + '<div style="background:#f9fafb;border-radius:10px;padding:13px 15px;font-size:14px;font-weight:600;color:#1f2937;line-height:1.5;">Turn Mum Club on in your cart and your member price applies instantly.</div>';
    }
    return h;
  }
  function mcShowLearnMore() {
    var ex = document.getElementById('mc-learn-modal');
    if (ex) { ex.style.display = 'flex'; return; }
    var m = document.createElement('div');
    m.id = 'mc-learn-modal';
    m.style.cssText = 'position:fixed;inset:0;z-index:100002;background:rgba(0,0,0,0.55);display:flex;align-items:flex-end;justify-content:center;font-family:system-ui,-apple-system,sans-serif;';
    m.innerHTML = '<div style="background:#fff;width:100%;max-width:520px;max-height:88vh;overflow-y:auto;border-radius:16px 16px 0 0;">'
      + '<div style="position:sticky;top:0;background:#fff;display:flex;justify-content:space-between;align-items:center;padding:16px 20px;border-bottom:1px solid #eee;border-radius:16px 16px 0 0;"><span style="font-size:16px;font-weight:800;color:#1f2937;letter-spacing:0.04em;">WELCOME TO ' + MUM_UPPER + ' CLUB</span><button type="button" id="mc-learn-close" aria-label="Close" style="background:none;border:none;font-size:24px;line-height:1;cursor:pointer;color:#374151;padding:2px 6px;">×</button></div>'
      + '<div style="padding:18px 20px 28px;color:#374151;font-size:14px;line-height:1.6;">' + mcLearnCopy() + '</div>'
      + '</div>';
    document.body.appendChild(m);
    m.addEventListener('click', function(e){ if (e.target === m || e.target.id === 'mc-learn-close') m.style.display = 'none'; });
  }
  // Membership toggle: inject the switch CSS once + bind a delegated change listener once.
  if (!window.__mcToggleInit) {
    window.__mcToggleInit = true;
    var __mcStyle = document.createElement('style');
    __mcStyle.textContent = '.mc-toggle{display:inline-flex;align-items:center;cursor:pointer;-webkit-tap-highlight-color:transparent;}.mc-toggle-input{position:absolute;width:1px;height:1px;opacity:0;}.mc-toggle-track{position:relative;display:inline-block;width:52px;height:30px;border-radius:999px;background:#d1d5db;transition:background .2s ease;flex:none;}.mc-toggle-thumb{position:absolute;top:3px;left:3px;width:24px;height:24px;border-radius:50%;background:#fff;box-shadow:0 1px 3px rgba(0,0,0,.25);transition:transform .2s ease;}.mc-toggle-input:checked + .mc-toggle-track{background:#c8a84e;}.mc-toggle-input:checked + .mc-toggle-track .mc-toggle-thumb{transform:translateX(22px);}.mc-toggle-input:focus-visible + .mc-toggle-track{box-shadow:0 0 0 3px rgba(200,168,78,.35);}';
    if (document.head) document.head.appendChild(__mcStyle);
    document.addEventListener('change', function(e) {
      if (e.target && e.target.id === 'mc-membership-toggle') {
        try { if (e.target.checked) sessionStorage.removeItem('mc_off'); else sessionStorage.setItem('mc_off', '1'); } catch (err) {}
        window.__mcMember = e.target.checked;
        mcReconcileMembership(lastCartJson);
      }
    });
    document.addEventListener('click', function(e) {
      var lm = e.target && e.target.closest && e.target.closest('.mc-learn-more');
      if (lm) { e.preventDefault(); mcShowLearnMore(); }
    });
  }
  // Effective per-item price = min(tier_price, variant_price). Shopify discount functions can
  // only DECREASE prices, never raise them. So when tier > variant (e.g. US tier 1 = $999 used
  // as a no-op so 1-4 items stay at variant price), the variant price wins.
  // What a single item actually costs right now, for the ladder's qty-1 rung.
  // Prefers the cart's own bundle-eligible variant price; falls back to the
  // config's canonical full price of one. Deliberately NOT avgBundleVariantPrice
  // — that invents $35 on an empty cart, which would advertise a price nothing
  // is sold at.
  function singleItemUnitNow(cart) {
    if (cart && cart.items) {
      var sum = 0, qty = 0;
      cart.items.forEach(function (it) {
        if (!isBundleEligible(it)) return;
        var u = variantUnitDollars(it);
        if (u > 0) { sum += u * it.quantity; qty += it.quantity; }
      });
      if (qty > 0) return sum / qty;
    }
    var po = bundleConfig && Number(bundleConfig.price_of_one);
    if (po > 0 && po < 900) return po;
    var dp = bundleConfig && Number(bundleConfig.default_price);
    return (dp > 0 && dp < 900) ? dp : 0;
  }

  // "Normal price for one" companion to singleItemUnitNow, for the qty-1 rung's
  // strikethrough. Weighted exactly like the price it sits beside: the average across
  // bundle-eligible lines, so rung and struck price are always the same kind of number.
  //
  // Per line the normal price is the line's own unit price, or its catalog compare-at
  // when that is higher. The saving shown is the qty-1 pack tier undercutting that, NOT
  // a compare-at markdown — compare-at is kept equal to price across the catalogue, so
  // a markdown test would suppress this strike everywhere.
  //
  // Compare-at comes from the pack catalog by variant id because Shopify omits
  // compare_at_price from cart.js; absent a catalog row the line still contributes its
  // own unit price, which is the honest floor.
  var _cmpByVariant = null;
  function compareAtIndex() {
    if (_cmpByVariant) return _cmpByVariant;
    var cat = window.__emPackCatalog;
    if (!cat || !cat.products) return null;          // catalog not in yet — retry next render
    var m = {};
    cat.products.forEach(function (p) {
      (p.variants || []).forEach(function (v) {
        var c = Number(v.compareAt);
        if (c > 0) m[String(v.id)] = c;
      });
    });
    _cmpByVariant = m;
    return m;
  }
  function singleItemNormalNow(cart) {
    if (!cart || !cart.items) return 0;
    var idx = compareAtIndex() || {};
    var sum = 0, qty = 0;
    cart.items.forEach(function (it) {
      if (!isBundleEligible(it)) return;
      var unit = variantUnitDollars(it);
      if (!(unit > 0)) return;
      var cmp = idx[String(it.variant_id != null ? it.variant_id : it.id)] || 0;
      sum += Math.max(unit, cmp) * it.quantity;
      qty += it.quantity;
    });
    return qty > 0 ? sum / qty : 0;
  }

  function clampToVariant(tierPrice, variantPrice) {
    if (typeof variantPrice !== 'number' || !isFinite(variantPrice) || variantPrice <= 0) return tierPrice;
    return Math.min(tierPrice, variantPrice);
  }
  // Average variant price across bundle items currently in cart. Ceiling for tier-price
  // simulations (adding 1 more item, upsell card prices). Falls back to $35 if cart empty.
  function avgBundleVariantPrice(cart) {
    if (!cart || !cart.items) return 35;
    var sum = 0, qty = 0;
    cart.items.forEach(function(it) {
      if (!isBundleEligible(it)) return;
      var unit = variantUnitDollars(it);
      if (unit > 0) { sum += unit * it.quantity; qty += it.quantity; }
    });
    return qty > 0 ? sum / qty : 35;
  }
  // Compute the price the customer will actually pay at checkout (matches discount function logic)
  function computeBundlePricedTotal(cart) {
    if (!bundleConfig || !bundleConfig.tiers) return cart.total_price / 100;
    if (!window.__mcMember) return cart.total_price / 100; // membership OFF → full price = Shopify line total (sum of variant prices)
    var bundleQty = 0;
    var nonBundleTotal = 0;
    cart.items.forEach(function(it) {
      if (mcIsMembershipLine(it)) return; // membership excluded from the priced total (handled later)
      if (isBundleEligible(it)) {
        bundleQty += it.quantity;
      } else {
        nonBundleTotal += variantUnitDollars(it) * it.quantity;
      }
    });
    var tierPerItem = priceForQty(bundleQty);
    // Per bundle line: effective unit = min(tier, line variant). Sum.
    var bundleTotal = 0;
    cart.items.forEach(function(it) {
      if (!isBundleEligible(it)) return;
      bundleTotal += clampToVariant(tierPerItem, variantUnitDollars(it)) * it.quantity;
    });
    return Math.ceil(bundleTotal + nonBundleTotal);
  }
  var preorderConfig = null;
  var continueSellingSkus = new Set();
  var userStageOverride = null;
  var lastCartJson = null; // track for Shopify native cart sync
  var __upsellRenderToken = 0;
  var cartSaleUiTimer = null;

  function inferLifestage(items) {
    var hasMat = false, hasRec = false, hasNurs = false;
    items.forEach(function(it) {
      var t = (it.product_title || '').toLowerCase();
      if (t.indexOf('maternity') >= 0 || t.indexOf('mat ') >= 0) hasMat = true;
      if (t.indexOf('recovery') >= 0) hasRec = true;
      if (t.indexOf('nursing') >= 0) hasNurs = true;
    });
    if (hasMat) return 'pregnant';
    if (hasRec || hasNurs) return 'postpartum';
    return 'mum';
  }

  function getCartSize(items) {
    var sizes = {};
    items.forEach(function(it) {
      var s = __variantSize(it);
      if (s) sizes[s] = (sizes[s] || 0) + it.quantity;
    });
    var best = null, bc = 0;
    for (var s in sizes) { if (sizes[s] > bc) { best = s; bc = sizes[s]; } }
    return best || 'M';
  }

  // Returns the user's BASE sizes (from non-post-partum cart items, sorted by frequency desc).
  // Recovery/nursing items are excluded since they're already sized up by user — using them would
  // double-shift when the resolver applies sizeUpForPostPartum.
  function getCartBaseSizes(items) {
    var sizes = {};
    items.forEach(function(it) {
      var t = (it.product_title || '').toLowerCase();
      var isPP = t.indexOf('recovery') >= 0 || t.indexOf('nursing') >= 0;
      if (isPP) return;
      var s = __variantSize(it);
      if (s) sizes[s] = (sizes[s] || 0) + it.quantity;
    });
    if (Object.keys(sizes).length === 0) {
      // Fallback: use all items (e.g. cart only has post-partum items)
      items.forEach(function(it) {
        var s = __variantSize(it);
        if (s) sizes[s] = (sizes[s] || 0) + it.quantity;
      });
    }
    var arr = Object.keys(sizes).sort(function(a, b) { return sizes[b] - sizes[a]; });
    return arr.length ? arr : ['M'];
  }

  // No qualifying tier (qty below the lowest min_qty — e.g. 1-2 when there's no
  // min_qty 1/2 tier) → Infinity = "no discount". Callers clamp to the item's
  // variant price, so the full price shows instead of the lowest tier's price.
  function priceForQty(qty) {
    if (!bundleConfig || !bundleConfig.tiers || !bundleConfig.tiers.length) return Infinity;
    var p = Infinity;
    for (var i = 0; i < bundleConfig.tiers.length; i++) {
      if (qty >= bundleConfig.tiers[i].min_qty) p = bundleConfig.tiers[i].price;
    }
    return p;
  }

  // ONE NUDGE WHEN THE CART HAS NO DISCOUNT (Mark, 2026-10-10: one item is simply full price, so "−$0",
  // "Mum Club FREE" and "You saved $0" said nothing; "how should we adjust wording ... so ... the customer will
  // add more to cart to get her discount ... but only when theres no discount"). Null when the cart already has a
  // discount, has no pack pieces, or no bigger pack would lower EVERY piece in it (a cheap piece priced under the
  // next rung must never be told it "drops"). Prices are the live ladder (bundleConfig), so the copy follows it.
  function scvNoDiscountNudge(cart) {
    if (!cart || !cart.items || !bundleConfig || !bundleConfig.tiers || !bundleConfig.tiers.length) return null;
    var bq = 0, minUnit = Infinity, full = 0;
    cart.items.forEach(function(it) {
      if (mcIsMembershipLine(it)) return;
      full += (((it.original_price != null ? it.original_price : it.price) || 0) / 100) * it.quantity;
      if (!isBundleEligible(it)) return;
      bq += it.quantity;
      minUnit = Math.min(minUnit, variantUnitDollars(it));
    });
    if (!bq || !(minUnit < Infinity)) return null;
    if (Math.ceil(full) - mcMemberItemsTotal(cart) > 0) return null;   // already discounted
    var qtys = packTierQtys(), q = null;
    for (var i = 0; i < qtys.length; i++) { if (qtys[i] > bq && priceForQty(qtys[i]) < minUnit) { q = qtys[i]; break; } }
    if (!q) return null;
    var p = priceForQty(q), add = q - bq;
    var after = qtys.filter(function(x) { return x > q && priceForQty(x) < p; });
    var more = [];
    if (after.length) more.push(after[0]);
    if (after.length > 1) more.push(after[after.length - 1]);
    return {
      have: bq, add: add, q: q,
      head: 'Add ' + add + ' more piece' + (add === 1 ? '' : 's') + ' and ' + (q === 2 ? 'both' : 'all ' + q) + ' drop to ' + formatWholeMoney(p) + ' each',
      sub: more.map(function(x) { return x + ' for ' + formatWholeMoney(priceForQty(x)) + ' each'; }).join(' \u00b7 ') + (more.length ? '. ' : '') + 'Mix any styles.'
    };
  }
  function scvNudgeHtml(n, clubOff) {
    if (!n) return '';
    // Just the nudge (Mark, 2026-10-11); the price table it leaned on was removed from the drawer on 2026-10-14.
    return '<div style="margin-top:9px;font-size:13px;font-weight:700;color:#15803d;line-height:1.4;">' + n.head + (clubOff ? ' with ' + MUM_TITLE + ' Club' : '') + '</div>';
  }

  // Hero-set economics for the empty-cart pill CTA. Same source the
  // slideout header uses (bundleConfig tiers): discounted hero-total vs RRP
  // (heroQty × default_price). Returns null until bundleConfig has loaded so
  // the caller can fall back to number-less copy rather than show $0.
  function _scvSetEconomics() {
    if (!bundleConfig || !bundleConfig.tiers || !bundleConfig.tiers.length) return null;
    // RRP = bundleConfig.default_price (per-item retail), NOT priceForQty(1)
    // — tier[0] is the "1 Item Sale" price, already discounted, which would
    // collapse the savings figure. default_price is the bundle system's
    // canonical regular per-item price (e.g. AUD 100 vs the $28 hero tier).
    var rrpPer = bundleConfig.default_price;
    if (!(rrpPer > 0) || rrpPer >= 900) return null; // missing / sentinel (e.g. fullPrice 999)
    var hq = heroQty();
    var total = Math.ceil(priceForQty(hq) * hq);
    var rrp = Math.ceil(rrpPer * hq);
    var save = rrp - total;
    if (!(total > 0) || !(save > 0) || save >= rrp) return null;
    return { sym: S, total: total, save: save, qty: hq };
  }

  // Dollar saved at an arbitrary cart qty vs RRP — for the 5/7/9 reward
  // states + the 6/8 next-tier bonus. Same source as _scvSetEconomics
  // (default_price RRP, priceForQty tier). null until config loads.
  function _scvSavedAtQty(n) {
    if (!bundleConfig || !bundleConfig.tiers || !bundleConfig.tiers.length) return null;
    var rrpPer = bundleConfig.default_price;
    if (!(rrpPer > 0) || rrpPer >= 900 || !(n > 0)) return null;
    var save = Math.ceil(rrpPer * n) - Math.ceil(priceForQty(n) * n);
    return (save > 0) ? save : null;
  }

  // Pack-builder journey category for the current browsing context, so the
  // empty-cart pill opens the builder pre-seeded to the right stage instead
  // of its maternity default. Mirrors _scvStageLabel's title/path detection.
  function _scvStageCat() {
    // SPA-accurate signal first: the packprice keeps window.pdpMeta /
    // window.pdpLifestage fresh on every in-place swap. On the home SPA the
    // URL stays "/" and #v2-title-name doesn't exist in this theme, so the
    // old title/path detection always fell through to mumlife. Trust the
    // live lifestage; only fall back to title/path when it's absent.
    var ls = (window.pdpMeta && window.pdpMeta.pdpLifestage) || window.pdpLifestage || '';
    if (ls === 'pregnant')   return 'maternity';
    if (ls === 'postpartum') return 'postpartum';
    if (ls === 'mum')        return 'mumlife';
    var t = '';
    var el = document.getElementById('v2-title-name');
    if (el && el.textContent) t = el.textContent.toLowerCase();
    else if (typeof window.pdpTitle === 'string') t = window.pdpTitle.toLowerCase();
    else t = (location.pathname.match(/\/products\/([^\/?#]+)/) || [,''])[1].toLowerCase();
    var p = location.pathname.toLowerCase();
    var blob = t + ' ' + p;
    if (blob.indexOf('maternity') >= 0 || blob.indexOf('pregnancy') >= 0) return 'maternity';
    if (blob.indexOf('recovery') >= 0 || blob.indexOf('nursing') >= 0 || blob.indexOf('postpartum') >= 0 || blob.indexOf('post-partum') >= 0) return 'postpartum';
    return 'mumlife'; // shapewear / shaper / generic mum-life
  }

  // ── Ladder shape from the config (single source) ────────────────────────
  // Pack tiers ascending (min_qty > 1, sentinel-filtered); hero = the flagship
  // set the pill/upsell copy leads with (role 'hero', else the freeShip tier,
  // else the middle rung). FALLBACK_PACK_QTYS only bridges the moment before
  // bundleConfig has loaded — every rendered state re-derives from the JSON.
  var FALLBACK_PACK_QTYS = [5, 7, 9];
  function packTierQtys() {
    if (!bundleConfig || !bundleConfig.tiers || !bundleConfig.tiers.length) return FALLBACK_PACK_QTYS;
    var qtys = bundleConfig.tiers.filter(function(t) {
      var q = Number(t.min_qty), p = Number(t.price);
      return q > 1 && p > 0 && p < 900;
    }).map(function(t) { return Number(t.min_qty); }).sort(function(a, b) { return a - b; });
    return qtys.length ? qtys : FALLBACK_PACK_QTYS;
  }
  function heroTier() {
    if (!bundleConfig || !bundleConfig.tiers) return null;
    var ts = bundleConfig.tiers.filter(function(t) {
      var q = Number(t.min_qty), p = Number(t.price);
      return q > 1 && p > 0 && p < 900;
    }).sort(function(a, b) { return Number(a.min_qty) - Number(b.min_qty); });
    for (var i = 0; i < ts.length; i++) if (ts[i].role === 'hero') return ts[i];
    return ts[Math.floor((ts.length - 1) / 2)] || null;
  }
  function heroQty() { var h = heroTier(); return h ? Number(h.min_qty) : FALLBACK_PACK_QTYS[0]; }
  // The pack free shipping is marketed at — calculated, never flagged: the smallest
  // pack whose set total reaches the free-shipping threshold (else the biggest pack).
  function freeShipSetQty() {
    var qtys = packTierQtys();
    for (var i = 0; i < qtys.length; i++) {
      if (Math.ceil(priceForQty(qtys[i]) * qtys[i]) >= FREE_SHIP) return qtys[i];
    }
    return qtys[qtys.length - 1];
  }
  // The cart celebrates EVERY pack tier (Mark, 2026-09-11): each discounted
  // pack rung is a milestone, and upsells always target the next tier not yet
  // reached in the cart.
  function cartRungQtys() {
    return packTierQtys();
  }
  function maxPackQty() { var q = cartRungQtys(); return q[q.length - 1]; }

  function getTier(count) {
    var qtys = cartRungQtys();
    var current = 0, next = null;
    for (var i = 0; i < qtys.length; i++) {
      if (count >= qtys[i]) current = qtys[i];
      else { next = qtys[i]; break; }
    }
    return { current: current, next: next, target: next || current };
  }

  function formatWholeMoney(amount) {
    return S + Math.ceil(Number(amount) || 0);
  }

  function bundleTotalForQty(qty) {
    return formatWholeMoney(Math.ceil(priceForQty(qty) * qty));
  }

  function bundlePerItemForQty(qty) {
    return formatWholeMoney(priceForQty(qty));
  }

  // Free-ship gate uses the BUNDLE-DISCOUNTED total (matches Shopify's evaluation order —
  function itemsNeededForFreeShipping(cart, memFee) {
    if (!cart || !cart.items) return 0;
    if (!bundleConfig || !bundleConfig.tiers) return 0;
    var mf = memFee || 0; // membership fee in cart counts toward the free-ship threshold
    var bundleQty = 0, nonBundleSubtotal = 0;
    cart.items.forEach(function(it) {
      if (isBundleEligible(it)) bundleQty += it.quantity;
      else nonBundleSubtotal += variantUnitDollars(it) * it.quantity;
    });
    // Avg variant ceiling — used for ALL bundle items in simulation (including the n new ones).
    var avgVariant = avgBundleVariantPrice(cart);
    var currentTotal = computeBundlePricedTotal(cart) + mf;
    if (currentTotal >= FREE_SHIP) return 0;
    for (var n = 1; n <= 10; n++) {
      var simBundleQty = bundleQty + n;
      var simEffectiveUnit = clampToVariant(priceForQty(simBundleQty), avgVariant);
      var simTotal = simBundleQty * simEffectiveUnit + nonBundleSubtotal + mf;
      if (simTotal >= FREE_SHIP) return n;
    }
    return 10;
  }

  function getFlashSaleApi() {
    return window.__emFlashSale || null;
  }

  function getFlashSaleState() {
    var flashSale = getFlashSaleApi();
    if (!flashSale) return { active: false, remainingMs: 0 };
    return flashSale.getState();
  }

  function buildCartSaleUiState(context) {
    var flashSale = getFlashSaleApi();
    var saleState = getFlashSaleState();
    var itemCount = context.itemCount;
    var currentTotal = context.currentTotal;
    var shipping = context.shipping;
    var tier = context.tier;
    var saved = context.saved;
    var totalWithShipping = context.totalWithShipping;
    var itemsForFreeShipping = itemsNeededForFreeShipping(context.cart, context.memFee);
    var oneAwayFromFreeShipping = shipping > 0 && itemsForFreeShipping === 1;
    var activeSale = !!saleState.active;
    var countdown = activeSale && flashSale ? flashSale.formatCountdown(saleState.remainingMs) : '';
    var cardKicker = '';
    var cardHeadline = '';
    var cardBody = '';
    var stickyKicker = '';
    var stickyKickerColor = '#ffffff';
    var stickyKickerBg = '#000000';
    var stickyHeadline = '';
    var stickyHeadlineColor = '#1f2937';
    var stickySupport = '';
    var stickySupportColor = '#6b7280';
    var buttonText = '';

    // All rungs below come from getTier()/packTierQtys() — the config's ladder,
    // never literal quantities. next === maxPackQty() reads as "the best bundle".
    var __maxQty = maxPackQty();
    var __firstQty = cartRungQtys()[0];

    if (tier.current === 0) {
      cardKicker = 'PACK PRICING AVAILABLE';
      cardHeadline = __firstQty + ' for ' + bundleTotalForQty(__firstQty);
      cardBody = 'Reach ' + __firstQty + ' items to drop your price to ' + bundlePerItemForQty(__firstQty) + ' each.';
    } else if (tier.next) {
      cardKicker = 'YOUR ' + tier.current + '-PACK PRICE IS ACTIVE';
      cardHeadline = tier.current + ' for ' + bundleTotalForQty(tier.current);
      cardBody = 'Keep at least ' + tier.current + ' items in cart to hold this bundle price.';
    } else {
      cardKicker = 'BEST BUNDLE PRICE ACTIVE';
      cardHeadline = 'Best bundle unlocked';
      cardBody = 'Checkout while your selected sizes are still available.';
    }

    if (activeSale) {
      if (tier.current > 0 && !tier.next) {
        stickyKicker = 'BEST SALE PRICE LOCKED';
      } else if (tier.current > 0) {
        stickyKicker = tier.current + '-PACK LOCKED • ENDS IN ' + countdown;
      } else {
        // Message-aware kicker: msg 1 = FLASH SALE, msg 2 = BUY 5 FOR 1 + FREE SHIPPING.
        var __cartMsgId = (saleState && saleState.currentMessageId) || 1;
        if (__cartMsgId === 2) {
          var promoKicker = flashSale && flashSale.getPromoMessage ? flashSale.getPromoMessage('cart_sticky').compact : '';
      stickyKicker = promoKicker || ('FLASH SALE ENDS IN ' + countdown);
        }
      }

      if (oneAwayFromFreeShipping) {
        stickyHeadline = 'Add 1 more to get free shipping';
        stickySupportColor = '#3D9A8B';
        if (tier.next && tier.next < __maxQty) {
          stickySupport = 'That also moves you closer to ' + tier.next + ' for ' + bundleTotalForQty(tier.next) + '.';
        } else {
          stickySupport = 'That also moves you closer to the best bundle price.';
        }
      } else if (tier.current === 0) {
        stickyHeadline = 'Add ' + (tier.next - itemCount) + ' more to unlock ' + tier.next + ' for ' + bundleTotalForQty(tier.next);
        stickySupport = 'Reach ' + tier.next + ' items to drop your price to ' + bundlePerItemForQty(tier.next) + ' each today.';
      } else if (tier.next && tier.next < __maxQty) {
        stickyHeadline = (tier.next - itemCount) + ' more to ' + tier.next + ' for ' + bundleTotalForQty(tier.next);
        stickySupport = (tier.next - itemCount) === 1
          ? 'Add 1 more item to lock the ' + tier.next + '-pack before the timer ends.'
          : 'Keep your ' + tier.current + '-pack locked and push to the ' + tier.next + '-pack before the timer ends.';
      } else if (tier.next) {
        stickyHeadline = (tier.next - itemCount) + ' more to reach the best bundle';
        stickySupport = 'Best flash-sale price unlocks at ' + tier.next + ' items.';
      } else {
        stickyHeadline = 'Checkout before the timer ends';
        stickySupport = 'Your best flash-sale price is active now.';
      }

      if (!oneAwayFromFreeShipping && shipping > 0 && itemsForFreeShipping > 0) {
        stickySupport += (stickySupport ? ' ' : '') + 'Free shipping in ' + itemsForFreeShipping + ' more item' + (itemsForFreeShipping > 1 ? 's' : '') + '.';
      }

      if (tier.current > 0 && !tier.next) {
        buttonText = 'Checkout — Keep My Best Price';
      } else if (tier.current > 0) {
        buttonText = 'Checkout — Keep My ' + bundleTotalForQty(tier.current) + ' Pack';
      } else {
        buttonText = 'Checkout — Secure My Cart';
      }
    } else {
      stickyKickerColor = '#6f5a4d';
      stickyKickerBg = '#f3ede8';

      if (tier.current > 0 && !tier.next) {
        stickyKicker = 'BEST BUNDLE PRICE ACTIVE';
      } else if (tier.current > 0) {
        stickyKicker = tier.current + '-PACK PRICE ACTIVE';
      } else {
        stickyKicker = 'BUNDLE PRICING AVAILABLE';
      }

      if (oneAwayFromFreeShipping) {
        stickyHeadline = 'Add 1 more to get free shipping';
        stickySupportColor = '#3D9A8B';
        if (tier.next && tier.next < __maxQty) {
          stickySupport = 'That also moves you closer to ' + tier.next + ' for ' + bundleTotalForQty(tier.next) + '.';
        } else {
          stickySupport = 'That also moves you closer to the best bundle price.';
        }
      } else if (tier.current === 0) {
        stickyHeadline = 'Add ' + (tier.next - itemCount) + ' more to unlock ' + tier.next + ' for ' + bundleTotalForQty(tier.next);
      } else if (tier.next && tier.next < __maxQty) {
        stickyHeadline = 'Add ' + (tier.next - itemCount) + ' more for ' + tier.next + ' for ' + bundleTotalForQty(tier.next);
      } else if (tier.next) {
        stickyHeadline = 'Add ' + (tier.next - itemCount) + ' more to reach the best bundle price';
      } else {
        stickyHeadline = 'Best bundle price active';
      }

      if (!stickySupport) {
        if (shipping === 0) {
          stickySupport = 'Free shipping included.';
          stickySupportColor = '#3D9A8B';
        } else {
          stickySupport = formatWholeMoney(shipping) + ' shipping';
          if (itemsForFreeShipping > 0) {
            stickySupport += ' — add ' + itemsForFreeShipping + ' item' + (itemsForFreeShipping > 1 ? 's' : '') + ' to get it free';
          }
        }
      }

      buttonText = (saved > 0 ? 'Secure my sale price — ' : 'Secure my order — ') + formatWholeMoney(totalWithShipping);
    }

    return {
      cardKicker: cardKicker,
      cardHeadline: cardHeadline,
      cardBody: cardBody,
      stickyKicker: stickyKicker,
      stickyKickerColor: stickyKickerColor,
      stickyKickerBg: stickyKickerBg,
      stickyHeadline: stickyHeadline,
      stickyHeadlineColor: stickyHeadlineColor,
      stickySupport: stickySupport,
      stickySupportColor: stickySupportColor,
      buttonText: buttonText
    };
  }

  function applyCartSaleUi(state) {
    var cardKicker = document.getElementById('scv-sale-card-kicker');
    var cardHeadline = document.getElementById('scv-sale-card-headline');
    var cardBody = document.getElementById('scv-sale-card-body');
    var stickyKicker = document.getElementById('scv-sticky-kicker');
    var stickyHeadline = document.getElementById('scv-sticky-headline');
    var stickySupport = document.getElementById('scv-sticky-support');
    var stickyBtn = document.getElementById('scv-sticky-btn');

    // At full price (toggle OFF), hide nudges that quote a member price or claim a pack is "locked".
    var mcOff = !window.__mcMember;
    if (cardKicker) cardKicker.textContent = state.cardKicker;
    if (cardHeadline) cardHeadline.textContent = (mcOff && /\$/.test(state.cardHeadline || '')) ? '' : state.cardHeadline;
    if (cardBody) cardBody.textContent = state.cardBody;

    if (stickyKicker) {
      var __sk = mcOff ? '' : state.stickyKicker; // kicker is always a member/"LOCKED" claim
      stickyKicker.textContent = __sk;
      stickyKicker.style.color = state.stickyKickerColor;
      stickyKicker.style.background = state.stickyKickerBg;
      stickyKicker.style.display = __sk ? 'inline-flex' : 'none';
    }

    if (stickyHeadline) {
      var __sh = (mcOff && /\$/.test(state.stickyHeadline || '')) ? '' : state.stickyHeadline; // hide member-priced headline
      stickyHeadline.textContent = __sh;
      stickyHeadline.style.color = state.stickyHeadlineColor;
      stickyHeadline.style.display = __sh ? '' : 'none';
    }

    if (stickySupport) {
      stickySupport.textContent = state.stickySupport;
      stickySupport.style.color = state.stickySupportColor;
      stickySupport.style.display = state.stickySupport ? '' : 'none';
    }

    if (stickyBtn) stickyBtn.textContent = state.buttonText;
  }

  function bindCartSaleUi(context) {
    if (cartSaleUiTimer) {
      window.clearInterval(cartSaleUiTimer);
      cartSaleUiTimer = null;
    }

    function tick() {
      applyCartSaleUi(buildCartSaleUiState(context));
    }

    tick();
    cartSaleUiTimer = window.setInterval(tick, 1000);
  }

  function getGhostProducts(stageKey, tier, cartItems) {
    if (!cfg || !cfg.stages) return [];

    // Lifecycle: pregnant → postpartum → mum (forward).
    var stageOrderMap = {
      pregnant:   ['pregnant', 'postpartum', 'mum'],
      postpartum: ['postpartum', 'mum', 'pregnant'],
      mum:        ['mum', 'postpartum', 'pregnant']
    };
    var stageOrder = stageOrderMap[stageKey] || ['mum', 'postpartum', 'pregnant'];

    var cartQtyByHandle = {};
    cartItems.forEach(function(it) {
      if (it.handle) cartQtyByHandle[it.handle] = (cartQtyByHandle[it.handle] || 0) + it.quantity;
    });

    var seenHandles = {};
    var result = [];
    stageOrder.forEach(function(s) {
      var data = cfg.stages[s];
      if (!data || !data.products) return;
      data.products.forEach(function(prod) {
        if (!prod.handle) return;
        if (seenHandles[prod.handle]) return; // dedupe across stages
        if ((cartQtyByHandle[prod.handle] || 0) > 0) return; // exclude items already in cart
        seenHandles[prod.handle] = true;
        result.push({
          handle: prod.handle,
          name: prod.name,
          desc: prod.desc,
          tagline: prod.tagline || '',
          rrp: prod.rrp,
          image: prod.image,
          productId: prod.productId,
          qty: 1
        });
      });
    });
    return result;
  }

  function cleanTitle(t) {
    return (t || '').replace(/\s*[-\u2013]?\s*FINAL SALE.*/i, '').trim();
  }

  // ── UGC modal for product images ──
  var TN = cfg.stages.pregnant ? 'emamaco' : '';
  var CDN = 'https://' + TN + '.myshopishop.com';

  function openUgcForProduct(productId, size, productTitle) {
    // Fetch UGC tagged as pdp for this specific product
    var productKey = TN + ':' + productId;
    var params = 'tenantId=' + encodeURIComponent(TN) + '&pdp=true&limit=50&productKey=' + encodeURIComponent(productKey);

    fetch(CDN + '/api/ugc-gallery?' + params)
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (!d.ok || !d.items || !d.items.length) return;
        showUgcModal(d.items, productTitle);
      })
      .catch(function() {});
  }

  // Fetch UGC across all products in the set, filter by user's sizes, dedupe by item.id.
  var ugcSetCache = {};
  // Per-product UGC cache for the mini-circles inside the expanded set.
  var ugcMiniCache = {};
  function fetchUgcForProductMini(pid) {
    if (!pid) return Promise.resolve([]);
    var key = String(pid);
    if (ugcMiniCache[key]) return ugcMiniCache[key];
    var productKey = TN + ':' + key;
    var params = 'tenantId=' + encodeURIComponent(TN) + '&pdp=true&limit=50&productKey=' + encodeURIComponent(productKey);
    ugcMiniCache[key] = fetch(CDN + '/api/ugc-gallery?' + params)
      .then(function(r) { return r.json(); })
      .then(function(d) { return (d && d.ok && d.items) ? d.items : []; })
      .catch(function() { return []; });
    return ugcMiniCache[key];
  }
  function fetchUgcForSet(productIds, sizes) {
    var ids = (productIds || []).filter(Boolean).map(String);
    var uniqueIds = [];
    var seenId = {};
    ids.forEach(function(id) { if (!seenId[id]) { seenId[id] = 1; uniqueIds.push(id); } });
    var sizeList = (sizes || []).filter(Boolean).map(function(s){ return String(s).toUpperCase(); });
    var key = uniqueIds.join(',') + '|' + sizeList.join(',');
    if (ugcSetCache[key]) return Promise.resolve(ugcSetCache[key]);

    var fetches = uniqueIds.map(function(pid) {
      var productKey = TN + ':' + pid;
      var params = 'tenantId=' + encodeURIComponent(TN) + '&pdp=true&limit=50&productKey=' + encodeURIComponent(productKey);
      return fetch(CDN + '/api/ugc-gallery?' + params)
        .then(function(r) { return r.json(); })
        .then(function(d) { return (d && d.ok && d.items) ? d.items : []; })
        .catch(function() { return []; });
    });

    return Promise.all(fetches).then(function(arrays) {
      var seen = {};
      var combined = [];
      arrays.forEach(function(items) {
        items.forEach(function(it) {
          var id = it && it.id;
          if (!id || seen[id]) return;
          if (sizeList.length) {
            var b = (it.bottoms || '').split(',').map(function(s){return s.trim().toUpperCase();}).filter(Boolean);
            var t = (it.tops || '').split(',').map(function(s){return s.trim().toUpperCase();}).filter(Boolean);
            var pool = b.concat(t);
            var match = pool.some(function(s){ return sizeList.indexOf(s) >= 0; });
            if (!match) return;
          }
          seen[id] = 1;
          combined.push(it);
        });
      });
      ugcSetCache[key] = combined;
      return combined;
    });
  }

  var STAGE_LABELS_MAP = {t1:'in her 1st trimester',t2:'in her 2nd trimester',t3:'in her 3rd trimester',p:'post partum',k:'in the mum uniform'};

  function resolveUrl(u) {
    if (!u) return '';
    return u.startsWith('http') ? u : CDN + (u.startsWith('/') ? '' : '/') + u;
  }

  function getStageLabel(item) {
    if (item && item.trimester && STAGE_LABELS_MAP[item.trimester]) return STAGE_LABELS_MAP[item.trimester];
    if (item && item.stage === 'm') return 'pregnant';
    if (item && item.stage === 'p') return STAGE_LABELS_MAP.p;
    // 'k' = mum life — locale-aware: "living mum life" / "living mom life"
    if (item && item.stage === 'k') return 'living ' + MUM_LOWER + ' life';
    return '';
  }

  function getWearingSize(item) {
    var b = (item.bottoms || '').split(',').map(function(s){return s.trim();}).filter(Boolean);
    var t = (item.tops || '').split(',').map(function(s){return s.trim();}).filter(Boolean);
    var all = b.length ? b : t;
    return all.length ? all[0] : '';
  }

  function getProductDisplayName(item) {
    // Use product assignment titles, clean them
    if (item.products && item.products.length) {
      var name = item.products[0].title || '';
      return name.replace(/\s*[-\u2013]?\s*FINAL SALE.*/i, '').replace(/\bEmama\b\s*/gi, '').replace(/\s*\|.*/g, '').trim();
    }
    return '';
  }

  function cleanProductName(t) {
    return (t || '')
      .replace(/\s*[-–]?\s*FINAL SALE.*/i, '')
      .replace(/\bEmama\b\s*/gi, '')
      .replace(/\s*\|.*/g, '')
      .trim();
  }

  function showUgcModal(items, tappedProductTitle) {
    // Cart context for badge logic
    var cartItemsArr = (lastCartJson && lastCartJson.items) || [];
    var cartHandleSet = {};
    var modalItemCount = 0;
    cartItemsArr.forEach(function(it){
      if (it.handle) cartHandleSet[it.handle] = true;
      modalItemCount += it.quantity || 0;
    });
    var modalUserSizes = cartItemsArr.length ? getCartBaseSizes(cartItemsArr) : [];
    if (typeof window.__scvEmit === 'function') {
      window.__scvEmit('wardrobe_ugc_opened', {
        source_surface: 'wardrobe_ugc',
        product_title: tappedProductTitle || '',
        ugc_count: items.length,
        item_count: modalItemCount,
        sizes: modalUserSizes.join(',')
      });
    }
    // Predict per-item price after adding 1 more bundle item; clamp to current cart's avg variant ceiling.
    var modalAddPrice = Math.ceil(clampToVariant(priceForQty(modalItemCount + 1), avgBundleVariantPrice(lastCartJson)));

    // Sort: videos first, then randomise within each group
    var videos = [], images = [];
    items.forEach(function(it) {
      if (it.type === 'reel' || it.type === 'video') videos.push(it);
      else images.push(it);
    });
    // Shuffle each group
    function shuffle(arr) {
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = arr[i]; arr[i] = arr[j]; arr[j] = tmp;
      }
      return arr;
    }
    var sorted = shuffle(videos).concat(shuffle(images));

    var savedY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.overflow = 'hidden';

    var modal = document.createElement('div');
    modal.style.cssText = 'position:fixed;inset:0;z-index:99999;background:#000;';

    // Build slides
    var h = '';
    // Close + sound buttons
    h += '<button id="scv-ugc-close" style="position:fixed;top:12px;right:16px;z-index:100002;color:white;background:rgba(0,0,0,0.4);border:none;font-size:20px;cursor:pointer;width:36px;height:36px;border-radius:50%;display:flex;align-items:center;justify-content:center;">\u2715</button>';
    h += '<button id="scv-ugc-sound" style="position:fixed;top:60px;right:16px;z-index:100002;color:white;background:rgba(0,0,0,0.4);border:none;font-size:18px;cursor:pointer;width:36px;height:36px;border-radius:50%;display:flex;align-items:center;justify-content:center;">\uD83D\uDD07</button>';
    // Sticky "back to my cart" bar at bottom
    h += '<button id="scv-ugc-back" style="position:fixed;bottom:0;left:0;right:0;z-index:100002;padding:18px 20px calc(18px + env(safe-area-inset-bottom)) 20px;background:rgba(0,0,0,0.92);color:#fff;border:none;font-family:system-ui,-apple-system,sans-serif;font-size:13px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:10px;-webkit-backdrop-filter:blur(10px);backdrop-filter:blur(10px);">';
    h += '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width:16px;height:16px;"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>';
    h += '<span>back to my cart</span>';
    h += '</button>';

    // Swipe hint overlay
    h += '<div id="scv-swipe-hint" style="position:fixed;inset:0;z-index:100001;display:flex;align-items:center;justify-content:center;pointer-events:none;">';
    h += '<div style="text-align:center;color:white;text-shadow:0 2px 8px rgba(0,0,0,0.6);">';
    h += '<div style="font-size:28px;margin-bottom:4px;">\u2191</div>';
    h += '<div style="font-size:16px;font-weight:700;letter-spacing:0.1em;">SWIPE</div>';
    h += '</div></div>';

    // Vertical scroll container (TikTok style)
    h += '<div id="scv-ugc-feed" style="height:100%;overflow-y:scroll;scroll-snap-type:y mandatory;-webkit-overflow-scrolling:touch;">';

    sorted.forEach(function(it, idx) {
      var isV = it.type === 'reel' || it.type === 'video';
      var url = resolveUrl(it.url);
      var poster = resolveUrl(it.posterUrl);
      var stageLabel = getStageLabel(it);
      var wearSize = getWearingSize(it);
      var productName = getProductDisplayName(it);
      var handle = it.handle || '';

      h += '<div class="scv-ugc-slide" style="height:100%;width:100%;scroll-snap-align:start;position:relative;background:#000;">';

      // Media
      if (isV) {
        h += '<video class="scv-ugc-video" src="' + url + '" poster="' + poster + '" playsinline loop muted preload="metadata" style="width:100%;height:100%;object-fit:cover;display:block;"></video>';
      } else {
        h += '<img src="' + url + '" style="width:100%;height:100%;object-fit:cover;display:block;" loading="' + (idx < 2 ? 'eager' : 'lazy') + '">';
      }

      // Bottom-left overlay text (TikTok style) — bottom anchored above sticky, scrolls if too tall
      h += '<div class="scv-ugc-overlay" style="position:absolute;bottom:90px;left:16px;right:60px;z-index:10;color:white;text-shadow:0 2px 6px rgba(0,0,0,0.8);font-family:system-ui,-apple-system,sans-serif;max-height:calc(100% - 180px);overflow-y:auto;-webkit-overflow-scrolling:touch;padding-right:6px;">';
      if (handle) h += '<div style="font-size:20px;font-weight:700;">@' + handle + '</div>';
      if (stageLabel) h += '<div style="font-size:16px;margin-top:4px;">' + stageLabel + '</div>';
      if (wearSize) h += '<div style="font-size:16px;margin-top:3px;">wearing size ' + wearSize + '</div>';

      // Per-product list with badges (in your set / add to set $X / sold out)
      var prodList = (it.products && it.products.length) ? it.products : [];
      if (prodList.length) {
        var seenLine = {};
        h += '<div class="scv-ugc-prodlist">';
        h += '<div class="scv-ugc-prodlist-heading">she’s wearing:</div>';
        prodList.forEach(function(prod) {
          if (!prod || !prod.handle || seenLine[prod.handle]) return;
          seenLine[prod.handle] = true;
          var pName = cleanProductName(prod.title || prod.handle);
          var pNameAttr = pName.replace(/"/g, '&quot;');
          var inSet = !!cartHandleSet[prod.handle];
          h += '<div class="scv-ugc-prodlist-row">';
          h += '<span class="scv-ugc-prodname">' + pName + '</span>';
          if (inSet) {
            h += '<span class="scv-ugc-badge scv-ugc-inset">in your set</span>';
          } else {
            h += '<span class="scv-ugc-badge scv-ugc-resolving" data-add-handle="' + prod.handle + '" data-add-name="' + pNameAttr + '">resolving…</span>';
          }
          h += '</div>';
        });
        h += '</div>';
      } else {
        var displayProduct = tappedProductTitle || productName;
        if (displayProduct) h += '<div style="font-size:16px;margin-top:3px;">' + displayProduct + '</div>';
      }
      h += '</div>';

      h += '</div>';
    });

    h += '</div>';
    modal.innerHTML = h;
    document.body.appendChild(modal);

    // Close
    function closeModal() {
      if (typeof window.__scvEmit === 'function') {
        window.__scvEmit('wardrobe_ugc_closed', {
          source_surface: 'wardrobe_ugc',
          product_title: tappedProductTitle || '',
          ugc_count: items.length,
          item_count: modalItemCount,
          sizes: modalUserSizes.join(',')
        });
      }
      modal.remove();
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      window.scrollTo(0, savedY);
    }
    modal.querySelector('#scv-ugc-close').addEventListener('click', closeModal);
    var backBtn = modal.querySelector('#scv-ugc-back');
    if (backBtn) backBtn.addEventListener('click', closeModal);

    // Hydrate "add to set" badges — resolve variant in user's size, set price + click handler
    (function hydrateAddBadges() {
      var pending = Array.prototype.slice.call(modal.querySelectorAll('.scv-ugc-resolving[data-add-handle]'));
      if (!pending.length) return;
      var uniqueHandles = {};
      pending.forEach(function(el){ uniqueHandles[el.getAttribute('data-add-handle')] = el.getAttribute('data-add-name') || el.getAttribute('data-add-handle'); });
      var products = Object.keys(uniqueHandles).map(function(h){ return { handle: h, name: uniqueHandles[h], qty: 1 }; });

      function markAsInSet(targetHandle) {
        // Update every badge in the modal that targets this handle (across all slides + the
        // current set-built items rendered behind us)
        modal.querySelectorAll('.scv-ugc-badge[data-add-handle="' + targetHandle + '"]').forEach(function(other) {
          other.classList.remove('scv-ugc-add', 'scv-ugc-resolving', 'scv-ugc-soldout');
          other.classList.add('scv-ugc-inset');
          other.textContent = 'in your set';
          other.style.cursor = 'default';
          other.__inset = true;
        });
        cartHandleSet[targetHandle] = true;
      }

      function applyResolution(byHandle) {
        pending.forEach(function(el) {
          var h = el.getAttribute('data-add-handle');
          var r = byHandle[h];
          if (r && r.variantId) {
            el.classList.remove('scv-ugc-resolving');
            el.classList.add('scv-ugc-add');
            el.setAttribute('data-variant-id', r.variantId);
            el.setAttribute('data-preorder', (r.preorderNote || '').replace(/"/g, '&quot;'));
            el.textContent = 'add to set ' + S + modalAddPrice;
            el.addEventListener('click', function(ev) {
              ev.preventDefault();
              ev.stopPropagation();
              if (el.__busy || el.__inset) return;
              el.__busy = true;
              var prevText = el.textContent;
              el.textContent = 'adding…';
              addItems([{ id: r.variantId, quantity: 1, properties: r.preorderNote ? { Ships: r.preorderNote } : {} }], function() {
                el.__busy = false;
                markAsInSet(h);
                // Refresh cart UI behind the modal silently — modal stays mounted on document.body
                loadAndRender();
              });
              setTimeout(function(){
                if (el.__busy) { el.__busy = false; el.textContent = prevText; }
              }, 4000);
            });
          } else {
            el.classList.remove('scv-ugc-resolving');
            el.classList.add('scv-ugc-soldout');
            el.textContent = 'sold out';
          }
        });
      }

      function fallbackPerHandle() {
        var byHandle = {};
        var sizeUpper = modalUserSizes.map(function(s){ return String(s).toUpperCase(); });
        Promise.all(products.map(function(p){
          return fetch('/products/' + p.handle + '.js').then(function(r){ return r.json(); }).then(function(d){
            var v = (d.variants || []).find(function(v){
              var t = (v.title || '').toUpperCase();
              return v.available && (sizeUpper.length ? sizeUpper.indexOf(t) >= 0 : true);
            });
            if (v) byHandle[p.handle] = { variantId: v.id, handle: p.handle };
          }).catch(function(){});
        })).then(function(){ applyResolution(byHandle); });
      }

      if (window.EmmacoProductResolver && modalUserSizes.length) {
        window.EmmacoProductResolver.resolveSet(products, {
          sizes: modalUserSizes,
          sizeUpForPostPartum: true,
          sizeUpAmount: 1
        }).then(function(resolved) {
          var byHandle = {};
          // Suggestions sell what SHIPS NOW: resolver results that are only
          // purchasable via continue-selling at 0 stock (source 'preorder' /
          // 'oversell') are dropped — pre-order stays a deliberate PDP choice,
          // never something a suggestion slips into the bag (29 Jul).
          (resolved || []).forEach(function(r){
            if (!r || r.source !== 'stock') return;
            // source 'stock' still admits config-less continue-selling; the
            // catalog truth closes that: sellable qty must not be zero.
            if (typeof window.__scvSkuInStock === 'function' && window.__scvSkuInStock(r.sku) === false) return;
            var key = r.originalHandle || r.handle;
            byHandle[key] = r;
          });
          applyResolution(byHandle);
        }).catch(fallbackPerHandle);
      } else {
        fallbackPerHandle();
      }
    })();

    // Sound toggle
    var soundOn = false;
    var soundBtn = modal.querySelector('#scv-ugc-sound');
    soundBtn.addEventListener('click', function() {
      soundOn = !soundOn;
      soundBtn.innerHTML = soundOn ? '\uD83D\uDD0A' : '\uD83D\uDD07';
      modal.querySelectorAll('.scv-ugc-video').forEach(function(v) { v.muted = !soundOn; });
    });

    // Swipe hint: hide after 3s or on touch
    var hint = modal.querySelector('#scv-swipe-hint');
    var hintTimer = setTimeout(function() { if (hint) hint.style.display = 'none'; }, 3000);
    modal.addEventListener('touchstart', function() {
      if (hint) hint.style.display = 'none';
      clearTimeout(hintTimer);
    }, { once: true });
    modal.addEventListener('mousedown', function() {
      if (hint) hint.style.display = 'none';
      clearTimeout(hintTimer);
    }, { once: true });

    // Video autoplay: play visible slide, pause others
    var feed = modal.querySelector('#scv-ugc-feed');
    if (feed && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var vid = entry.target.querySelector('.scv-ugc-video');
          if (!vid) return;
          if (entry.isIntersecting) {
            try { vid.play(); } catch(e) {}
          } else {
            try { vid.pause(); } catch(e) {}
          }
        });
      }, { root: feed, threshold: 0.5 });
      feed.querySelectorAll('.scv-ugc-slide').forEach(function(slide) { obs.observe(slide); });
    }
  }

  // ── Cart operations ──

  // Per-line FIFO with target coalescing.  Rapid clicks update slot.target;
  // one /cart/change.js in flight per key at a time, latest-target wins.
  // Optimistic lines (fake keys `__optimistic:VID:TS`) are sent as variant_id
  // since the server doesn't know the fake key.
  var __scvChangeQ = {};
  function __scvReqIdForKey(key) {
    // Translate optimistic keys to variant_id; Shopify accepts variant_id as
    // the "id" parameter and changes the matching cart line.
    if (typeof key === 'string' && key.indexOf('__optimistic:') === 0) {
      var parts = key.split(':');
      if (parts[1]) return parts[1];
    }
    return key;
  }
  function __scvFlush(key, callback) {
    var slot = __scvChangeQ[key];
    if (!slot || slot.inFlight) return;
    slot.inFlight = true;
    var sent = slot.target;
    var reqId = __scvReqIdForKey(key);
    var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/change.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function() {
        slot.inFlight = false;
        if (xhr.status >= 200 && xhr.status < 300) {
          if (typeof window.__scvBustCartCache === 'function') window.__scvBustCartCache();
          window.dispatchEvent(new CustomEvent('em:cart:changed'));
          
          var cart;
          try { cart = JSON.parse(xhr.responseText); } catch(e) {}
          if (__scvChangeQ[key] && __scvChangeQ[key].target !== sent) {
            __scvFlush(key, callback);
          } else {
            var cb = slot.callback;
            delete __scvChangeQ[key];
            if (Object.keys(__scvChangeQ).length === 0) {
              if (cb) cb(cart);
              else loadAndRender();
            }
          }
                } else {
          console.warn('[scv change.js]', xhr.status, 'id=', reqId, 'qty=', sent, 'resp=', xhr.responseText.slice(0, 300));
          var fallback = false;
          if (xhr.status === 400 && xhr.responseText.indexOf('no valid id') !== -1 && typeof reqId === 'string' && reqId.indexOf(':') !== -1) {
            var vid = reqId.split(':')[0];
            console.log('[scv change.js] Stale key fallback. Retrying with vid=', vid);
            var retryXhr = new XMLHttpRequest();
            retryXhr.open('POST', '/cart/change.js', true);
            retryXhr.setRequestHeader('Content-Type', 'application/json');
            retryXhr.setRequestHeader('Accept', 'application/json');
            retryXhr.onload = function() {
              if (retryXhr.status >= 200 && retryXhr.status < 300) {
                if (typeof window.__scvBustCartCache === 'function') window.__scvBustCartCache();
                window.dispatchEvent(new CustomEvent('em:cart:changed'));
              }
              delete __scvChangeQ[key];
              if (Object.keys(__scvChangeQ).length === 0) loadAndRender();
            };
            retryXhr.onerror = function() {
              delete __scvChangeQ[key];
              if (Object.keys(__scvChangeQ).length === 0) loadAndRender();
            };
            retryXhr.send(JSON.stringify({ id: vid, quantity: sent }));
            fallback = true;
          }
          if (!fallback) {
            delete __scvChangeQ[key];
            if (Object.keys(__scvChangeQ).length === 0) loadAndRender();
          }
        }
      };
      xhr.onerror = function() {
        slot.inFlight = false;
        delete __scvChangeQ[key];
        if (Object.keys(__scvChangeQ).length === 0) loadAndRender();
      };
      xhr.send(JSON.stringify({ id: reqId, quantity: sent }));
  }
  function changeQty(key, newQty, callback) {
    newQty = Math.max(0, newQty);
    if (typeof window.__scvOptimisticBumpQty === 'function') {
      window.__scvOptimisticBumpQty(key, newQty);
    }
    if (!__scvChangeQ[key]) __scvChangeQ[key] = { target: newQty, inFlight: false, callback: callback || null };
    else { __scvChangeQ[key].target = newQty; if (callback) __scvChangeQ[key].callback = callback; }
    __scvFlush(key, callback);
  }
  // Expose for the +qty pip handler (lives in a separate IIFE earlier).
  window.__scvChangeQty = changeQty;

  function addItems(items, callback) {
    if (!items || !items.length) { if(callback) callback(); else loadAndRender(); return; }
      var xhr = new XMLHttpRequest();
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.onload = function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          if (typeof window.__scvBustCartCache === 'function') window.__scvBustCartCache();
          window.dispatchEvent(new CustomEvent('em:cart:changed'));
        }
        if (callback) callback(); else loadAndRender();
      };
      xhr.onerror = function() { loadAndRender(); };
      xhr.send(JSON.stringify({ items: items }));
  }

  // ── Render ──


  // Her gift card's live balance arrived (cm-ad-card.js), or a card went on: redraw what is open.
  window.addEventListener('cm:card-checked', function () { if (lastCartJson) { try { render(lastCartJson); } catch (e) {} } });
  // The pack reward's script loaded after the cart was drawn: draw it again with the reward line.
  window.addEventListener('cm:pack-reward-ready', function () { if (lastCartJson) { try { render(lastCartJson); } catch (e) {} } });
  window.addEventListener('emamaco:gift-card-on', function () { if (lastCartJson) { try { fetchCart().then(function (c) { render(c); }).catch(function () {}); } catch (e) {} } });
  function render(cart) {
    lastCartJson = cart;
    // The product page shows her gift card against this cart (emamaco-packprice.liquid listens): tell it what the cart is now.
    try { window.dispatchEvent(new CustomEvent('cm:cart', { detail: cart })); } catch (e) {}
    // Toggle state is DERIVED each render: active member, or a non-member who hasn't opted out this
    // session → ON (default). The membership line is auto-reconciled into the cart to match.
    window.__mcMember = mcIsActiveMember() || !mcOptedOff();
    // Hide the Mum Club membership line from all cart UI + totals. It stays in the real
    // Shopify cart (for checkout / billing / the discount gate); its visual + total
    // treatment is handled separately, later, inside the toggle row.
    var mcMembershipCents = 0;
    if (cart && cart.items && cart.items.some(mcIsMembershipLine)) {
      var __mcQty = 0, __mcKept = [];
      cart.items.forEach(function(it){
        if (mcIsMembershipLine(it)) { __mcQty += it.quantity; mcMembershipCents += (it.line_price || it.final_line_price || it.original_line_price || 0); }
        else __mcKept.push(it);
      });
      cart = Object.assign({}, cart, { items: __mcKept, item_count: Math.max(0, (cart.item_count || 0) - __mcQty), total_price: Math.max(0, (cart.total_price || 0) - mcMembershipCents) });
    }

    if (!cart.items || !cart.items.length) {
      if (typeof window.__scvEmit === 'function') {
        window.__scvEmit('wardrobe_cart_rendered', { journey_family: 'wardrobe', cart_state: 'empty' }, { cart_value: 0, cart_units: 0 });
      }
      if (cartSaleUiTimer) {
        window.clearInterval(cartSaleUiTimer);
        cartSaleUiTimer = null;
      }
      // Empty cart — show the 4 journey accordions with "see the X range"
      var __emptyMw = IS_MOM ? 'MOM' : 'MUM';
      var __emptyMwLower = IS_MOM ? 'mom' : 'mum';
      var __emptyStageColor = {
        'pregnancy':           'pregnancy',
        'postpartum-recovery': 'recovery',
        'breastfeeding':       'breastfeeding',
        'mum-uniform':         'mum-uniform'
      };
      var __emptyLabel = {
        'pregnancy':           'MY PREGNANCY JOURNEY',
        'postpartum-recovery': 'MY POST PARTUM RECOVERY',
        'breastfeeding':       'MY BREASTFEEDING ADVENTURE',
        'mum-uniform':         'MY ' + __emptyMw + ' UNIFORM'
      };
      var __emptyRange = {
        'pregnancy':           'maternity',
        'postpartum-recovery': 'postpartum',
        'breastfeeding':       'breastfeeding',
        'mum-uniform':         __emptyMwLower + '-uniform'
      };
      var __emptySvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>';
      // Breastfeeding label is cart-state-aware (this branch = truly empty
      // cart so we get the "mums start with this..." variant).
      var __emptyMumsPlural = IS_MOM ? 'moms' : 'mums';
      var __emptyHtml = '';
      ['pregnancy', 'postpartum-recovery', 'breastfeeding', 'mum-uniform'].forEach(function(__sg) {
        var __pair = __JOURNEY_PAIRS[__sg];
        var __seed = (__pair && __pair.seedDefault) || '';
        var __label;
        if (__sg === 'breastfeeding') __label = __emptyMumsPlural + ' start with this breastfeeding crop';
        else if (__sg === 'pregnancy') __label = 'most ' + __emptyMumsPlural + ' start with these maternity leggings';
        else if (__sg === 'mum-uniform') __label = 'these leggings are for everyday ' + __emptyMwLower + ' life (they hide ' + __emptyMwLower + ' pouch)';
        else __label = 'see the ' + __emptyRange[__sg] + ' range';
        var __lblCls = 'scv-journey-aug-label' + (__label.length > 36 ? ' scv-journey-aug-label--long' : '');
        __emptyHtml += '<div class="scv-subgroup-acc scv-subgroup-acc-empty" data-stage-color="' + __emptyStageColor[__sg] + '">'
          + '<div class="scv-subgroup-empty-row">'
          + '<span class="scv-subgroup-eyebrow">' + __emptyLabel[__sg] + '</span>'
          + '</div>'
          + '<button type="button" class="scv-journey-aug-row" data-journey-aug="see-range" data-journey="' + __sg + '" data-seed-handle="' + __seed + '">'
          +   '<span class="scv-journey-aug-circle">' + __emptySvg + '</span>'
          +   '<span class="' + __lblCls + '">' + __label + '</span>'
          + '</button>'
          + '</div>';
      });
      inner.innerHTML = __emptyHtml;
      window.__scvRenderedOk = true;
      clearTimeout(window.__scvFallbackTimer);
      var emptySticky = document.getElementById('scv-sticky-checkout');
      if (emptySticky) emptySticky.style.display = 'none';
      return;
    }

    var stage = userStageOverride || inferLifestage(cart.items);
    var stageData = cfg.stages[stage];
    if (!stageData) return;

    var userSize = getCartSize(cart.items);
    var userBaseSizes = getCartBaseSizes(cart.items);
    var itemCount = 0;
    cart.items.forEach(function(it) { itemCount += it.quantity; });
    var cartTotalRaw = cart.total_price / 100;
    var currentTotal = computeBundlePricedTotal(cart);
    // Free-ship threshold check: against the BUNDLE-DISCOUNTED total PLUS the membership fee — the
    // membership line is in the cart at checkout and counts toward Shopify's free-ship rule.
    var mcMemFee = mcMembershipCents / 100;
    var freeShipBase = currentTotal + mcMemFee;
    var shipping = freeShipBase >= FREE_SHIP ? 0 : STANDARD_SHIPPING;
    // Member free shipping (merchant toggle): on + member view → free regardless of threshold.
    var mcMemberFreeShip = (window.__mcMemberFreeShipping === true) && !!window.__mcMember;
    if (mcMemberFreeShip) shipping = 0;
    var tier = getTier(itemCount);
    var perItem = Math.ceil(clampToVariant(priceForQty(itemCount), avgBundleVariantPrice(cart)));
    var totalWithShipping = Math.ceil(currentTotal + mcMemFee + shipping); // grand total includes the membership fee

    // RRP savings
    var fullRrp = 0;
    cart.items.forEach(function(it) { fullRrp += (it.original_price * it.quantity) / 100; });
    var saved = Math.ceil(fullRrp - currentTotal);
    var pct = fullRrp > 0 ? Math.round((saved / fullRrp) * 100) : 0;
    var tierHoldNote = '';
    if (tier.current > 0) {
      tierHoldNote = 'Your ' + tier.current + '-item pack price stays active while you keep at least ' + tier.current + ' items in cart.';
    }
    var saleUiContext = {
      itemCount: itemCount,
      currentTotal: currentTotal,
      memFee: mcMemFee,
      cartTotalRaw: cartTotalRaw,
      cart: cart,
      shipping: shipping,
      tier: tier,
      saved: saved,
      totalWithShipping: totalWithShipping
    };
    var saleUi = buildCartSaleUiState(saleUiContext);

    // Discount codes
    var discounts = cart.cart_level_discount_applications || [];

    var h = '';

    // Bundle-set tier (computed early so the title can switch based on it)
    var bundleQty = 0;
    cart.items.forEach(function(it) { if (isBundleEligible(it)) bundleQty += it.quantity; });
    publishBundleQty(cart);   // no-ops when unchanged
    var BUNDLE_TIERS = cartRungQtys();
    var boxedCount = 0;
    for (var btiEarly = BUNDLE_TIERS.length - 1; btiEarly >= 0; btiEarly--) {
      if (bundleQty >= BUNDLE_TIERS[btiEarly]) { boxedCount = BUNDLE_TIERS[btiEarly]; break; }
    }
    // "Forming set" — bundle-eligible items in the cart, not yet at the first rung
    var isFormingSet = (boxedCount === 0 && bundleQty > 0 && bundleQty < BUNDLE_TIERS[0]);
    var __scvCtxNow = (typeof window.__scvCtx === 'function')
      ? window.__scvCtx(stage, tier, itemCount, bundleQty, boxedCount, currentTotal, cart)
      : null;
    if (__scvCtxNow && typeof window.__scvEmit === 'function') {
      window.__scvEmit('wardrobe_cart_rendered', __scvCtxNow, { cart_value: currentTotal, cart_units: itemCount });
      var __progressKey = stage + ':' + itemCount + ':' + (__scvCtxNow.next_tier || '');
      if (__scvCtxNow.next_tier && !window.__scvTierSeen[__progressKey]) {
        window.__scvTierSeen[__progressKey] = true;
        window.__scvEmit('wardrobe_tier_progress_seen', __scvCtxNow, { cart_value: currentTotal, cart_units: itemCount });
      }
      var __completeKey = stage + ':' + boxedCount + ':' + itemCount;
      if (boxedCount && !window.__scvTierCompleteSeen[__completeKey]) {
        window.__scvTierCompleteSeen[__completeKey] = true;
        window.__scvEmit('wardrobe_set_completed', Object.assign({}, __scvCtxNow, { completed_tier: String(boxedCount) }), { cart_value: currentTotal, cart_units: itemCount });
      }
    }

    // ── Title ──
    var bagStage = { pregnant: 'PREGNANCY', postpartum: 'POST-PARTUM', mum: MUM_UPPER };
    var setStageLabel = { pregnant: 'MATERNITY', postpartum: 'POST-PARTUM', mum: MUM_UPPER };
    var SYS_FONT = "system-ui,-apple-system,'Segoe UI',Roboto,sans-serif";
    var titleText = boxedCount > 0
      ? 'MY ' + boxedCount + ' ITEM ' + (setStageLabel[stage] || MUM_UPPER) + ' SET'
      : 'MY ' + (bagStage[stage] || MUM_UPPER) + ' BAG';
    h += '<div class="scv-bag-title" style="font-family:' + SYS_FONT + ';">' + titleText + '</div>';

    // Dynamic header lines (system font, normal text, centered)
    var headerLines = [];
    // Free-shipping threshold checks Shopify's cart subtotal (cartTotalRaw), NOT the bundle-discounted total.
    // Reason: Shopify's free-shipping rules evaluate cart.total_price at checkout, before the discount function applies.
    var awayFromFreeShip = Math.max(0, FREE_SHIP - freeShipBase);
    var itemsToFreeShip = itemsNeededForFreeShipping(cart, mcMemFee);
    if (EM_FREESHIP_UI_ENABLED) {
      if (awayFromFreeShip > 0) {
        headerLines.push('Add ' + itemsToFreeShip + ' more item' + (itemsToFreeShip === 1 ? '' : 's') + ' → free shipping');
      } else if (cartTotalRaw > 0) {
        headerLines.push('you got FREE shipping');
      }
    }
    var fsApi = window.__emFlashSale || null;
    var saleStateNow = fsApi ? fsApi.getState() : { active: false, remainingMs: 0 };
    // (Flash-sale countdown line removed from this header strip — redundant with the cart's own copy.)
    // Cart-state-aware progress message. Strategy:
    function __formingProgressMsg(freeShipDone) {
      // Bucket bundle-eligible items by universal journey key.
      var j = { 'pregnancy': 0, 'postpartum-recovery': 0, 'breastfeeding': 0, 'mum-uniform': 0 };
      cart.items.forEach(function(it) {
        if (!isBundleEligible(it)) return;
        var k = __journeyOf(it);
        if (j.hasOwnProperty(k)) j[k] += it.quantity;
      });
      var present = Object.keys(j).filter(function(k){ return j[k] > 0; });
      var n = bundleQty;
      var __setClaim = 'set pricing';
      if (n === 1) {
        var only = present[0];
        if (only === 'pregnancy')           return 'most pregnant ' + MUM_PLURAL + ' add a 2nd pair to rotate as the bump grows';
        if (only === 'postpartum-recovery') return 'most ' + MUM_PLURAL + ' get 2 post partum pieces — one in wash, one wearing';
        if (only === 'breastfeeding')       return 'most ' + MUM_PLURAL + ' add a 2nd nursing top — feeding days = lots of changes';
        if (only === 'mum-uniform')         return 'most ' + MUM_PLURAL + ' wear these on rotation and add a 2nd';
      }
      if (n === 2) {
        if (present.length === 1) {
          var only2 = present[0];
          if (only2 === 'pregnancy')           return 'your bump’s sorted. most pregnant ' + MUM_PLURAL + ' also start their hospital kit early';
          if (only2 === 'postpartum-recovery') return 'recovery covered. most ' + MUM_PLURAL + ' pair this with a nursing top for feeding days';
          if (only2 === 'breastfeeding')       return 'feeding’s covered. most ' + MUM_PLURAL + ' add recovery pieces for the same weeks';
          if (only2 === 'mum-uniform')         return 'daily uniform sorted. most ' + MUM_PLURAL + ' also keep a body-shapewear piece for dress days';
        }
        // Mixed two-stage combinations
        if (j['mum-uniform'] > 0)                                       return 'nice mix across stages — ' + (BUNDLE_TIERS[0] - n) + ' more to unlock ' + __setClaim;
        if (j.pregnancy > 0 && j['postpartum-recovery'] > 0)            return 'hospital kit forming — most ' + MUM_PLURAL + ' add a nursing crop to feed in';
        if (j.pregnancy > 0 && j.breastfeeding > 0)                     return 'add recovery shorts and you’re hospital-bag ready';
        if (j['postpartum-recovery'] > 0 && j.breastfeeding > 0)        return 'postpartum kit shaping up. one more piece locks the rotation';
      }
      var __need = BUNDLE_TIERS[0] - n;
      if (__need === 2) {
        if (present.length === 1) return '2 more = set pricing. most ' + MUM_PLURAL + ' add a piece from another stage for variety';
        return freeShipDone ? '2 more unlocks ' + __setClaim : '2 more unlocks ' + __setClaim + ' + free shipping';
      }
      if (__need === 1) {
        if (present.length === 1) return '1 more from another stage = set pricing' + (freeShipDone ? '' : ' + free shipping') + '. most ' + MUM_PLURAL + ' round it out';
        return freeShipDone ? 'add 1 more to unlock ' + __setClaim : 'add 1 more item to get free shipping';
      }
      if (__need > 2 && n > 2) {
        return __need + ' more unlocks ' + __setClaim + (freeShipDone ? '' : ' + free shipping');
      }
      return '';
    }
    var progressMsg = '';
    if (bundleQty > 0 && bundleQty < BUNDLE_TIERS[0]) {
      // ("You've built the perfect set ✔" celebration removed — redundant with the cart's own copy.)
      // The totals' nudge says it with the prices; the softer line only stays while it also has shipping to tell.
      progressMsg = (shipping === 0 && scvNoDiscountNudge(cart)) ? '' : __formingProgressMsg(shipping === 0);
    }
    if (progressMsg) headerLines.push(progressMsg);
    // Header lines (sale countdown + progress / celebration) are emitted
    // directly above the checkout button — see the headerLinesHtml emission
    // just before "Primary checkout button". Title gets a small spacer below.
    var headerLinesHtml = '';
    if (headerLines.length) {
      // Top padding gives the 3-day-sale line breathing room from whatever's
      // above; bottom padding stays near zero so the progress message sits
      // tight against the checkout button below.
      headerLinesHtml = '<div style="font-family:' + SYS_FONT + ';font-size:13px;font-weight:400;color:#6b7280;text-align:center;padding:14px 0 0 0;line-height:1.5;">';
      headerLines.forEach(function(line) {
        headerLinesHtml += '<div>' + line + '</div>';
      });
      headerLinesHtml += '</div>';
    }
    h += '<div style="padding-bottom:16px;"></div>';

    // ── Set-progress visual: one circle per item up to the first cart rung ──
    var __ringN = BUNDLE_TIERS[0];
    var __pgSlots = [];
    cart.items.forEach(function(it) {
      if (__pgSlots.length >= __ringN) return;
      var __img = it.image || '';
      for (var __i = 0; __i < it.quantity && __pgSlots.length < __ringN; __i++) {
        __pgSlots.push(__img);
      }
    });
    // Unlock prompt above the progress circles — only visible while the set
    // is forming (1-4 bundle-eligible items). Tells the user exactly how many
    // more items they need to unlock set pricing.
    // Entry-pack upsell: while the cart has fewer than the first pack tier (X)
    // bundle items, show a prominent invite. X = lowest min_qty > 1 in the json;
    // Y = X × that tier's per-item price (the total to buy any X items).
    if (bundleConfig && bundleConfig.tiers && bundleConfig.tiers.length) {
      var __sortedTiers = bundleConfig.tiers.slice().sort(function(a, b){ return a.min_qty - b.min_qty; });
      var __X = 0;
      for (var __ti = 0; __ti < __sortedTiers.length; __ti++) { if (__sortedTiers[__ti].min_qty > 1) { __X = __sortedTiers[__ti].min_qty; break; } }
      if (__X > 0 && bundleQty < __X && window.__mcMember) { // member-priced → only when toggle ON
        var __Y = Math.ceil(priceForQty(__X) * __X);
        h += '<div class="scv-set-unlock-prompt" style="font-size:17px;font-weight:800;line-height:1.3;">Buy ANY ' + __X + ' items for ' + S + __Y + '</div>';
      }
    }
    h += '<div class="scv-progress-row' + (itemCount >= __ringN ? ' complete' : '') + '">';
    for (var __pi = 0; __pi < __ringN; __pi++) {
      if (__pi > 0) h += '<span class="scv-pg-bar"></span>';
      if (__pi < __pgSlots.length && __pgSlots[__pi]) {
        h += '<span class="scv-pg-slot scv-pg-filled"><img src="' + __pgSlots[__pi] + '" alt=""></span>';
      } else {
        h += '<span class="scv-pg-slot scv-pg-empty"></span>';
      }
    }
    h += '</div>';

    // ── Sale line up top ──
    // The price table that sat under it is gone (Mark, 2026-10-14: "in the slideout cart remove the pricing table up
    // top"), and with it its "free shipping on orders over $X" footer: the totals and the line above Checkout already
    // say what shipping costs her. The sale line stays, on carts priced from pack tiers as before; it ticks off the
    // 3-day rotation timer (data-em-fs-countdown is auto-updated by flash-sale-state).
    var __hasPackTiers = !!(bundleConfig && bundleConfig.tiers && bundleConfig.tiers.some(function(t) {
      var q = Number(t.min_qty), p = Number(t.price);
      return q > 1 && p > 0 && p < 900;
    }));
    var __fsL = window.__emFlashSale || null;
    var __fsLState = __fsL ? __fsL.getState() : null;
    if (__hasPackTiers && __fsLState && __fsLState.active) {
      // The top banner's message, from flash-sale-state: its promo engine re-renders
      // the [data-em-promo] span every tick, so the words can never drift from it.
      var __fsLead = (__fsL.getPromoMessage && __fsL.ladderTiers && __fsL.ladderTiers().length)
        ? __fsL.getPromoMessage('cart').bannerLead : 'sale ends in ';
      h += '<div class="scv-sale-line" style="margin:4px 0 14px;font-family:system-ui,-apple-system,sans-serif;font-size:11px;font-weight:800;letter-spacing:0.06em;text-transform:uppercase;color:#b5504a;"><span data-em-promo="bannerLead" data-em-promo-context="cart">' + String(__fsLead).replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</span><span data-em-fs-countdown>' + __fsL.formatCountdown(__fsLState.remainingMs) + '</span></div>';
    }

    // ── Real cart items ──
    // bundleQty + boxedCount were computed earlier so the title can react.
    // No set box (Mark, 2026-10-12: "stop the cart collapsing into the set view its not needed"): a cart that has made
    // a pack lists its pieces one by one, exactly as a cart that has not made one yet does. boxedCount still drives the
    // title and the set-completed event above; from here on only the one-by-one view is drawn.
    isFormingSet = bundleQty > 0;
    var setLabelMap = { pregnant: 'Maternity', postpartum: 'Postpartum', mum: MUM_TITLE };

    // Split lines into (a) box-eligible segments (bundle items, up to boxedCount) and
    // (b) outside segments (everything else — bundle overflow, non-bundle, non-eligible)
    var boxedSegments = [];
    var outsideSegments = [];
    cart.items.forEach(function(it) {
      var isEligible = isBundleEligible(it);
      if (!isEligible) {
        // Non-bundle items (gift cards, full-price etc.) stay outside the
        // set box.  They don't fit the journey taxonomy and aren't priced
        // by the bundle-discount tier.
        outsideSegments.push({ it: it, qty: it.quantity, partial: false });
        return;
      }
      // All bundle-eligible items go inside the set box — including overflow
      if (boxedCount > 0 || isFormingSet) {
        boxedSegments.push({ it: it, qty: it.quantity, partial: false });
      } else {
        outsideSegments.push({ it: it, qty: it.quantity, partial: false });
      }
    });

    // ── Sub-group helpers (used by both collapsed summary + expanded item rows) ──
    function __journeyOf(__it) {
      var __c = __categoryOf(__it);
      if (__c === 'mat') return 'pregnancy';
      if (__c === 'rec') return 'postpartum-recovery';
      if (__c === 'nursing') return 'breastfeeding';
      return 'mum-uniform'; // shaper / shapewear / top all bucket here
    }
    // Per-item category — derived from handle + title keywords. Resilient
    // to handle changes since both are checked.
    function __categoryOf(__it) {
      var __h = (__it.handle || '').toLowerCase();
      var __t = (__it.product_title || '').toLowerCase();
      if (/pregnancy.recovery|^recovery$|recovery-/.test(__h) || __t.indexOf('pregnancy recovery') >= 0 || __t.indexOf('recovery') >= 0) return 'rec';
      if (__h.indexOf('nursing') >= 0 || __h.indexOf('crop') >= 0 || __t.indexOf('nursing') >= 0) return 'nursing';
      if (__h.indexOf('body-shapewear') >= 0 || __t.indexOf('body shapewear') >= 0) return 'shapewear';
      if (__h.indexOf('shaper-move') >= 0 || __h.indexOf('vibe') >= 0 || __t.indexOf('shaper move') >= 0 || __t.indexOf('vibe') >= 0) return 'shaper';
      if (__h.indexOf('mat-') >= 0 || /\bmat\b|maternity/.test(__h) || __t.indexOf('maternity') >= 0) return 'mat';
      return 'top';
    }
    // Sub-group title per category — stage-independent for mum-tum items so
    function __subGroupOf(__cat) {
      // Mum-tum categories — header regardless of stage.
      if (__cat === 'shaper' || __cat === 'top') return 'For school runs and feeling like yourself again →';
      if (__cat === 'shapewear') return 'For the dresses you didn’t think you’d wear again →';
      // Maternity items only get a heading when the cart is in the
      // "pregnant" stage (otherwise they're already over).
      if (__cat === 'mat' && stage === 'pregnant') return 'For every day until your due date →';
      // Recovery + nursing → "meet baby" line.  Applies to pregnant
      // (hospital-bag context) and postpartum (just-met-baby context).
      if (__cat === 'rec') return 'For the day you meet baby →';
      if (__cat === 'nursing' && stage === 'pregnant') return 'For the day you meet baby →';
      if (__cat === 'nursing') return 'For feeding whenever, wherever →';
      return null;
    }
    // Canonical sub-group order per stage — first = "everyday" use case, second = "special moment".
    var __subGroupOrder = {
      pregnant:   ['For every day until your due date →', 'For the day you meet baby →'],
      postpartum: ['For the day you meet baby →', 'For feeding whenever, wherever →'],
      mum:        ['For school runs and feeling like yourself again →', 'For the dresses you didn’t think you’d wear again →'],
    };
    // Stage-colour key per sub-group title. Used to colour headings + item
    // titles across BOTH the forming-set accordion AND the locked-set
    // collapsed/expanded views — so the wardrobe palette is consistent.
    function __stageColorFor(sg) {
      var map = {
        // Universal journey keys (forming-set)
        'pregnancy':           'pregnancy',
        'postpartum-recovery': 'recovery',
        'breastfeeding':       'breastfeeding',
        'mum-uniform':         'mum-uniform',
        // Long-string sub-group keys (locked-set narrative)
        'For every day until your due date →': 'pregnancy',
        'For the day you meet baby →': 'recovery',
        'For feeding whenever, wherever →': 'breastfeeding',
        'For school runs and feeling like yourself again →': 'mum-uniform',
        'For the dresses you didn’t think you’d wear again →': 'shapewear'
      };
      return map[sg] || 'default';
    }
    // Editorial short label per sub-group title — used everywhere headings
    // appear (forming accordion + locked-set collapsed + locked-set expanded)
    // so the cart speaks one heading-style consistently.
    function __shortLabelFor(sg) {
      var __mw = IS_MOM ? 'MOM' : 'MUM';
      var map = {
        // Universal journey keys (forming-set)
        'pregnancy':           'MY PREGNANCY JOURNEY',
        'postpartum-recovery': 'MY POST PARTUM RECOVERY',
        'breastfeeding':       'MY BREASTFEEDING ADVENTURE',
        'mum-uniform':         'MY ' + __mw + ' UNIFORM',
        // Long-string sub-group keys (locked-set narrative)
        'For every day until your due date →': 'MY PREGNANCY JOURNEY',
        'For the day you meet baby →': 'MY POST PARTUM RECOVERY',
        'For feeding whenever, wherever →': 'MY BREASTFEEDING ADVENTURE',
        'For school runs and feeling like yourself again →': 'MY ' + __mw + ' UNIFORM',
        'For the dresses you didn’t think you’d wear again →': 'MY CONFIDENCE LAYER'
      };
      return map[sg] || sg.toUpperCase();
    }
    // Sort boxedSegments by sub-group canonical order so the expanded view
    // groups items by sub-group (matching the collapsed view's grouping).
    // Unknown sub-groups go last in insertion order.
    (function sortBoxedBySubGroup() {
      var order = __subGroupOrder[stage] || [];
      var rank = function(seg) {
        var sg = __subGroupOf(__categoryOf(seg.it));
        var idx = sg ? order.indexOf(sg) : -1;
        return idx >= 0 ? idx : 999;
      };
      // stable sort
      boxedSegments.sort(function(a, b) { return rank(a) - rank(b); });
    })();
    // Pre-bucket boxedSegments by sub-group title — used by the forming-set
    var __subGroupItems = {};
    boxedSegments.forEach(function(__s) {
      var __sg = __journeyOf(__s.it);
      if (!__sg) return;
      if (!__subGroupItems[__sg]) __subGroupItems[__sg] = [];
      __subGroupItems[__sg].push(__s);
    });
    // Stage totals (sum of all items in a journey × their quantities).
    var __subGroupPrices = {};
    Object.keys(__subGroupItems).forEach(function(__sg) {
      var __sum = 0, __sumRrp = 0;
      __subGroupItems[__sg].forEach(function(__s) {
        var __it = __s.it;
        var __qty = __s.qty || 0;
        var __unit = isBundleEligible(__it) && bundleQty > 0
          ? mcUnit(__it, bundleQty)
          : (__it.final_line_price / Math.max(1, __it.quantity)) / 100;
        var __unitRrp = (__it.original_price || 0) / 100;
        __sum += __unit * __qty;
        __sumRrp += __unitRrp * __qty;
      });
      __subGroupPrices[__sg] = { total: Math.ceil(__sum), rrp: Math.ceil(__sumRrp) };
    });
    function __stagePriceHtml(sg) {
      var p = __subGroupPrices[sg];
      if (!p || !p.total) return '';
      var html = '<div class="scv-stage-price-col">';
      html += '<div class="scv-stage-price-total">' + S + p.total + '</div>';
      if (p.rrp > p.total) {
        html += '<div class="scv-stage-price-rrp">' + S + p.rrp + '</div>';
      }
      html += '</div>';
      return html;
    }

    // Forming-set canonical journey list — universal 4 entries regardless of
    var __canonicalSGs = ['pregnancy', 'postpartum-recovery', 'breastfeeding', 'mum-uniform'];
    var __nextCanonicalIdx = 0;

    // Precompute which product KINDS (shorts / leggings / crop) are in the
    var __journeyKinds = {};
    __canonicalSGs.forEach(function(sg) { __journeyKinds[sg] = { shorts: false, leggings: false, crop: false, other: false }; });
    if (isFormingSet) {
      boxedSegments.forEach(function(s) {
        var jsg = __journeyOf(s.it);
        if (!__journeyKinds[jsg]) return;
        var k = __itemKindOf(s.it);
        __journeyKinds[jsg][k] = true;
      });
    }

    // Inline SVGs for the augmentation circles (left-arrow for "see range",
    // plus for "add the other too").  Stroke uses currentColor so the muted
    // grey from .scv-journey-aug-circle propagates.
    var __SVG_LEFTARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>';
    var __SVG_PLUS      = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>';

    // Empty-stage accordion: eyebrow on top, "see the X range" CTA row
    function __breastfeedingEmptyLabel() {
      var hasMat = false, hasRec = false;
      var matLeggings = false, matShorts = false;
      var recLeggings = false, recShorts = false;
      (cart.items || []).forEach(function(__it) {
        var __c = __categoryOf(__it);
        if (__c === 'mat') {
          hasMat = true;
          var __k = __itemKindOf(__it);
          if (__k === 'leggings') matLeggings = true;
          else if (__k === 'shorts') matShorts = true;
        } else if (__c === 'rec') {
          hasRec = true;
          var __k2 = __itemKindOf(__it);
          if (__k2 === 'leggings') recLeggings = true;
          else if (__k2 === 'shorts') recShorts = true;
        }
      });
      function pickKind(hasLeg, hasShorts) {
        // Spec: if both kinds in cart, choose "leggings".  If neither (rare
        // edge), default to "leggings" too — it reads better than "shorts"
        // in the connective copy.
        if (hasLeg) return 'leggings';
        if (hasShorts) return 'shorts';
        return 'leggings';
      }
      var nothingInCart = !cart.items || cart.items.length === 0;
      if (nothingInCart) return MUM_PLURAL + ' start with this breastfeeding crop';
      if (hasMat && !hasRec) {
        return 'this breastfeeding top goes well with those maternity '
          + pickKind(matLeggings, matShorts)
          + ' and are made for pregnancy + after';
      }
      if (!hasMat && hasRec) {
        return 'this breastfeeding crop pairs perfectly with your post partum '
          + pickKind(recLeggings, recShorts);
      }
      if (hasMat && hasRec) {
        var combLeg = matLeggings || recLeggings;
        var combShorts = matShorts || recShorts;
        return 'this breastfeeding top is popular during pregnancy + post partum. Pairs with all your maternity and post partum '
          + pickKind(combLeg, combShorts);
      }
      return null; // fall back to default "see the breastfeeding range"
    }
    // Pregnancy empty-stage matrix.  Mirrors __breastfeedingEmptyLabel but
    // only 3 cart states get custom copy; everything else falls back to the
    // default "see the maternity range" line.
    function __pregnancyEmptyLabel() {
      var hasRec = false, hasNurse = false, hasMum = false;
      (cart.items || []).forEach(function(__it) {
        var __c = __categoryOf(__it);
        if (__c === 'rec') hasRec = true;
        else if (__c === 'nursing') hasNurse = true;
        else if (__c === 'shaper' || __c === 'shapewear' || __c === 'top') hasMum = true;
      });
      var nothingInCart = !cart.items || cart.items.length === 0;
      if (nothingInCart) return 'most ' + MUM_PLURAL + ' start with these maternity leggings';
      if (hasRec && !hasNurse && !hasMum) return 'these maternity leggings work across the all trimesters';
      if (hasNurse && !hasRec && !hasMum) return 'these maternity leggings go perfectly with your nursing crop';
      return null; // every other combo → default "see the maternity range"
    }
    function __postpartumEmptyLabel() {
      var hasMat = false, hasNurse = false;
      (cart.items || []).forEach(function(__it) {
        var __c = __categoryOf(__it);
        if (__c === 'mat') hasMat = true;
        else if (__c === 'nursing') hasNurse = true;
      });
      if (hasNurse) return 'these leggings pair perfectly with your nursing crop';
      if (hasMat && !hasNurse) return 'most ' + MUM_PLURAL + ' add these leggings for their Hospital Bag';
      return null;
    }
    function __emptyAccordionHtml(sg) {
      var sc = __stageColorFor(sg);
      var pair = __JOURNEY_PAIRS[sg];
      var seedHandle = (pair && pair.seedDefault) || '';
      var label = null;
      if (sg === 'breastfeeding') label = __breastfeedingEmptyLabel();
      else if (sg === 'pregnancy') label = __pregnancyEmptyLabel();
      else if (sg === 'postpartum-recovery') label = __postpartumEmptyLabel();
      else if (sg === 'mum-uniform') label = 'these leggings are for everyday ' + MUM_LOWER + ' life (they hide ' + MUM_LOWER + ' pouch)';
      if (!label) {
        label = 'see the ' + __rangeLabelFor(sg) + ' range';
      }
      // Longer breastfeeding variants need a smaller font to fit cleanly
      // beside the icon without wrapping aggressively.
      var labelCls = 'scv-journey-aug-label' + (label.length > 36 ? ' scv-journey-aug-label--long' : '');
      return '<div class="scv-subgroup-acc scv-subgroup-acc-empty" data-stage-color="' + sc + '">'
        + '<div class="scv-subgroup-empty-row">'
        + '<span class="scv-subgroup-eyebrow">' + __shortLabelFor(sg) + '</span>'
        + '</div>'
        + '<button type="button" class="scv-journey-aug-row" data-journey-aug="see-range" data-journey="' + sg + '" data-seed-handle="' + seedHandle + '">'
        +   '<span class="scv-journey-aug-circle">' + __SVG_LEFTARROW + '</span>'
        +   '<span class="' + labelCls + '">' + label + '</span>'
        + '</button>'
        + '</div>';
    }
    // Render the "+ add the [other] too" row for a populated journey when it
    // ── Journey fill engine (28 Jul, agreed) ────────────────────────────
    // The "add the X too" row is DYNAMIC: candidates come from the journey's
    // stage pool in the live catalog — in stock NOW (qty > 0, never
    // pre-order), bundle-eligible, EXACT her-size, not already in cart,
    // deepest stock first. Complement ladder: missing bottom first
    // (shorts <-> leggings), then tops. Nothing useful, unknown size, or
    // 9+ units in the bag -> the row does not render (agreed: hide).
    var __JOURNEY_STAGE = {
      'pregnancy': 'maternity',
      'postpartum-recovery': 'postpartum',
      'breastfeeding': 'postpartum',
      'mum-uniform': 'mum'
    };
    // Honest garment word — a top is only "nursing" when the product says so.
    function __suggestWord(garment, title) {
      if (garment === 'shorts') return 'the shorts';
      if (garment === 'leggings') return 'the leggings';
      var t = String(title || '').toLowerCase();
      if (t.indexOf('nursing') >= 0 && t.indexOf('crop') >= 0) return 'a nursing crop';
      if (t.indexOf('nursing') >= 0 && t.indexOf('bra') >= 0) return 'a nursing bra';
      if (t.indexOf('bodysuit') >= 0) return 'a bodysuit';
      if (t.indexOf('crop') >= 0) return 'a crop';
      if (t.indexOf('bra') >= 0) return 'a bra';
      return 'a top';
    }
    // Deepest in-stock candidate for stage|garment at her exact size.
    function __journeyCandidate(stage, garment, size, cartHandles) {
      var cat = window.__emPackCatalog;
      if (!cat || !cat.products || !size) return null;
      var best = null;
      cat.products.forEach(function (p) {
        if (p.bucket !== stage + '|' + garment) return;
        if (p.bundleEligible === false) return;           // drops never suggested
        if (cartHandles[p.handle]) return;                // already in the bag
        var v = null;
        (p.variants || []).forEach(function (x) {
          if (String(x.size || '').toUpperCase() !== size) return;
          if (!(typeof x.qty === 'number' && x.qty > 0)) return;
          if (!v || x.qty > v.qty) v = x;
        });
        if (v && (!best || v.qty > best.qty)) best = { handle: p.handle, vid: v.id, qty: v.qty, title: p.title, garment: garment };
      });
      return best;
    }

    function __renderJourneyAugmentation(sg) {
      var stage = __JOURNEY_STAGE[sg];
      var kinds = __journeyKinds[sg];
      if (!stage || !kinds) return '';
      // Stop at the best tier — the celebration/tier UI owns the max rung and up.
      if ((typeof bundleQty === 'number' ? bundleQty : 0) >= maxPackQty()) return '';

      // Her size from what she actually bought in this journey; unknown -> hide.
      var bucket = __subGroupItems[sg] || [];
      var size = null;
      for (var i = 0; i < bucket.length; i++) {
        var t = __variantSize(bucket[i].it);
        if (t) { size = t; break; }
      }
      if (!size) return '';

      // Complement ladder for this journey's state. Tops for the PREGNANCY
      // journey come from postpartum|tops (nursing crops) — the same forward
      // pull the smart-set plans use for t1/t2; maternity|tops (bodysuits)
      // are a thin clearance pool.
      var topsStage = (stage === 'maternity') ? 'postpartum' : stage;
      var ladder;
      if (sg === 'breastfeeding') ladder = [['tops', topsStage]];
      else if (kinds.leggings && !kinds.shorts) ladder = [['shorts', stage], ['tops', topsStage]];
      else if (kinds.shorts && !kinds.leggings) ladder = [['leggings', stage], ['tops', topsStage]];
      else if (kinds.shorts && kinds.leggings) ladder = [['tops', topsStage]];
      else ladder = [['leggings', stage], ['shorts', stage]];

      var cartHandles = {};
      ((lastCartJson && lastCartJson.items) || []).forEach(function (it) { if (it.handle) cartHandles[it.handle] = true; });

      var cand = null;
      for (var li = 0; li < ladder.length && !cand; li++) {
        cand = __journeyCandidate(ladder[li][1], ladder[li][0], size, cartHandles);
      }
      if (!cand) return '';                               // nothing useful -> no row

      // Price + crossed-out RRP, same row, per-country. Source = the bundle
      // price JSON (same as the pill/CTA): now = per-item price the bag
      // sits at once this is added (priceForQty(bundleQty+1)); RRP =
      // bundleConfig.default_price. Omitted entirely until config loads or
      // if RRP is missing/sentinel, so we never show a bogus figure.
      var __augPriceHtml = '';
      if (bundleConfig && bundleConfig.tiers && bundleConfig.tiers.length) {
        var __augBq = (typeof bundleQty === 'number' ? bundleQty : 0);
        var __augNow = Math.ceil(clampToVariant(priceForQty(__augBq + 1), avgBundleVariantPrice(lastCartJson)));
        if (__augNow > 0) {
          __augPriceHtml = '<span class="scv-journey-aug-price">' + S + __augNow;
          var __augRrp = bundleConfig.default_price;
          if (__augRrp > 0 && __augRrp < 900 && Math.ceil(__augRrp) > __augNow) {
            __augPriceHtml += '<s>' + S + Math.ceil(__augRrp) + '</s>';
          }
          __augPriceHtml += '</span>';
        }
      }
      var label = 'add ' + __suggestWord(cand.garment, cand.title) + ' too';
      return '<button type="button" class="scv-journey-aug-row" data-journey-aug="add-other" data-journey="' + sg + '" data-variant-id="' + cand.vid + '" data-target-handle="' + cand.handle + '">'
        +     '<span class="scv-journey-aug-circle">' + __SVG_PLUS + '</span>'
        +     '<span class="scv-journey-aug-label">' + label + '</span>'
        +     __augPriceHtml
        +   '</button>';
    }
    function __shouldShowEmpty(sg) {
      if (bundleQty >= 4) return true;
      var hasMat = __subGroupItems['pregnancy'] && __subGroupItems['pregnancy'].length > 0;
      var hasPost = __subGroupItems['postpartum-recovery'] && __subGroupItems['postpartum-recovery'].length > 0;
      var hasBreast = __subGroupItems['breastfeeding'] && __subGroupItems['breastfeeding'].length > 0;
      var hasMum = __subGroupItems['mum-uniform'] && __subGroupItems['mum-uniform'].length > 0;
      if (sg === 'pregnancy') return false;
      if (sg === 'postpartum-recovery') {
        if (hasBreast) return true;
        if (hasMat) return true;
      }
      if (sg === 'breastfeeding') {
        if (hasPost) return true;
        if (hasMat && bundleQty >= 2) return true;
      }
      if (sg === 'mum-uniform') {
        if (bundleQty >= 3) return true;
      }
      return false;
    }
    
    function __emitMissingBefore(currentSG) {
      var currentIdx = __canonicalSGs.indexOf(currentSG);
      if (currentIdx < 0) return; // unrecognised SG; don't gate
      while (__nextCanonicalIdx < currentIdx) {
        var sg = __canonicalSGs[__nextCanonicalIdx];
        if (!__subGroupItems[sg] || !__subGroupItems[sg].length) {
          if (__shouldShowEmpty(sg)) h += __emptyAccordionHtml(sg);
        }
        __nextCanonicalIdx++;
      }
      __nextCanonicalIdx = currentIdx + 1;
    }
    function __emitMissingAfterAll() {
      while (__nextCanonicalIdx < __canonicalSGs.length) {
        var sg = __canonicalSGs[__nextCanonicalIdx];
        if (!__subGroupItems[sg] || !__subGroupItems[sg].length) {
          if (__shouldShowEmpty(sg)) h += __emptyAccordionHtml(sg);
        }
        __nextCanonicalIdx++;
      }
    }

    // Combined sequence for rendering: box first, then outside. Each segment carries its position.
    var segments = [];
    boxedSegments.forEach(function(s) { segments.push({ it: s.it, position: 'in',  qty: s.qty, partial: s.partial }); });
    outsideSegments.forEach(function(s) { segments.push({ it: s.it, position: 'out', qty: s.qty, partial: s.partial }); });
    var inFieldset = false;
    // Captured at fieldset-open from boxed segments; emitted at fieldset-close
    var setPreorderHtml = '';
    // Captured for the forming-set path (1-4 items): the set-level UGC row
    // HTML is built when we "open" the in-set group (which doesn't render
    // a fieldset in forming mode) and emitted when the group closes.
    var formingUgcHtml = '';
    // Tracks the sub-group of the previously rendered in-position row, so we
    // emit a sub-group header only when the group changes.
    var __lastInSubGroup = null;

    segments.forEach(function(seg, idx) {
      var it = seg.it;
      var qtyDisplay = seg.qty;
      // Stepper hidden on the in-box portion of a SPLIT line (locked-in, no controls).
      // Fully-in-box lines and outside segments keep the stepper.
      var stepperEnabled = !(seg.position === 'in' && seg.partial);
      // Open the set fieldset + collapsed details summary before the first in-box segment.
      if (seg.position === 'in' && !inFieldset && isFormingSet) {
        // Stash the set-level UGC row HTML for emission at fieldset-close.
        var __packPids = boxedSegments.map(function(__s){ return __s.it.product_id; }).filter(Boolean).join(',');
        var __mumsStageLabel = stage === 'pregnant' ? ('pregnant ' + MUM_PLURAL) : (stage === 'postpartum' ? ('postpartum ' + MUM_PLURAL) : MUM_PLURAL);
        formingUgcHtml = '<div class="scv-pack-mums scv-pack-mums-forming" data-set-mums data-product-ids="' + __packPids + '" data-stage-label="' + __mumsStageLabel + '" hidden>'
          + '<div class="scv-mums-circle" aria-hidden="true"></div>'
          + '<div class="scv-mums-text">'
          + '<div class="scv-mums-copy">watch <span data-mums-count>?</span> ' + __mumsStageLabel + ' wearing this set →</div>'
          + '<div class="scv-mums-sub">Real ' + MUM_PLURAL + '. Same Journey. Same size.</div>'
          + '</div>'
          + '</div>';
        inFieldset = true;
      } else if (seg.position === 'in' && !inFieldset) {
        // Locked-in set (5+) — forming-set is handled in the branch above.
        // Header reflects the actual count of bundle items in the cart (was
        // tier-pinned to boxedCount — 5/7/9 — even when the cart had more).
        var setHeading = (setLabelMap[stage] || MUM_TITLE) + ' ' + bundleQty + ' piece set';
        // Total = current-tier price × bundleQty (every bundle item in the box,
        // including overflow past the tier cap).  Matches the cart's actual
        // subtotal for bundle-eligible items at the active discount tier.
        var setTotal;
        if (window.__mcMember) {
          setTotal = Math.ceil(priceForQty(bundleQty) * bundleQty);
        } else {
          var __fullSetSum = 0;
          boxedSegments.forEach(function(__bs){ __fullSetSum += variantUnitDollars(__bs.it) * (__bs.qty || 0); });
          setTotal = Math.ceil(__fullSetSum);
        }
        // Set RRP — sum of original_price (cents) × qty across boxed items.
        var __setRrp = 0;
        boxedSegments.forEach(function(__bs){
          __setRrp += ((__bs.it.original_price || 0) / 100) * (__bs.qty || 0);
        });
        __setRrp = Math.ceil(__setRrp);
        // New structure: a frame wrapper holds the header (sits above the
        h += '<div class="scv-set-frame">';
        h += '<div class="scv-set-header">' + setHeading + '</div>';
        // Box sits flush against the header (margin-top:0), tight top padding
        // so the first stage subgroup is close to the header line.
        h += '<fieldset data-set-box class="scv-set-box" style="border:none;background:#FAF3E0;border-radius:6px;padding:10px 14px 12px;margin:0 0 16px;">';
        h += '<legend class="scv-set-legend-hidden" style="display:none;"></legend>'; // semantic legend retained but hidden
        // Persist the customise-expanded state across re-renders so qty changes
        // (which trigger render → rebuild innerHTML → new <details>) don't
        // auto-collapse the set the user just expanded.  Mirrors the journey
        // accordion's __scvOpenJourneys pattern.
        var __setExpandedAttr = (window.__scvSetExpanded) ? ' open' : '';
        h += '<details class="scv-pack-details"' + __setExpandedAttr + '>';
        h += '<summary>';
        // Build collapsed content.  New order (per spec):
        h += '<div class="scv-pack-collapsed-content"><div class="scv-pack-side-by-side">';
        // Fanned image stack (left column of side-by-side)
        h += '<div class="scv-pack-fan">';
        var __n = boxedSegments.length;
        boxedSegments.forEach(function(__seg, __i) {
          var __img = __seg.it.image;
          if (!__img) return;
          var __t = (__i - (__n - 1) / 2);
          var __deg = (__t * 8).toFixed(1);
          // translateX in % is relative to the image's own width — scales when CSS resizes the img.
          var __x = (__t * 6.25).toFixed(2);
          h += '<img src="' + __img + '" alt="" style="transform:rotate(' + __deg + 'deg) translateX(' + __x + '%);z-index:' + __i + ';">';
        });
        h += '</div>';
        // Product list — simplified set view: simple_name only, no modifiers, no size.
        var __ccUpper = ((window.Shopify && window.Shopify.country && window.Shopify.country.iso_code) || 'AU').toUpperCase();
        var __useMumTum = (__ccUpper === 'AU' || __ccUpper === 'GB' || __ccUpper === 'UK' || __ccUpper === 'IE' || __ccUpper === 'NZ');
        function __localiseMumTum(name) {
          return __useMumTum ? name : name.replace(/\bMum\s+Tum\b/g, 'Mom');
        }
        // (categoryOf / subGroupOf / subGroupOrder are defined at outer scope —
        var __groups = {}; // title → segments[]
        var __cats = {};   // category → true (Set polyfill)
        boxedSegments.forEach(function(__seg) {
          var __c = __categoryOf(__seg.it);
          __cats[__c] = true;
          var __title = __subGroupOf(__c) || '__nogroup';
          if (!__groups[__title]) __groups[__title] = [];
          __groups[__title].push(__seg);
        });
        var __orderedTitles = (__subGroupOrder[stage] || []).filter(function(t){ return __groups[t]; });
        Object.keys(__groups).forEach(function(t){ if (__orderedTitles.indexOf(t) < 0 && t !== '__nogroup') __orderedTitles.push(t); });
        if (__groups['__nogroup']) __orderedTitles.push('__nogroup');

        // ── "Why mums choose this set" — right column of side-by-side ──
        function __bulletsFor(c) {
          var b = [];
          if (c.mat) {
            b.push('supports bump, back &amp; posture');
            b.push('grows with you each trimester');
          }
          if (c.mat && (c.rec || c.nursing)) {
            b.push('hospital-bag approved');
          }
          if (c.rec) {
            if (c.mat) {
              b.push('recovers with you, day one');
            } else {
              b.push('post-birth recovery compression');
              b.push('post-c-section friendly');
              b.push('ARTG-listed medical-grade');
            }
          }
          if (c.nursing) b.push('feed anywhere, anytime');
          if (c.shaper) b.push('smooths the ' + (__useMumTum ? 'mum-tum' : 'mom-pouch') + ', all day');
          if (c.shapewear) b.push('invisible under any outfit');
          if (c.shaper && c.shapewear) b.push('wears from school-run to date-night');
          if (c.shaper || c.shapewear || c.mat) b.push('pocket-deep for your phone');
          var seen = {}, out = [];
          for (var i = 0; i < b.length && out.length < 5; i++) {
            if (!seen[b[i]]) { seen[b[i]] = 1; out.push(b[i]); }
          }
          return out;
        }
        var __bullets = isFormingSet ? [] : __bulletsFor(__cats);
        if (__bullets.length) {
          var __setTypeWord = (stage === 'pregnant') ? 'maternity'
                             : (stage === 'postpartum') ? 'postpartum'
                             : (IS_MOM ? 'mom uniform' : 'mum uniform');
          h += '<div class="scv-pack-why">';
          h += '<div class="scv-pack-why-title">you made the perfect ' + __setTypeWord + ' set</div>';
          h += '<ul class="scv-pack-why-list">';
          __bullets.forEach(function(__bl){ h += '<li>' + __bl + '</li>'; });
          h += '</ul>';
          h += '</div>';
        }
        h += '</div>'; // close .scv-pack-side-by-side

        // Product list below the side-by-side block (still inside
        // .scv-pack-collapsed-content). Sub-group headers + ×N item rows.
        h += '<div class="scv-pack-text">';
        var __preorderTexts = [];
        var __firstSubgroupEmitted = false;
        __orderedTitles.forEach(function(__title) {
          var __titleStageColor = __title !== '__nogroup' ? __stageColorFor(__title) : 'default';
          if (__title !== '__nogroup') {
            // First-emitted subgroup carries the set price on the right —
            // big sale total, crossed-out RRP under it (smaller, faded).
            var __isFirstSg = !__firstSubgroupEmitted;
            __firstSubgroupEmitted = true;
            var __sgPriceHtml = '';
            if (__isFirstSg) {
              __sgPriceHtml = '<div class="scv-pack-subgroup-price">'
                + '<div class="scv-pack-subgroup-price-now">' + S + setTotal + '</div>'
                + (__setRrp > setTotal ? '<div class="scv-pack-subgroup-price-rrp">' + S + __setRrp + '</div>' : '')
                + '</div>';
            }
            var __sgCls = 'scv-pack-subgroup' + (__isFirstSg ? ' scv-pack-subgroup--with-price' : '');
            h += '<div class="' + __sgCls + '" data-stage-color="' + __titleStageColor + '">';
            h += '<span class="scv-pack-subgroup-title">' + __title + '</span>';
            h += __sgPriceHtml;
            h += '</div>';
          }
          __groups[__title].forEach(function(__seg) {
            var __it = __seg.it;
            var __meta = metaFor(__it.variant_id);
            var __name = (__meta.simple_name || __meta.core_name || cleanTitle(__it.product_title) || '').trim();
            __name = __localiseMumTum(__name);
            h += '<div class="scv-pack-row" data-stage-color="' + __titleStageColor + '">';
            h += '<div class="r1">' + __name + ' <span class="scv-row-qty-suffix">×' + __seg.qty + '</span></div>';
            h += '</div>';
            // Collect preorder note for this item if any. The stamped (and live
            // reconciled) Ships property is the truth; the config fallback only
            // applies when the sku is confirmed NOT in stock now — config
            // presence alone must never label an in-stock line PRE-ORDER.
            var __props = __it.properties || {};
            var __note = '';
            if (__it.sku && !continueSellingSkus.has(__it.sku)) {
              __note = __props.Ships || '';
              if (!__note && preorderConfig && __it.sku
                  && typeof window.__scvSkuInStock === 'function'
                  && window.__scvSkuInStock(__it.sku) === false) {
                for (var __pi = 0; __pi < preorderConfig.length; __pi++) {
                  if (preorderConfig[__pi].sku === __it.sku && preorderConfig[__pi].qty > 0) {
                    __note = preorderConfig[__pi].note || '';
                    break;
                  }
                }
              }
            }
            if (__note && __preorderTexts.indexOf(__note) < 0) __preorderTexts.push(__note);
          });
        });
        // Preorder text moved to the very bottom of the fieldset (emitted at
        // fieldset-close below). Stash the HTML for this set here.
        setPreorderHtml = __preorderTexts.length
          ? '<div class="scv-pack-preorder scv-pack-preorder-bottom">' + __preorderTexts.join('<br>') + '</div>'
          : '';
        h += '</div>'; // close .scv-pack-text
        h += '</div>'; // close .scv-pack-collapsed-content

        var __setToggleLabel = (setLabelMap[stage] || MUM_TITLE).toLowerCase();
        var __packPids = boxedSegments.map(function(__s){ return __s.it.product_id; }).filter(Boolean).join(',');
        var __mumsStageLabel = stage === 'pregnant' ? ('pregnant ' + MUM_PLURAL) : (stage === 'postpartum' ? ('postpartum ' + MUM_PLURAL) : MUM_PLURAL);
        var __mumsSize = (userBaseSizes && userBaseSizes[0]) || userSize || '';
        // Customise toggle FIRST in the summary stack (was below the mums row).
        // British-English markets read "customise"; US/CA "customize".
        var __customiseLabel = IS_MOM ? 'customize' : 'customise';
        h += '<div class="scv-pack-toggle"><span class="t-collapsed">' + __customiseLabel + ' ↓</span><span class="t-expanded">tap to collapse ↑</span></div>';
        // Set-level UGC pitch BELOW the customise toggle.  Built empty; the
        // [data-set-mums] handler fills the circle + count then unhides.
        h += '<div class="scv-pack-mums" data-set-mums data-product-ids="' + __packPids + '" data-stage-label="' + __mumsStageLabel + '" hidden>';
        h += '<div class="scv-mums-circle" aria-hidden="true"></div>';
        h += '<div class="scv-mums-text">';
        h += '<div class="scv-mums-copy">watch <span data-mums-count>?</span> ' + __mumsStageLabel + ' wearing this set →</div>';
        h += '<div class="scv-mums-sub">Real ' + MUM_PLURAL + '. Same Journey. Same size.</div>';
        h += '</div>';
        h += '</div>';
        h += '</summary>';
        inFieldset = true;
      } else if (seg.position === 'out' && inFieldset) {
        // Close journey-accordion stack (universal: both forming-set body
        if (__lastInSubGroup) {
          h += __renderJourneyAugmentation(__lastInSubGroup);
          h += '</div></div></div>';
          __lastInSubGroup = null;
        }
        __emitMissingAfterAll();
        // Forming-set: emit the captured set-mums pitch (locked-set already
        // rendered its UGC pitch inside the <summary> at fieldset-open).
        if (isFormingSet && formingUgcHtml) { h += formingUgcHtml; formingUgcHtml = ''; }
        // Locked-set: close the cream-box shell + frame.
        if (!isFormingSet) {
          h += '</details>';
          if (setPreorderHtml) { h += setPreorderHtml; setPreorderHtml = ''; }
          h += '</fieldset>';
          h += '</div>'; // close .scv-set-frame
        }
        inFieldset = false;
      }
      var includePrice = seg.position === 'out';
      var pHandle = it.handle || '';
      var pTitleSafe = cleanTitle(it.product_title);
      var pTitleAttr = pTitleSafe.replace(/"/g, '&quot;');
      var meta = metaFor(it.variant_id);
      var coreVal = (meta.core_name || '').toString().trim();
      var coreWords = coreVal.toLowerCase().match(/[a-z0-9]+/g) || [];
      var coreLastNoun = coreWords[coreWords.length - 1] || '';
      function shouldShow(val, k) {
        if (!val) return false;
        var words = val.toLowerCase().match(/[a-z0-9]+/g) || [];
        if (!words.length) return false;
        // Skip if every word is already in core_name (e.g. "long crop" vs "Long Line Nursing Crop")
        if (words.every(function(w){ return coreWords.indexOf(w) >= 0; })) return false;
        // For LENGTH specifically: skip if the value contains core's last noun
        // (e.g. core="Maternity Shorts" + length="bike shorts" — the "shorts" repeat makes length useless)
        if (k === 'length' && coreLastNoun && words.indexOf(coreLastNoun) >= 0) return false;
        return true;
      }
      var metaLines = [];
      ['core_name','length','feature','colour','tagline'].forEach(function(k){
        var val = (meta[k] || '').toString().trim();
        if (k === 'core_name' || k === 'tagline') {
          if (val) metaLines.push(val);
        } else if (shouldShow(val, k)) {
          metaLines.push(val);
        }
      });
      if (!metaLines.length) metaLines.push(pTitleSafe);

      // Sub-group header before in-position rows when the group changes.
      var __isInSet = (seg.position === 'in');
      if (__isInSet) {
        // Journey-accordion bucket key — same in both forming-set and the
        // locked-set's customise (details-open) body.  Locked-set's COLLAPSED
        // summary product list still uses narrative __subGroupOf elsewhere.
        var __thisInSG = __journeyOf(seg.it);
        if (__thisInSG && __thisInSG !== __lastInSubGroup) {
          // Close previous accordion body before opening next.  Inject the
          if (__lastInSubGroup) {
            h += __renderJourneyAugmentation(__lastInSubGroup);
            h += '</div></div></div>';
          }
          __emitMissingBefore(__thisInSG);
          var __jOpen = (window.__scvOpenJourneys && window.__scvOpenJourneys[__thisInSG]) ? 'true' : 'false';
          // "Locked" = no more pair-products to add for this journey.
          var __jLocked = false;
          var __jPair = __JOURNEY_PAIRS[__thisInSG];
          var __jKinds = __journeyKinds[__thisInSG];
          if (__jPair && __jKinds) {
            if (__jPair.shorts && __jPair.leggings) __jLocked = !!(__jKinds.shorts && __jKinds.leggings);
            else if (__jPair.crop) __jLocked = !!__jKinds.crop;
          }
          h += '<div class="scv-subgroup-acc" data-open="' + __jOpen + '" data-locked="' + __jLocked + '" data-journey="' + __thisInSG + '" data-stage-color="' + __stageColorFor(__thisInSG) + '">'
            + '<button type="button" class="scv-subgroup-toggle" aria-expanded="' + __jOpen + '">'
            + '<span class="scv-subgroup-eyebrow">' + __shortLabelFor(__thisInSG) + '</span>'
            + '<span class="scv-set-row-subgroup">' + __thisInSG + '</span>'
            + '<svg class="scv-subgroup-chevron" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>'
            + '</button>'
            + '<div class="scv-subgroup-body">'
            + __stagePriceHtml(__thisInSG)
            + '<div class="scv-stage-rows-col">';
          __lastInSubGroup = __thisInSG;
        }
      }

      // Row's stage-color matches the journey-accordion above it. Universal
      // across forming-set body + locked-set customise body.
      var __rowStageColor = __isInSet ? __stageColorFor(__journeyOf(seg.it)) : 'default';
      h += '<div data-cart-row data-stage-color="' + __rowStageColor + '" style="display:flex;align-items:flex-start;gap:0;padding:14px 0;border-top:1px solid #f3f4f6;">';
      // Image column: just the image for in-set items (the "see real mums" link
      // moves below the qty stepper); image + link for outside items.
      h += '<div data-row-imgcol style="flex-shrink:0;align-self:center;display:flex;flex-direction:column;gap:10px;width:140px;">';
      if (it.image) h += '<a href="/products/' + pHandle + '" style="display:block;line-height:0;"><img src="' + it.image + '" data-handle="' + pHandle + '" data-product-id="' + (it.product_id || '') + '" data-size="' + __variantSize(it) + '" style="width:140px;height:175px;object-fit:cover;cursor:pointer;"></a>';
      if (!__isInSet) {
        h += '<button type="button" class="scv-mums-wearing" data-product-id="' + (it.product_id || '') + '" data-size="' + __variantSize(it) + '" data-title="' + pTitleAttr + '" style="background:none;border:none;padding:0;margin:0;font:inherit;color:#9ca3af;font-size:11px;line-height:1.3;cursor:pointer;text-decoration:underline;text-underline-offset:2px;letter-spacing:0.02em;text-align:center;width:100%;">see real ' + MUM_PLURAL + ' in this →</button>';
      }
      h += '</div>';
      h += '<div style="flex:1;min-width:0;padding:0 0 0 12px;display:flex;flex-direction:column;gap:4px;">';
      // Three-row treatment: headline / combined modifiers / italic tagline.
      var modifierBits = [];
      ['length','feature','colour'].forEach(function(k){
        var v = (meta[k] || '').toString().trim();
        if (shouldShow(v, k)) modifierBits.push(v);
      });
      var taglineVal = (meta.tagline || '').toString().trim();
      // Forming-set rows show the simple_name with a trailing ×N qty — the qty
      // stepper is hidden in collapsed state so this surfaces the count inline.
      var headline;
      if (isFormingSet) {
        var __simple = (meta.simple_name || '').trim();
        var __formingBase = __simple || coreVal || pTitleSafe;
        // Show the +qty pip next to ×N when this journey already has both
        var __journeyOfRow = __journeyOf(it);
        var __jk = __journeyKinds[__journeyOfRow];
        var __pair = __JOURNEY_PAIRS[__journeyOfRow];
        var __showQtyPlus = false;
        if (__pair && __jk) {
          if (__pair.shorts && __pair.leggings) {
            __showQtyPlus = __jk.shorts && __jk.leggings;
          } else if (__pair.crop) {
            __showQtyPlus = !!__jk.crop;
          }
        }
        var __qtyHtml = '<span class="scv-row-qty-suffix">×' + seg.qty + '</span>';
        if (__showQtyPlus) {
          // data-current-qty must be the LINE quantity, not the segment qty.
          // For split lines (boxed + outside) seg.qty < it.quantity; sending
          // change.js with seg.qty+1 would shrink the line.
          __qtyHtml += '<button type="button" class="scv-row-qty-suffix-plus" data-qty-plus data-line-key="' + (it.key || '') + '" data-current-qty="' + (it.quantity || 1) + '" aria-label="add another">+</button>';
        }
        headline = __formingBase + ' ' + __qtyHtml;
      } else {
        headline = coreVal || pTitleSafe;
        // Locked-set collapsed view: qty stepper is CSS-hidden, so surface
        // a grey ×N suffix when line qty > 1 (mirrors forming-set above).
        if (seg.qty > 1) {
          headline += ' <span class="scv-row-qty-suffix">×' + seg.qty + '</span>';
        }
      }
      h += '<a href="/products/' + pHandle + '" style="text-decoration:none;color:inherit;display:block;">';
      // Line 1: core_name — headline, sentence case, medium weight, biggest
      h += '<div data-meta-row data-meta-idx="0" class="scv-item-title" style="font-family:var(--font-heading-family,system-ui,-apple-system,sans-serif);font-size:19px;font-weight:500;color:#1f2937;letter-spacing:-0.01em;line-height:1.2;margin:0;">' + headline + '</div>';
      // Line 2: length · feature · colour — supporting metadata, lowercase, muted
      if (modifierBits.length) {
        h += '<div data-meta-row data-meta-idx="1" style="font-size:12px;font-weight:400;color:#6b7280;letter-spacing:0.02em;line-height:1.3;margin:0;text-transform:lowercase;">' + modifierBits.join(' · ') + '</div>';
      }
      // (tagline row hidden per design — keep variable for fallback elsewhere)
      h += '</a>';

      // Price + RRP \u2014 only shown on "out" segments. For bundle-eligible items we use the TIER price
      // (priceForQty(bundleQty)) clamped to the line's variant price (Shopify discount fns can
      // only decrease \u2014 when tier > variant, item stays at variant).
      if (includePrice) {
        var rowIsEligible = isBundleEligible(it);
        var perUnit = rowIsEligible && bundleQty > 0
          ? mcUnit(it, bundleQty)
          : (it.final_line_price / Math.max(1, it.quantity)) / 100;
        var perUnitRrp = (it.original_price || 0) / 100;
        var totalPrice = Math.ceil(perUnit * qtyDisplay);
        var totalRrp = Math.ceil(perUnitRrp * qtyDisplay);
        h += '<div data-row-price style="display:flex;align-items:baseline;gap:8px;">';
        if (totalRrp > totalPrice) {
          h += '<span data-row-rrp style="font-size:12px;color:#9ca3af;text-decoration:line-through;">' + S + totalRrp + '</span>';
        }
        h += '<span style="font-size:14px;font-weight:600;color:#1f2937;">' + S + totalPrice + '</span>';
        h += '</div>';
      }

      // Size row (+ recovery sizing-up note). Nursing crops are NOT sized
      // up — only recovery (pregnancy-recovery) items are. Match on title
      // alone to avoid false positives from core_name overlap.
      var __isRecoveryItem = /recovery/i.test(it.product_title || '');
      // Colour x Size lines (e.g. DSers drops "dark blue / S / China Mainland") show
      // "colour / size" — drop the redundant "Size" label AND the single-value
      // "Ships From" option (helpers ignore it). Single-size lines keep "Size S".
      var __vcol = __variantColour(it);
      var __vlabel = __vcol ? (__vcol + ' / ' + __variantSize(it)) : ('Size ' + (it.variant_title || ''));
      h += '<div data-row-size style="font-size:11px;color:#6b7280;">' + __vlabel;
      if (__isRecoveryItem) {
        h += '<span style="font-style:italic;color:#9ca3af;margin-left:8px;">' + MUM_PLURAL + ' normally get a size up for these</span>';
      }
      h += '</div>';

      // Per-line price row — all in-segments (forming-set + locked-set
      if (seg.position === 'in') {
        var __rowEligible = isBundleEligible(it);
        var __perUnit = __rowEligible && bundleQty > 0
          ? mcUnit(it, bundleQty)
          : (it.final_line_price / Math.max(1, it.quantity)) / 100;
        var __perUnitRrp = (it.original_price || 0) / 100;
        var __totalPrice = Math.ceil(__perUnit * qtyDisplay);
        var __totalRrp = Math.ceil(__perUnitRrp * qtyDisplay);
        h += '<div data-row-price-inline style="display:flex;align-items:baseline;gap:8px;margin-top:2px;">';
        h += '<span style="font-size:14px;font-weight:600;color:#6b7280;">' + S + __totalPrice + '</span>';
        if (__totalRrp > __totalPrice) {
          h += '<span style="font-size:12px;color:#9ca3af;text-decoration:line-through;">' + S + __totalRrp + '</span>';
        }
        h += '</div>';
      }

      var props = it.properties || {};
      var shipNote = '';
      // Skip preorder note for continue-selling override SKUs
      if (it.sku && !continueSellingSkus.has(it.sku)) {
        shipNote = props.Ships || '';
        // Config fallback ONLY when the sku is confirmed NOT in stock now —
        // config presence alone must never label an in-stock line (29 Jul:
        // this expanded-line path was the last ungated one; a restocked
        // config sku showed PRE-ORDER here while the PDP correctly said
        // in stock).
        if (!shipNote && preorderConfig && it.sku
            && typeof window.__scvSkuInStock === 'function'
            && window.__scvSkuInStock(it.sku) === false) {
          for (var pi = 0; pi < preorderConfig.length; pi++) {
            if (preorderConfig[pi].sku === it.sku && preorderConfig[pi].qty > 0) {
              shipNote = preorderConfig[pi].note || '';
              break;
            }
          }
        }
      }
      // Per-item ship note: show for out-of-set rows always, AND for
      // forming-set rows (set not yet made → no bottom-of-fieldset preorder
      // line exists yet, so the note must surface per line under the price).
      // Once the set is locked the set-level line covers it, so skip then.
      if (shipNote && (!__isInSet || isFormingSet)) h += '<div data-ship-note style="font-size:10px;color:#E8846C;">' + shipNote + '</div>';
      // Show discount function message (skip internal ones)
      var lineDiscounts = it.line_level_discount_allocations || [];
      lineDiscounts.forEach(function(ld) {
        var msg = ld.discount_application && ld.discount_application.title || '';
        if (msg && msg.indexOf('surprise gift') < 0 && msg.indexOf('Item Pack') < 0 && msg.indexOf('Full Price') < 0 && msg.indexOf('Fixed price') < 0) {
          h += '<div data-discount-msg style="font-size:10px;color:#3D9A8B;">' + msg + '</div>';
        }
      });

      // Qty stepper \u2014 full width, single outer border. Bin icon when displayed qty = 1.
      // For partial in-box segments (locked-in portion of a split line), the stepper is replaced
      // with a static "\u00d7 N" indicator: the line's qty must be modified via the outside row.
      if (stepperEnabled) {
        var leftBtnAria = qtyDisplay === 1 ? 'Remove item' : 'Decrease quantity';
        var leftBtnContent = qtyDisplay === 1
          ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="width:16px;height:16px;display:block;"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>'
          : '\u2212';
        h += '<div data-row-qty style="display:flex;align-items:stretch;width:100%;border:1px solid #e5e7eb;border-radius:4px;overflow:hidden;margin-top:6px;">';
        h += '<button type="button" class="scv-qty" data-key="' + it.key + '" data-delta="-1" style="flex:1;min-height:36px;border:none;background:#fff;font-size:15px;color:#1f2937;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;" aria-label="' + leftBtnAria + '">' + leftBtnContent + '</button>';
        h += '<span style="flex:1;min-height:36px;display:flex;align-items:center;justify-content:center;font-size:14px;font-weight:600;background:#fff;color:#1f2937;" aria-label="Quantity">' + qtyDisplay + '</span>';
        h += '<button type="button" class="scv-qty" data-key="' + it.key + '" data-delta="1" style="flex:1;min-height:36px;border:none;background:#fff;font-size:15px;color:#1f2937;cursor:pointer;display:flex;align-items:center;justify-content:center;padding:0;" aria-label="Increase quantity">+</button>';
        h += '</div>';
      } else {
        // In-box partial \u2014 static qty indicator
        h += '<div data-row-qty-static style="font-size:11px;font-weight:500;color:#6b7280;margin-top:6px;letter-spacing:0.04em;">\u00d7' + qtyDisplay + ' in your set</div>';
      }

      // Per-item UGC row under the qty stepper \u2014 only inside the set box.
      if (__isInSet) {
        h += '<div class="scv-set-row-ugc" data-product-id="' + (it.product_id || '') + '" data-size="' + __variantSize(it) + '" data-title="' + pTitleAttr + '">';
        h += '<div class="scv-mini-circle" data-product-id="' + (it.product_id || '') + '" aria-hidden="true"></div>';
        h += '<button type="button" class="scv-mums-wearing" data-product-id="' + (it.product_id || '') + '" data-size="' + __variantSize(it) + '" data-title="' + pTitleAttr + '">see real ' + MUM_PLURAL + ' in this \u2192</button>';
        h += '</div>';
      }

      h += '</div>'; // close info column
      h += '</div>'; // close cart row
    });
    // Close fieldset if all items ended up boxed (no out-segments).  Universal
    // close: always shut the journey-accordion stack first; in locked-set
    // also close the cream-box shell.
    if (inFieldset) {
      if (__lastInSubGroup) {
        h += __renderJourneyAugmentation(__lastInSubGroup);
        h += '</div></div></div>'; // rows-col + body + acc
        __lastInSubGroup = null;
      }
      __emitMissingAfterAll();
      if (isFormingSet && formingUgcHtml) { h += formingUgcHtml; formingUgcHtml = ''; }
      if (!isFormingSet) {
        h += '</details>';
        if (setPreorderHtml) { h += setPreorderHtml; setPreorderHtml = ''; }
        h += '</fieldset>';
        h += '</div>'; // close .scv-set-frame
      }
      inFieldset = false;
    }

    // Empty bundle pool — no bundle-eligible items (truly empty cart, or
    if (bundleQty === 0) {
      __canonicalSGs.forEach(function(__sg) {
        h += __emptyAccordionHtml(__sg);
      });
    }

    // ── Free-ship unlock state (cart attribute set by previous form submit) ──
    var __freeshipUnlockedAtAttr = (cart.attributes && cart.attributes[FREESHIP_ATTR_UNLOCKED]) || '';
    var __freeshipUnlockedAtMs = parseInt(__freeshipUnlockedAtAttr, 10);
    var __freeshipHasUnlockAttr = isFinite(__freeshipUnlockedAtMs) && __freeshipUnlockedAtMs > 0;
    var __freeshipAgeMs = __freeshipHasUnlockAttr ? (Date.now() - __freeshipUnlockedAtMs) : 0;
    var __freeshipPastHardExpiry = __freeshipHasUnlockAttr && __freeshipAgeMs > FREESHIP_HARD_EXPIRY_MS;
    // Past hard expiry (24h after unlock) — clear the cart attr so the discount function stops
    // applying free shipping at checkout. UI reverts to + $15 shipping.
    if (__freeshipPastHardExpiry) {
      var clearAttrs = {};
      clearAttrs[FREESHIP_ATTR_UNLOCKED] = '';
      clearAttrs[FREESHIP_ATTR_EMAIL] = '';
      clearAttrs[FREESHIP_ATTR_PHONE] = '';
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: clearAttrs })
      }).catch(function(){});
      console.log('[scv freeship] hard expiry reached, clearing cart attrs');
    }
    var __freeshipIsUnlocked = __freeshipHasUnlockAttr && bundleQty >= freeShipSetQty() && !__freeshipPastHardExpiry;
    var __freeshipInGracePeriod = __freeshipIsUnlocked && __freeshipAgeMs > FREESHIP_TIMER_MS;
    console.log('[scv freeship] render state',
      'bundleQty=' + bundleQty,
      'shipping=' + shipping,
      'hasUnlockAttr=' + __freeshipHasUnlockAttr,
      'isUnlocked=' + __freeshipIsUnlocked,
      'attrRaw=[' + __freeshipUnlockedAtAttr + ']',
      'cart.attributes JSON=' + JSON.stringify(cart.attributes || {})
    );
    var __freeshipUsedLocal = !!lsGet(FREESHIP_LS_USED);
    var __freeshipOfferExpiredLocal = !!lsGet(FREESHIP_LS_OFFER_EXPIRED);
    var __freeshipCanShowOffer =
      bundleQty >= freeShipSetQty() &&
      shipping > 0 &&
      !__freeshipHasUnlockAttr &&
      !__freeshipUsedLocal &&
      !__freeshipOfferExpiredLocal;
    // Master kill switch — silence ALL freeship UI when off (form, applied strip, grace strip,
    // button override). Discount function still applies server-side for already-unlocked carts.
    if (!EM_FREESHIP_UI_ENABLED) {
      __freeshipIsUnlocked = false;
      __freeshipInGracePeriod = false;
      __freeshipCanShowOffer = false;
    }

    // Header lines (sale countdown + "you've built the perfect set ✔") moved
    // here from under the bag title so the dopamine + urgency lands right
    // before the user's eye reaches the checkout button.
    // ── Mum Club membership row ── active member = informational; everyone else = join-and-buy toggle ──
    // ── Membership row + subtotal/total breakdown, in ONE bordered box ──
    if (bundleQty > 0) {
      // Top section: membership row — active member = informational; everyone else = join row.
      var mcRowHtml;
      if (mcIsActiveMember()) {
        mcRowHtml = '<div style="display:flex;align-items:center;justify-content:space-between;gap:12px;">'
          + '<div><div style="font-size:14px;font-weight:700;color:#1f2937;">Mum Club member</div><div style="font-size:12px;color:#6b7280;margin-top:2px;">member pricing applied</div></div>'
          + '<span style="display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:50%;background:#c8a84e;color:#fff;font-size:16px;font-weight:800;flex:none;">&#10003;</span>'
          + '</div>';
      } else {
        var __mcImg = window.__mcMembershipImage ? '<img src="' + window.__mcMembershipImage + '" alt="" style="width:56px;height:56px;border-radius:8px;object-fit:cover;flex:none;">' : '';
        var __mcLogin = !window.__mcLoggedIn ? ' · <a href="/account/login?return_url=%2Fcart" style="font-size:12px;font-weight:600;color:#b5894e;text-decoration:underline;text-underline-offset:2px;">members login</a>' : '';
        mcRowHtml = '<div style="display:flex;align-items:flex-start;gap:12px;">'
          + __mcImg
          + '<div style="flex:1;min-width:0;">'
          +   '<div style="font-size:14px;font-weight:700;color:#1f2937;line-height:1.25;">' + ((window.__cmSignup && window.__cmSignup.active()) ? 'Enable ' + MUM_LOWER + ' club pricing' : (window.__mcMembershipTitle || 'Mum Club Membership')) + '</div>'
          +   '<div style="font-size:12px;color:#6b7280;margin-top:3px;line-height:1.45;">' + MUM_LOWER + ' club pricing, free · <a href="#" class="mc-learn-more" style="color:#b5894e;text-decoration:underline;text-underline-offset:2px;">learn more</a>' + __mcLogin + '</div>'
          +   ((window.__cmSignup && window.__cmSignup.inlineHtml && window.__cmSignup.inlineHtml()) || '')
          + '</div>'
          + '<label class="mc-toggle" aria-label="Mum Club membership" style="flex:none;margin-top:2px;"><input type="checkbox" class="mc-toggle-input" id="mc-membership-toggle"' + (window.__mcMember ? ' checked' : '') + '><span class="mc-toggle-track"><span class="mc-toggle-thumb"></span></span></label>'
          + '</div>';
      }

      // Bottom section: subtotal / total breakdown.
      var mcMemberItems = mcMemberItemsTotal(cart);          // member price of the items
      // Full price from original_price (the variant price). NOT cart.total_price — this theme
      // optimistically rewrites line prices to the member price, so cart.total_price isn't reliable here.
      var mcFullItems = 0;
      cart.items.forEach(function(it){ if (!mcIsMembershipLine(it)) mcFullItems += (((it.original_price != null ? it.original_price : it.price) || 0) / 100) * it.quantity; });
      mcFullItems = Math.ceil(mcFullItems);
      var mcFee = mcMembershipCents > 0 ? (Math.round(mcMembershipCents) / 100) : MC_MEMBERSHIP_PRICE;
      var mcDiscount = Math.max(0, mcFullItems - mcMemberItems);  // Mum Club discount = full − member items
      // No discount yet (one piece is full price): plain totals and one nudge instead of the discount receipt.
      var mcNudge = mcDiscount > 0 ? null : scvNoDiscountNudge(cart);
      var mcNoDiscountView = !(mcDiscount > 0) && (MC_FREE || mcIsActiveMember());
      window.__mcTotals = { full: mcFullItems, member: mcMemberItems, save: mcDiscount, nudge: mcNudge }; // for the learn-more modal
      var mcShipLabel = shipping > 0 ? mcMoney(shipping) : 'FREE';
      var MC_GREEN = '#15803d';
      var mcRow = function(label, value, opts) {
        opts = opts || {};
        var vStyle = 'font-weight:' + (opts.bold ? '800' : '600') + ';';
        if (opts.big) vStyle += 'font-size:15px;';
        if (opts.strike) vStyle += 'text-decoration:line-through;font-weight:800;color:#1f2937;'; // struck but STRONG, not greyed
        else if (opts.color) vStyle += 'color:' + opts.color + ';';
        var sub = opts.sub ? ' <span style="color:#9ca3af;font-size:11px;">' + opts.sub + '</span>' : '';
        return '<div style="display:flex;justify-content:space-between;align-items:baseline;padding:3px 0;font-size:13px;color:#374151;"><span>' + label + sub + '</span><span style="' + vStyle + '">' + value + '</span></div>';
      };
      var mcRows = '', mcTotal = 0, mcBottom = '';
      if (window.__mcMember && mcNoDiscountView) {
        mcRows += mcRow('Your Items', mcMoney(mcFullItems));
        if (mcMemberFreeShip) {
          mcRows += mcRow('Free Shipping for members', '<span style="text-decoration:line-through;color:#374151;font-weight:700;">' + mcMoney(STANDARD_SHIPPING) + '</span> <span style="color:' + MC_GREEN + ';font-weight:800;">FREE</span>');
        } else {
          mcRows += mcRow('Shipping', mcShipLabel);
        }
        mcTotal = mcMemberItems + shipping;
        mcBottom = scvNudgeHtml(mcNudge, false);
      } else if (window.__mcMember) {
        // Discount-receipt: anchor full price (struck), hero −discount (green), small membership, Today.
        mcRows += mcRow('Your Items', mcMoney(mcFullItems), { strike: true, big: true });
        mcRows += mcRow('Mum Club Discount', '−' + mcMoney(mcDiscount), { color: MC_GREEN, bold: true, big: true });
        if (!mcIsActiveMember() && !MC_FREE) {
          var mcMembDiscounted = (window.__mcMembershipCompareAt > window.__mcMembershipPrice && window.__mcMembershipPrice > 0);
          var mcMembBadge = mcMembDiscounted
            ? ' <span style="display:inline-block;margin-left:6px;padding:1px 6px;font-size:10px;font-weight:700;color:#fff;background:#dc2626;border-radius:4px;vertical-align:middle;text-transform:uppercase;letter-spacing:0.03em;">Limited offer</span>'
            : '';
          var mcMembVal = mcMoney(mcFee) + '/mo';
          if (mcMembDiscounted) mcMembVal += ' · <span style="text-decoration:line-through;color:#6b7280;font-weight:600;">' + mcMoney(window.__mcMembershipCompareAt) + '</span>';
          mcRows += '<div style="padding:3px 0;">'
            + '<div style="display:flex;justify-content:space-between;align-items:baseline;gap:8px;font-size:13px;color:#374151;"><span>Mum Club Membership' + mcMembBadge + '</span><span style="font-weight:600;white-space:nowrap;">' + mcMembVal + '</span></div>'
            + '<div style="font-size:11px;color:#9ca3af;margin-top:1px;">Cancel Anytime. No lock-in</div>'
            + '</div>';
        }
        // Free mode has no "Mum Club FREE" row any more (Mark, 2026-10-14: "we dont need mum club free line in subtotal
        // anymore").
        if (mcMemberFreeShip) {
          mcRows += mcRow('Free Shipping for members', '<span style="text-decoration:line-through;color:#374151;font-weight:700;">' + mcMoney(STANDARD_SHIPPING) + '</span> <span style="color:' + MC_GREEN + ';font-weight:800;">FREE</span>');
        } else {
          mcRows += mcRow('Shipping', mcShipLabel);
        }
        mcTotal = mcMemberItems + ((mcIsActiveMember() || MC_FREE) ? 0 : mcFee) + shipping;
        var mcInclItems = 'Includes ' + itemCount + ' item' + (itemCount === 1 ? '' : 's') + ((mcIsActiveMember() || MC_FREE) ? '' : ' + first month of Mum Club')
          // The pack reward, only when this cart earns it (Mark, 2026-10-14: "just add + X gift cards worth $Y each").
          + (window.cmPackReward ? window.cmPackReward.includesSuffix(window.cmPackReward.piecesInCart(cart)) : '');
        mcBottom = '<div style="margin-top:8px;font-size:12px;color:#6b7280;line-height:1.4;">' + mcInclItems + '</div>'
          + '<div style="margin-top:2px;font-size:13px;font-weight:700;color:' + MC_GREEN + ';line-height:1.4;">You saved ' + mcMoney(mcDiscount) + ' today</div>';
      } else {
        // Full price (toggle off) — no discount line; carrot shows what Mum Club would save.
        mcRows += mcRow('Your Items', mcMoney(mcFullItems));
        mcRows += mcRow('Shipping', mcShipLabel);
        mcTotal = mcFullItems + shipping;
        var mcJoinFee = MC_FREE ? 0 : MC_MEMBERSHIP_PRICE;
        var mcJoinShip = ((mcMemberItems + mcJoinFee) >= FREE_SHIP) ? 0 : STANDARD_SHIPPING;
        var mcJoinTotal = Math.round((mcMemberItems + mcJoinFee + mcJoinShip) * 100) / 100;
        mcBottom = !(mcDiscount > 0) ? scvNudgeHtml(mcNudge, true) : MC_FREE
          ? '<div style="margin-top:9px;font-size:13px;font-weight:700;color:' + MC_GREEN + ';line-height:1.4;">Turn on Mum Club → save ' + mcMoney(mcDiscount) + ' — on us (pay ' + mcMoney(mcJoinTotal) + ' today, no subscription)</div>'
          : '<div style="margin-top:9px;font-size:13px;font-weight:700;color:' + MC_GREEN + ';line-height:1.4;">Turn on Mum Club → save ' + mcMoney(mcDiscount) + ' (pay ' + mcMoney(mcJoinTotal) + ' today)</div>';
      }

      // HER GIFT CARD (Mark, 2026-10-11: "when someone claims a gift card ... show the price affect with cross outs").
      // The card she holds on this cart (window.cmHeldCard, layout/theme.liquid) comes off the whole order at checkout:
      // a line for it, and Today struck through with what she pays. Up to the order's total; any rest stays on the card.
      var mcCard = (typeof window.cmHeldCard === 'function') ? window.cmHeldCard(cart) : null;
      var mcToday = Math.round(mcTotal * 100) / 100;
      var mcCardOff = mcCard ? Math.min(mcCard.cents / 100, mcToday) : 0;
      if (mcCardOff > 0) {
        mcRows += mcRow('Your gift card', '\u2212' + mcMoney(mcCardOff), { color: MC_GREEN, bold: true, big: true });
        var mcLeft = Math.round((mcCard.cents / 100 - mcCardOff) * 100) / 100;
        if (mcLeft > 0) mcBottom = '<div style="margin-top:8px;font-size:12px;color:#6b7280;line-height:1.4;">' + mcMoney(mcLeft) + ' stays on your gift card</div>' + mcBottom;
      }
      var mcTodayHtml = mcCardOff > 0
        ? '<span><s style="color:#9ca3af;font-weight:600;font-size:14px;margin-right:6px;">' + mcMoney(mcToday) + '</s>' + mcMoney(Math.round((mcToday - mcCardOff) * 100) / 100) + '</span>'
        : '<span>' + mcMoney(mcToday) + '</span>';

      // Unboxed (Mark, 2026-09-11): no border/background — just the divider tint.
      var mcDiv = window.__mcMember ? '#e6d6ca' : '#eef0f2';
      h += '<div class="mc-subtotal" style="margin:0 0 14px;padding:12px 0;font-family:' + SYS_FONT + ';">'
        + mcRowHtml
        + '<div style="border-top:1px solid ' + mcDiv + ';margin:11px 0 9px;"></div>'
        + mcRows
        + '<div style="display:flex;justify-content:space-between;align-items:baseline;padding:7px 0 0;margin-top:5px;border-top:1px solid ' + mcDiv + ';font-size:16px;font-weight:800;color:#1f2937;"><span>Today</span>' + mcTodayHtml + '</div>'
        + mcBottom
        + '</div>';
    }
    if (headerLinesHtml) h += headerLinesHtml;

    // ── Free-shipping upsell (above Checkout) — when close to free shipping OR a set is built ──
    if (!mcMemberFreeShip && itemsToFreeShip > 0 && (itemsToFreeShip <= 2 || bundleQty >= cartRungQtys()[0])) {
      h += '<div style="font-weight: 600; font-size: 14px; text-align: center; color: #ef4444; margin-bottom: 8px;">Add ' + itemsToFreeShip + ' more item' + (itemsToFreeShip === 1 ? '' : 's') + ' to cart for free shipping</div>';
    }

    // ── Primary checkout button (right after items) ──
    h += '<div style="margin:4px 0 8px;">';
    // Two-line checkout button: items-total + checkout on top, geo-aware shipping line below.
    var __itemsTotal = Math.round((currentTotal + mcMemFee) * 100) / 100; // includes the membership fee
    var __shipLine;
    if (__freeshipIsUnlocked) {
      __shipLine = '+ FREE SHIPPING';
    } else if (shipping > 0) {
      __shipLine = '+ ' + S + Math.ceil(shipping) + ' shipping';
    } else {
      __shipLine = '+ free shipping';
    }
    h += '<button id="scv-primary-checkout" type="button" style="width:100%;display:flex;align-items:center;justify-content:center;padding:16px 18px;background:#1f2937;color:#fff;border:none;cursor:pointer;font-family:system-ui,-apple-system,sans-serif;">';
    h += '<span style="font-size:15px;font-weight:700;letter-spacing:0.10em;text-transform:uppercase;">CHECKOUT</span>';
    h += '</button>';
    // Subtle reassurance line directly under checkout — opens the same fit
    // guarantee modal the PDP shield triggers. Small, muted, underlined; not
    // a CTA on its own.
    h += '<a href="/pages/fit-guarantee" class="scv-fit-guarantee-link" onclick="event.preventDefault();if(window._openFitGuarantee)window._openFitGuarantee();else window.location.href=this.href;">100-day perfect fit guarantee</a>';
    // ── Pre-order note under the checkout button ──
    // The per-line note sits inside the set accordion and is invisible while
    // collapsed; any cart with 1+ pre-order lines must say so where the
    // customer is about to commit. Reconciled line properties are the truth
    // (Ships is added/stripped live against stock), deduped across lines.
    var __coNotes = [];
    (cart.items || []).forEach(function (it) {
      var __p = it.properties || {};
      var __n = __p.Ships || __p.ships || '';
      if (__n && __coNotes.indexOf(__n) < 0) __coNotes.push(__n);
    });
    if (__coNotes.length) {
      h += '<div class="scv-checkout-preorder" style="margin:8px 0 0;font-size:12px;line-height:1.5;color:#92400e;text-align:left;">'
        + __coNotes.join('<br>')
        + '</div>';
    }
    h += '</div>';

    // ── Free shipping unlock offer / applied strip (sits directly under checkout button) ──
    if (__freeshipCanShowOffer) {
      h += '<div id="scv-freeship-offer" data-state="form" style="margin:10px 0 16px;padding:0;font-family:system-ui,-apple-system,sans-serif;">';
      h += '<div style="font-size:13px;font-weight:700;color:#047857;letter-spacing:0.06em;text-transform:uppercase;text-align:left;">FREE SHIPPING OFFER AVAILABLE FOR <span id="scv-freeship-timer" style="font-variant-numeric:tabular-nums;">10:00</span></div>';
      h += '<div style="font-size:13px;font-weight:600;color:#1f2937;text-align:left;line-height:1.4;margin:8px 0 4px;">Unlock free shipping on your ' + freeShipSetQty() + ' piece set!</div>';
      h += '<div style="font-size:12px;color:#4b5563;text-align:left;line-height:1.45;margin:0 0 10px;">Enter your email + phone to get news, drops, promos &amp; unlock free shipping*</div>';
      h += '<input type="email" id="scv-freeship-email" placeholder="Email" autocomplete="email" style="width:100%;box-sizing:border-box;padding:10px 12px;font-size:14px;border:1px solid #d1d5db;border-radius:4px;margin-bottom:6px;background:#fff;">';
      h += '<input type="tel" id="scv-freeship-phone" placeholder="Phone (e.g. 0412 345 678)" autocomplete="tel" style="width:100%;box-sizing:border-box;padding:10px 12px;font-size:14px;border:1px solid #d1d5db;border-radius:4px;margin-bottom:8px;background:#fff;">';
      h += '<button type="button" id="scv-freeship-submit" style="width:100%;padding:11px 14px;background:#1f2937;color:#fff;border:none;border-radius:4px;font-size:13px;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;cursor:pointer;">Unlock Free Shipping</button>';
      h += '<div id="scv-freeship-error" style="display:none;font-size:11px;color:#b91c1c;text-align:center;margin-top:6px;"></div>';
      h += '<div style="font-size:10px;color:#6b7280;text-align:center;line-height:1.5;margin-top:8px;">*new customers only · one-time use · offer expires once timer runs out. By providing your phone you agree to receive marketing texts; msg/data rates may apply, reply STOP to opt out.</div>';
      h += '</div>';
    } else if (__freeshipIsUnlocked && __freeshipInGracePeriod) {
      // Visual countdown expired but still within 24h grace — italic small note, no border/bg.
      h += '<div id="scv-freeship-applied" data-state="grace" style="margin:8px 0 16px;padding:0;font-family:system-ui,-apple-system,sans-serif;font-size:11px;font-style:italic;color:#6b7280;line-height:1.5;text-align:left;">';
      h += 'your free shipping expired, but don’t worry — we got you.<br>';
      h += 'free shipping for your ' + freeShipSetQty() + ' piece set will apply for 24 hours';
      h += '</div>';
    } else if (__freeshipIsUnlocked) {
      h += '<div id="scv-freeship-applied" data-state="active" style="margin:6px 0 16px;padding:10px 12px;border:1px solid #c7e9df;background:#ecfdf5;border-radius:6px;font-family:system-ui,-apple-system,sans-serif;text-align:center;">';
      h += '<div style="font-size:13px;font-weight:600;color:#047857;">✓ Free shipping is applied for <span id="scv-freeship-applied-timer" style="font-variant-numeric:tabular-nums;">10:00</span></div>';
      h += '<div style="font-size:11px;color:#4b5563;margin-top:4px;">or spend over ' + S + Math.ceil(FREE_SHIP) + ' for free shipping</div>';
      h += '</div>';
    }

    // ── Ghost upsell zone ──
    h += '<div id="scv-ghost-zone"></div>';

    // ── Discounts ──
    if (discounts.length) {
      h += '<div style="padding:8px 0;">';
      discounts.forEach(function(d) {
        h += '<div style="display:flex;justify-content:space-between;font-size:13px;color:#3D9A8B;padding:2px 0;">';
        h += '<span>' + d.title + '</span>';
        h += '<span>-' + S + Math.ceil(d.total_allocated_amount / 100) + '</span>';
        h += '</div>';
      });
      h += '</div>';
    }

    inner.innerHTML = h;
    window.__scvRenderedOk = true;
    clearTimeout(window.__scvFallbackTimer);
    container.style.display = 'block';


    // ── Express checkout mount (Apple Pay / Shop Pay / PayPal / Google Pay) at bottom of cart ──
    // Sticky checkout disabled — express buttons + fallback "other payment options" button
    // sit inline in the cart content (#scv-express-mount).
    try {
      var expressMount = document.getElementById('scv-express-mount');
      if (!expressMount) {
        expressMount = document.createElement('div');
        expressMount.id = 'scv-express-mount';
        var cartView = document.getElementById('set-cart-view');
        if (cartView) cartView.appendChild(expressMount);
      }
      var expressEl = document.querySelector('.cart__dynamic-checkout-buttons');
      if (expressEl && !expressMount.querySelector('.cart__dynamic-checkout-buttons')) {
        expressEl.style.cssText = '';
        expressMount.appendChild(expressEl);
      }
    } catch(e) { console.warn('[scv] failed to mount express checkout', e); }

    // ── OUR POLICIES (accordions, geo-aware shipping copy) ──
    try {
      var policiesMount = document.getElementById('scv-policies-mount');
      if (!policiesMount) {
        policiesMount = document.createElement('div');
        policiesMount.id = 'scv-policies-mount';
        policiesMount.style.cssText = 'max-width:480px;margin:24px auto 32px;padding:0 20px;font-family:system-ui,-apple-system,sans-serif;';
        var curCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
        var freeShipMap = FREE_SHIP_MAP; // single source — the geo map defined up top
        var countryMap = { AUD: 'Australia', USD: 'the US', CAD: 'Canada', GBP: 'the UK', NZD: 'New Zealand', EUR: 'Europe', SGD: 'Singapore' };
        var freeShipAmt = freeShipMap[curCode] || 150;
        var countryName = countryMap[curCode] || 'your country';
        var SS = (function(){ var s='$'; if(curCode==='GBP')s='£';else if(curCode==='EUR')s='€';else if(curCode==='SGD')s='S$'; return s; })();

        var ph = '';
        ph += '<div style="font-size:13px;font-weight:700;color:#1f2937;letter-spacing:0.06em;text-transform:uppercase;margin:0 0 4px 0;">OUR POLICIES</div>';

        function policyAccordion(title, body, isLast) {
          var border = isLast ? 'border-top:1px solid #f3f4f6;border-bottom:1px solid #f3f4f6;' : 'border-top:1px solid #f3f4f6;';
          var s = '<details class="scv-policy" style="' + border + 'padding:14px 0;">';
          s += '<summary style="cursor:pointer;display:flex;align-items:center;justify-content:space-between;font-size:13px;font-weight:600;color:#1f2937;">';
          s += '<span>' + title + '</span><span class="scv-policy-chevron" style="color:#6b7280;display:inline-flex;align-items:center;"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg></span>';
          s += '</summary>';
          s += '<div style="font-size:12px;color:#6b7280;line-height:1.55;padding:10px 0 0 0;">' + body + '</div>';
          s += '</details>';
          return s;
        }

        var termsBody = 'By accessing or using emamaco.com.au, you signify that you have read, understand and agree to be bound by our Terms of Service. Full Terms and Conditions, Privacy Policy, and other terms of service can be accessed via <a href="/policies/terms-of-service" style="color:#1f2937;text-decoration:underline;">our policies page</a>.';
        var shippingFreeLine = freeShipAmt > 0
          ? 'Free standard shipping on orders over ' + SS + freeShipAmt + '.'
          : 'Free standard shipping on all orders.';
        var shippingBody = shippingFreeLine + '<br>'
          + 'Check that the item(s) in your cart are correct. Orders cannot be changed or canceled once placed.<br>'
          + 'Delivery within ' + countryName + ' is 1 to 10 days.<br>'
          + 'Please expect a processing time of 2-3 business days for orders placed with standard shipping.';
        var guaranteeBody = 'We give a fit about comfort and quality, and want you to look good and feel good. That\u2019s why every product comes with a Perfect Fit, Made to Last Guarantee \u2013 if it\u2019s not the right size or there\u2019s any faults, let us know within 100 days and we\u2019ll make it right.';

        ph += policyAccordion('100-Day Perfect Fit Guarantee', guaranteeBody, false);
        ph += policyAccordion('Terms &amp; Conditions', termsBody, false);
        ph += policyAccordion('Shipping &amp; Processing', shippingBody, true);

        policiesMount.innerHTML = ph;
        var cartView2 = document.getElementById('set-cart-view');
        if (cartView2) cartView2.appendChild(policiesMount);
      }
    } catch(e) { console.warn('[scv] failed to mount policies', e); }

    // ── Wire events ──

    // ── Free-shipping offer wiring ──
    if (window.__scvFreeshipTimer) { clearInterval(window.__scvFreeshipTimer); window.__scvFreeshipTimer = null; }
    var freeshipFormEl = document.getElementById('scv-freeship-offer');
    var freeshipAppliedEl = document.getElementById('scv-freeship-applied');

    function freeshipTickForm() {
      var startedAt = parseInt(lsGet(FREESHIP_LS_OFFER_STARTED) || '0', 10);
      if (!startedAt) {
        startedAt = Date.now();
        lsSet(FREESHIP_LS_OFFER_STARTED, String(startedAt));
      }
      var remaining = (startedAt + FREESHIP_TIMER_MS) - Date.now();
      var t = document.getElementById('scv-freeship-timer');
      if (t) t.textContent = freeshipFmtCountdown(remaining);
      if (remaining <= 0) {
        lsSet(FREESHIP_LS_OFFER_EXPIRED, '1');
        if (window.__scvFreeshipTimer) { clearInterval(window.__scvFreeshipTimer); window.__scvFreeshipTimer = null; }
        if (freeshipFormEl && freeshipFormEl.parentNode) freeshipFormEl.parentNode.removeChild(freeshipFormEl);
      }
    }

    function freeshipTickApplied() {
      var appliedEl = document.getElementById('scv-freeship-applied');
      // If already in grace (initial render decided so), no work + don't keep ticking.
      if (!appliedEl || appliedEl.getAttribute('data-state') === 'grace') {
        if (window.__scvFreeshipTimer) { clearInterval(window.__scvFreeshipTimer); window.__scvFreeshipTimer = null; }
        return;
      }
      var unlockedAt = parseInt((cart.attributes && cart.attributes[FREESHIP_ATTR_UNLOCKED]) || '0', 10);
      var remaining = (unlockedAt + FREESHIP_TIMER_MS) - Date.now();
      var t = document.getElementById('scv-freeship-applied-timer');
      if (t) t.textContent = remaining > 0 ? freeshipFmtCountdown(remaining) : '00:00';
      // Crossed 0 — swap the strip to grace state in place, do NOT re-render the cart
      // (a full re-render here causes an infinite loop because the new render sets up
      // this same tick which re-fires the swap).
      if (remaining <= 0) {
        if (window.__scvFreeshipTimer) { clearInterval(window.__scvFreeshipTimer); window.__scvFreeshipTimer = null; }
        appliedEl.outerHTML = '<div id="scv-freeship-applied" data-state="grace" style="margin:8px 0 16px;padding:0;font-family:system-ui,-apple-system,sans-serif;font-size:11px;font-style:italic;color:#6b7280;line-height:1.5;text-align:left;">your free shipping expired, but don’t worry — we got you.<br>free shipping for your ' + freeShipSetQty() + ' piece set will apply for 24 hours</div>';
      }
    }

    if (freeshipFormEl) {
      freeshipTickForm();
      window.__scvFreeshipTimer = setInterval(freeshipTickForm, 1000);

      var submitBtn = document.getElementById('scv-freeship-submit');
      var emailInput = document.getElementById('scv-freeship-email');
      var phoneInput = document.getElementById('scv-freeship-phone');
      var errEl = document.getElementById('scv-freeship-error');
      function showFreeshipError(msg) {
        if (!errEl) return;
        errEl.textContent = msg;
        errEl.style.display = 'block';
      }
      function clearFreeshipError() {
        if (errEl) { errEl.textContent = ''; errEl.style.display = 'none'; }
      }
      submitBtn.addEventListener('click', function() {
        clearFreeshipError();
        var email = (emailInput.value || '').trim();
        var phoneE164 = normalizePhoneE164(phoneInput.value);
        if (!isValidEmail(email)) { showFreeshipError('Please enter a valid email.'); return; }
        if (!phoneE164 || phoneE164.length < 8) { showFreeshipError('Please enter a valid phone number.'); return; }
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.6';
        submitBtn.textContent = 'Unlocking...';
        var now = Date.now();
        // Pre-fetch UGC for the cart products so Klaviyo emails can render real-mum imagery
        var __ugcPids = (cart.items || []).map(function(i){ return i && i.product_id; }).filter(Boolean);
        var __ugcSizes = (userBaseSizes && userBaseSizes.length) ? userBaseSizes : (userSize ? [userSize] : []);
        var __ugcPromise = Promise.race([
          fetchUgcForSet(__ugcPids, __ugcSizes).catch(function(){ return []; }),
          new Promise(function(res){ setTimeout(function(){ res([]); }, 2000); })
        ]).then(function(ugcItems){
          // Build product_id → first photo URL map (skip videos — emails don't render them well).
          var byPid = {};
          (ugcItems || []).forEach(function(u){
            if (!u || u.type === 'reel' || u.type === 'video') return;
            var prods = u.products || [];
            prods.forEach(function(p){
              var pid = String((p && (p.id || p.product_id)) || '');
              if (pid && !byPid[pid]) byPid[pid] = resolveUrl(u.url);
            });
          });
          return byPid;
        });

        // All three calls fire (mostly) in parallel — none block the unlock.
        freeshipKlaviyoSubscribe(email, phoneE164).catch(function(e) { console.warn('[scv freeship] klaviyo subscribe failed', e); });
        __ugcPromise.then(function(ugcByProductId){
          freeshipKlaviyoFireUnlockEvent(email, phoneE164, now, cart, {
            stage: stage,
            user_size: userSize,
            user_base_sizes: userBaseSizes || [],
            ugcByProductId: ugcByProductId
          }).catch(function(e) { console.warn('[scv freeship] klaviyo event failed', e); });
        });
        freeshipWriteCartAttrs(email, phoneE164, now)
          .then(function() {
            lsSet(FREESHIP_LS_USED, '1');
            loadAndRender();
          })
          .catch(function(e) {
            console.warn('[scv freeship] cart update failed', e);
            submitBtn.disabled = false;
            submitBtn.style.opacity = '1';
            submitBtn.textContent = 'Unlock Free Shipping';
            showFreeshipError('Something went wrong. Please try again.');
          });
      });
    } else if (freeshipAppliedEl) {
      freeshipTickApplied();
      window.__scvFreeshipTimer = setInterval(freeshipTickApplied, 1000);
    }

    // Stage picker (removed - stage buttons hidden)
    inner.querySelectorAll('.scv-stage').forEach(function(btn) {
      btn.addEventListener('click', function() {
        userStageOverride = btn.getAttribute('data-stage');
        loadAndRender();
      });
    });

    // Qty buttons — no global disable lock.  Read current qty from cartCache
    // (which the optimistic helper mutates synchronously) so rapid clicks
    // compute the right delta off the latest known state.
    inner.querySelectorAll('.scv-qty').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-key');
        var delta = parseInt(btn.getAttribute('data-delta'), 10);
        var src = (cartCache && cartCache.items) || cart.items;
        var item = src.find(function(it) { return it.key === key; });
        if (!item) return;
        var newQty = Math.max(0, item.quantity + delta);
        if (typeof window.__scvEmit === 'function') {
          window.__scvEmit(newQty === 0 ? 'wardrobe_item_removed' : 'wardrobe_qty_changed', Object.assign({}, __scvCtxNow || {}, {
            product_id: item.product_id || '',
            variant_id: item.variant_id || '',
            product_title: item.product_title || '',
            from_qty: item.quantity || 0,
            to_qty: newQty
          }), { cart_value: currentTotal, cart_units: itemCount });
        }
        changeQty(key, newQty);
      });
    });

    // Remove buttons
    inner.querySelectorAll('.scv-remove').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-key');
        if (typeof window.__scvEmit === 'function') {
          var src = (cartCache && cartCache.items) || cart.items;
          var item = src.find(function(it) { return it.key === key; }) || {};
          window.__scvEmit('wardrobe_item_removed', Object.assign({}, __scvCtxNow || {}, {
            product_id: item.product_id || '',
            variant_id: item.variant_id || '',
            product_title: item.product_title || '',
            from_qty: item.quantity || 0,
            to_qty: 0
          }), { cart_value: currentTotal, cart_units: itemCount });
        }
        btn.textContent = '...';
        changeQty(key, 0);
      });
    });

    // Cart note — save on blur
    var noteEl = document.getElementById('scv-cart-note');
    if (noteEl) {
      noteEl.addEventListener('blur', function() {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: noteEl.value })
        });
      });
    }

    // Checkout buttons (multiple)
    inner.querySelectorAll('.scv-checkout-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (typeof window.__scvEmit === 'function') window.__scvEmit('wardrobe_checkout_clicked', __scvCtxNow || {}, { cart_value: currentTotal, cart_units: itemCount });
        var note = document.getElementById('scv-cart-note');
        if (note && note.value !== (cart.note || '')) {
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: note.value })
          }).then(function() { window.location.href = '/checkout'; });
        } else {
          window.location.href = '/checkout';
        }
      });
    });

    // ── Primary checkout button click ──
    var primaryCheckoutBtn = inner.querySelector('#scv-primary-checkout');
    if (primaryCheckoutBtn && !primaryCheckoutBtn.__scvBound) {
      primaryCheckoutBtn.__scvBound = true;
      primaryCheckoutBtn.addEventListener('click', function() {
        if (typeof window.__scvEmit === 'function') window.__scvEmit('wardrobe_checkout_clicked', __scvCtxNow || {}, { cart_value: currentTotal, cart_units: itemCount });
        var note = document.getElementById('scv-cart-note');
        if (note && note.value !== (cart.note || '')) {
          fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }).then(function(){ window.location.href = '/checkout'; });
        } else {
          window.location.href = '/checkout';
        }
      });
    }

    // Persist customise (.scv-pack-details) open/close state across re-renders.
    document.querySelectorAll('.scv-pack-details').forEach(function(det){
      if (det.__scvBound) return;
      det.__scvBound = true;
      det.addEventListener('toggle', function(){
        window.__scvSetExpanded = !!det.open;
        if (typeof window.__scvEmit === 'function') window.__scvEmit(det.open ? 'wardrobe_set_expanded' : 'wardrobe_set_collapsed', __scvCtxNow || {}, { cart_value: currentTotal, cart_units: itemCount });
      });
    });

    // ── Forming-set sub-group accordion toggle ──
    window.__scvOpenJourneys = window.__scvOpenJourneys || {};
    document.querySelectorAll('.scv-subgroup-acc').forEach(function(acc) {
      if (acc.__scvBound) return;
      acc.__scvBound = true;
      acc.addEventListener('click', function(e) {
        var isOpen = acc.getAttribute('data-open') === 'true';
        var btn = acc.querySelector('.scv-subgroup-toggle');
        var jKey = acc.getAttribute('data-journey');
        if (!isOpen) {
          // Closed: any click expands the section. Block the navigation that
          // would otherwise fire from product-image <a> wrappers.
          e.preventDefault();
          acc.setAttribute('data-open', 'true');
          if (btn) btn.setAttribute('aria-expanded', 'true');
          if (jKey) window.__scvOpenJourneys[jKey] = true;
          if (typeof window.__scvEmit === 'function') window.__scvEmit('wardrobe_set_expanded', Object.assign({}, __scvCtxNow || {}, { journey_key: jKey || '' }), { cart_value: currentTotal, cart_units: itemCount });
          return;
        }
        // Open: only the heading toggle button collapses it.
        var toggle = e.target.closest('.scv-subgroup-toggle');
        if (toggle) {
          e.preventDefault();
          acc.setAttribute('data-open', 'false');
          toggle.setAttribute('aria-expanded', 'false');
          if (jKey) delete window.__scvOpenJourneys[jKey];
          if (typeof window.__scvEmit === 'function') window.__scvEmit('wardrobe_set_collapsed', Object.assign({}, __scvCtxNow || {}, { journey_key: jKey || '' }), { cart_value: currentTotal, cart_units: itemCount });
        }
        // Any other click (image link, qty stepper, mums-wearing link)
        // passes through to existing handlers.
      });
    });

    // ── "tap to see mums wearing this item" → UGC modal (cart rows + ghost rows) ──
    document.querySelectorAll('.scv-mums-wearing').forEach(function(btn) {
      if (btn.__scvBound) return;
      btn.__scvBound = true;
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var productId = btn.getAttribute('data-product-id');
        var size = btn.getAttribute('data-size');
        var title = btn.getAttribute('data-title') || '';
        if (!productId) return;
        openUgcForProduct(productId, size, title);
      });
    });

    // ── Set-level UGC: rotating circle of real mums + count + tap to open feed ──
    inner.querySelectorAll('[data-set-mums]').forEach(function(el) {
      if (el.__scvBound) return;
      el.__scvBound = true;
      var pids = (el.getAttribute('data-product-ids') || '').split(',').filter(Boolean);
      var sizes = getCartBaseSizes(cart.items);
      if (!pids.length) return;
      fetchUgcForSet(pids, sizes).then(function(items) {
        var n = items ? items.length : 0;
        if (!n) { el.hidden = true; return; }
        var countEl = el.querySelector('[data-mums-count]');
        if (countEl) countEl.textContent = n;
        el.hidden = false;
        // Click anywhere on the row opens the modal — bigger affordance than just an arrow.
        el.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          showUgcModal(items, 'Your set');
        });
        // Build rotating slideshow inside the circle. Sort videos first so the
        // circle leads with motion — matches the modal which also surfaces videos
        // before images. Take the top 6 to keep memory + autoplay budget sane.
        var __vids = items.filter(function(it) { return it.type === 'reel' || it.type === 'video'; });
        var __imgs = items.filter(function(it) { return it.type !== 'reel' && it.type !== 'video'; });
        var __sortedForCircle = __vids.concat(__imgs);
        var circle = el.querySelector('.scv-mums-circle');
        if (circle) buildMumsCircleSlideshow(circle, __sortedForCircle.slice(0, 6));
        // Populate per-item mini circles by fetching UGC per product using
        var fieldset = el.closest('fieldset[data-set-box]');
        if (fieldset) {
          fieldset.querySelectorAll('.scv-mini-circle[data-product-id]').forEach(function(mc) {
            var pid = String(mc.getAttribute('data-product-id') || '');
            if (!pid) return;
            fetchUgcForProductMini(pid).then(function(matches) {
              if (!matches || !matches.length) {
                var row = mc.closest('.scv-set-row-ugc');
                if (row) row.style.display = 'none';
                return;
              }
              var mv = matches.filter(function(u) { return u.type === 'reel' || u.type === 'video'; });
              var mi = matches.filter(function(u) { return u.type !== 'reel' && u.type !== 'video'; });
              buildMumsCircleSlideshow(mc, mv.concat(mi).slice(0, 6));
            });
          });
        }
        // Auto-fit both copy lines to the available width — runs after a frame
        // so layout has settled, plus on window resize (debounced).
        requestAnimationFrame(function() {
          fitMumsTextOneLine(el);
        });
      });
    });
    // Auto-fit headline + sub-line to one row by shrinking font-size until
    function fitMumsTextOneLine(mumsEl) {
      if (!mumsEl) return;
      [['.scv-mums-copy', 14, 9], ['.scv-mums-sub', 12, 8]].forEach(function(cfg) {
        var el = mumsEl.querySelector(cfg[0]);
        if (!el) return;
        var max = cfg[1], min = cfg[2];
        el.style.fontSize = max + 'px';
        var cur = max, safety = 40;
        while (el.scrollWidth > el.clientWidth && cur > min && safety-- > 0) {
          cur -= 0.5;
          el.style.fontSize = cur + 'px';
        }
      });
    }
    // Re-fit on resize (rotate phone, resize window). Debounced so we don't
    // thrash. One handler covers every row currently in the DOM.
    if (!window.__scvMumsResizeBound) {
      window.__scvMumsResizeBound = true;
      var __scvMumsResizeTimer = null;
      window.addEventListener('resize', function() {
        if (__scvMumsResizeTimer) clearTimeout(__scvMumsResizeTimer);
        __scvMumsResizeTimer = setTimeout(function() {
          document.querySelectorAll('.scv-pack-mums:not([hidden])').forEach(function(row) {
            fitMumsTextOneLine(row);
          });
        }, 150);
      });
    }
    // Helper: build a crossfade slideshow inside `container` from `items`.
    // Cycles 3s per slide. IntersectionObserver pauses + freezes when offscreen.
    function buildMumsCircleSlideshow(container, items) {
      if (!container || !items || !items.length) return;
      if (container.__scvSlideshow) return; // idempotent
      container.__scvSlideshow = true;
      var slides = items.map(function(it) {
        var isV = it.type === 'reel' || it.type === 'video';
        var url = resolveUrl(it.url);
        var poster = resolveUrl(it.posterUrl);
        var node;
        if (isV) {
          node = document.createElement('video');
          node.src = url;
          if (poster) node.poster = poster;
          node.muted = true;
          node.defaultMuted = true;
          node.loop = false;
          node.playsInline = true;
          node.setAttribute('playsinline', '');
          node.setAttribute('webkit-playsinline', '');
          node.setAttribute('muted', '');
          node.preload = 'metadata';
        } else {
          node = document.createElement('img');
          node.src = url;
          node.alt = '';
          node.loading = 'lazy';
        }
        node.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity 220ms ease;';
        container.appendChild(node);
        return node;
      });
      // Show first frame immediately so the circle is never empty.
      slides[0].style.opacity = '1';
      if (slides[0].tagName === 'VIDEO') { try { slides[0].play(); } catch(e) {} }
      if (slides.length <= 1) return; // single item — no rotation
      var idx = 0;
      var timer = null;
      function advance() {
        var cur = slides[idx];
        var nextIdx = (idx + 1) % slides.length;
        var next = slides[nextIdx];
        if (cur) {
          cur.style.opacity = '0';
          if (cur.tagName === 'VIDEO') { try { cur.pause(); cur.currentTime = 0; } catch(e) {} }
        }
        if (next) {
          next.style.opacity = '1';
          if (next.tagName === 'VIDEO') { try { next.play(); } catch(e) {} }
        }
        idx = nextIdx;
      }
      function start() {
        if (timer) return;
        // Play current video if it had been paused while offscreen.
        var cur = slides[idx];
        if (cur && cur.tagName === 'VIDEO') { try { cur.play(); } catch(e) {} }
        timer = setInterval(advance, 3000);
      }
      function stop() {
        if (timer) { clearInterval(timer); timer = null; }
        slides.forEach(function(s) { if (s.tagName === 'VIDEO') { try { s.pause(); } catch(e) {} } });
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function(entries) {
          entries.forEach(function(e) {
            if (e.isIntersecting) start(); else stop();
          });
        }, { threshold: 0.1 });
        io.observe(container);
      } else {
        start();
      }
    }

    // ── Ghost items (async) ──
    // Determine how many items needed for next level
    var levels = cartRungQtys();
    var nextLevel = null;
    for (var li = 0; li < levels.length; li++) {
      if (itemCount < levels[li]) { nextLevel = levels[li]; break; }
    }
    var slotsToFill = nextLevel ? nextLevel - itemCount : 0;

    if (slotsToFill > 0) {
      var ghostProducts = getGhostProducts(stage, tier, cart.items);

      if (ghostProducts.length) {
        // Render token: each render() bumps this. Async resolves only write to DOM if their
        // captured token still equals the current one — prevents a stale (older-stage) resolve
        // from overwriting a fresher render's upsell zone.
        var myUpsellToken = ++__upsellRenderToken;
        var resolvePromise;
        if (window.EmmacoProductResolver) {
          // Pass all sizes the user wears (from non-PP cart items). Resolver auto-shifts UP for
          // post-partum products (recovery / nursing) so the user's M maternity → L recovery.
          resolvePromise = window.EmmacoProductResolver.resolveSet(ghostProducts, {
            sizes: userBaseSizes,
            sizeUpForPostPartum: true,
            sizeUpAmount: 1
          });
        } else {
          resolvePromise = Promise.resolve(ghostProducts.map(function(p) {
            return { handle: p.handle, originalHandle: p.handle, name: p.name, image: p.image, qty: p.qty, variantId: null };
          }));
        }

        resolvePromise.then(function(resolved) {
          // Skip stale resolves: if a newer render() has bumped the token, this promise was
          // started against an older cart/stage and would overwrite the fresh upsell zone.
          if (myUpsellToken !== __upsellRenderToken) return;

          // Filter to products with a resolved variantId — i.e. user's size is available.
          // Resolver returns null/empty variantId when the product has no variant in user's size.
          resolved = (resolved || []).filter(function(m) { return m && m.variantId && m.source === 'stock' && !(typeof window.__scvSkuInStock === 'function' && window.__scvSkuInStock(m.sku) === false); }); // suggestions ship now — never pre-order (29 Jul)

          // Dedup by RESOLVED handle (fallback chains can route two different ghost products to
          // the same final handle) + exclude any handle already in cart (resolved fallback may
          // collide with a cart line whose original ghost handle was different).
          var __cartHandlesNow = {};
          cart.items.forEach(function(__it){ if (__it.handle) __cartHandlesNow[__it.handle] = true; });
          var __seenResolved = {};
          resolved = resolved.filter(function(m) {
            var h = m.handle || m.originalHandle;
            if (!h) return false;
            if (__cartHandlesNow[h]) return false;
            if (__seenResolved[h]) return false;
            __seenResolved[h] = true;
            return true;
          });

          if (!resolved.length) return;
          if (typeof window.__scvEmit === 'function') {
            window.__scvEmit('wardrobe_recommendations_shown', Object.assign({}, __scvCtxNow || {}, {
              next_tier: nextLevel ? String(nextLevel) : '',
              slots_to_fill: slotsToFill,
              recommended_handles: resolved.map(function(m){ return m.handle || m.originalHandle || ''; }).filter(Boolean).join(',')
            }), { cart_value: currentTotal, cart_units: itemCount });
          }

          // Stage-aware heading uses the same MUM_LOWER/MUM_PLURAL the cart's set
          // celebration copy uses (US/CA → "mom", everywhere else → "mum").
          var headingByStage = {
            pregnant:   'what our ' + MUM_PLURAL + ' WISH they had more of',
            postpartum: 'what our ' + MUM_PLURAL + ' wear post partum. on repeat. 24/7',
            mum:        'our ' + MUM_PLURAL + ' wear THESE for everything. kids, pets, school runs, work, workouts, hangs, bed.'
          };
          var upsellHeading = headingByStage[stage] || (MUM_PLURAL + ' also add');

          // Heading + horizontal carousel of cards.  Product links inside the
          var gh = '<div data-row-upsell-section style="padding:20px 0 0;">';
          gh += '<div data-row-upsell-heading style="font-size:13px;font-weight:600;color:#1f2937;letter-spacing:0.06em;padding:0 0 12px 0;">' + upsellHeading + '</div>';
          gh += '<div data-row-upsell-track style="display:flex;gap:10px;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;padding:2px 2px 8px 2px;">';

          // Find original ghost data for desc/rrp/productId
          var ghostDataMap = {};
          ghostProducts.forEach(function(gp) { ghostDataMap[gp.handle] = gp; });

          // Uniform tier price across all upsell cards: assume user adds 1 of any one of these (matches discount-function reality once cart is recalc'd).
          // Clamp to cart's avg variant ceiling so qty 1-4 (where US tier = $999 no-op) renders the actual variant price.
          var __upsellAvgVariant = avgBundleVariantPrice(cart);
          var perItemFlash = Math.ceil(clampToVariant(priceForQty(itemCount + 1), __upsellAvgVariant));
          resolved.forEach(function(m) {
            var vid = m.variantId || '';
            var pNote = (m.preorderNote || '').replace(/"/g, '&quot;');
            var orig = ghostDataMap[m.originalHandle || m.handle] || {};
            var rrpFull = Math.ceil(orig.rrp || 0);
            var pId = orig.productId || '';
            var gHandle = m.handle || m.originalHandle || '';
            // Card: no fixed height; sizes to content. Title gets line-clamp+min-height so all cards align uniformly.
            gh += '<div data-row-upsell-card style="flex:0 0 auto;width:170px;border:1px solid #f3f4f6;display:flex;flex-direction:column;scroll-snap-align:start;">';
            if (m.image) gh += '<a href="/products/' + gHandle + '" style="display:block;line-height:0;flex-shrink:0;"><img src="' + m.image + '" style="width:100%;height:225px;object-fit:cover;display:block;cursor:pointer;"></a>';
            gh += '<div data-row-upsell-info style="padding:10px 8px;display:flex;flex-direction:column;gap:6px;">';
            // Title — clamped to 2 lines, min-height 2 lines so all cards share the same content height
            gh += '<a href="/products/' + gHandle + '" style="text-decoration:none;color:inherit;display:block;"><div style="font-family:var(--font-heading-family,system-ui,-apple-system,sans-serif);font-size:14px;font-weight:500;color:#1f2937;line-height:1.2;letter-spacing:-0.01em;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:34px;">' + m.name + '</div></a>';
            // Tagline (custom.product_tagline metafield) — small italic feature subtitle
            var __tagline = localizeMum((orig.tagline || '').trim());
            if (__tagline) {
              gh += '<div data-row-upsell-tagline style="font-size:11px;font-style:italic;color:#6b7280;line-height:1.3;letter-spacing:0.01em;min-height:14px;">' + __tagline + '</div>';
            }
            // Button now ABOVE price line. If adding this 1 item drops the per-item tier price, the price line shows the tier-drop callout.
            gh += '<button type="button" class="scv-ghost-add" data-variant-id="' + vid + '" data-qty="' + m.qty + '" data-preorder="' + pNote + '" data-handle="' + gHandle + '" data-title="' + String(m.name || '').replace(/"/g, '&quot;') + '" style="padding:8px 0;background:none;color:#000;border:none;font-size:13px;font-weight:800;letter-spacing:0.04em;text-transform:uppercase;cursor:pointer;font-family:system-ui,-apple-system,sans-serif;width:100%;text-align:center;">ADD TO MY SET</button>';
            // Price line — depends on whether adding 1 item creates a new (lower) effective tier
            var __nextTierPrice = clampToVariant(priceForQty(bundleQty + 1), __upsellAvgVariant);
            var __currentTierPrice = clampToVariant(priceForQty(bundleQty), __upsellAvgVariant);
            var __dropsTier = bundleQty > 0 && __nextTierPrice < __currentTierPrice;
            if (__dropsTier) {
              gh += '<div data-row-upsell-price style="display:flex;flex-direction:column;align-items:center;gap:1px;text-align:center;">';
              gh += '<span style="font-size:13px;font-weight:700;color:#1f2937;">Add to my set ' + S + Math.ceil(__nextTierPrice) + '</span>';
              gh += '<span style="font-size:10px;color:#3D9A8B;font-style:italic;">(drops price per item)</span>';
              gh += '</div>';
            } else {
              gh += '<div data-row-upsell-price style="display:flex;align-items:baseline;justify-content:center;gap:6px;flex-wrap:wrap;">';
              gh += '<span style="font-size:11px;color:#6b7280;font-style:italic;">flash sale</span>';
              if (rrpFull > perItemFlash) {
                gh += '<span style="font-size:11px;color:#9ca3af;text-decoration:line-through;">' + S + rrpFull + '</span>';
              }
              gh += '<span style="font-size:13px;font-weight:700;color:#1f2937;">' + S + perItemFlash + '</span>';
              gh += '</div>';
            }
            gh += '</div>'; // close info
            gh += '</div>'; // close card
          });
          gh += '</div>'; // close track
          gh += '</div>'; // close section


          var ghostZone = document.getElementById('scv-ghost-zone');
          if (ghostZone) {
            ghostZone.innerHTML = gh;

            // Wire .scv-mums-wearing buttons in ghost zone (cart row buttons are wired by the global handler)
            ghostZone.querySelectorAll('.scv-mums-wearing').forEach(function(btn) {
              if (btn.__scvBound) return;
              btn.__scvBound = true;
              btn.addEventListener('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                var productId = btn.getAttribute('data-product-id');
                var size = btn.getAttribute('data-size');
                var title = btn.getAttribute('data-title') || '';
                if (productId) openUgcForProduct(productId, size, title);
              });
            });

            // Wire individual ghost add
            ghostZone.querySelectorAll('.scv-ghost-add').forEach(function(btn) {
              btn.addEventListener('click', function() {
                var vid = btn.getAttribute('data-variant-id');
                var qty = parseInt(btn.getAttribute('data-qty'), 10);
                var pNote = btn.getAttribute('data-preorder');
                var handle = btn.getAttribute('data-handle') || '';
                if (!vid) return;
                if (typeof window.__scvEmit === 'function') {
                  window.__scvEmit('wardrobe_recommendation_clicked', Object.assign({}, __scvCtxNow || {}, { recommendation_handle: handle, next_tier: nextLevel ? String(nextLevel) : '' }), { cart_value: currentTotal, cart_units: itemCount });
                  window.__scvEmit('wardrobe_add_to_set_clicked', Object.assign({}, __scvCtxNow || {}, { recommendation_handle: handle, next_tier: nextLevel ? String(nextLevel) : '' }), { cart_value: currentTotal, cart_units: itemCount });
                }
                btn.textContent = 'Adding...';
                btn.disabled = true;
                var item = { id: Number(vid), quantity: qty };
                if (pNote) item.properties = { "Ships": pNote };
                addItems([item], function(){
                  if (typeof window.__scvEmit === 'function') window.__scvEmit('wardrobe_add_to_set_succeeded', Object.assign({}, __scvCtxNow || {}, { recommendation_handle: handle, next_tier: nextLevel ? String(nextLevel) : '' }), { cart_value: currentTotal, cart_units: itemCount + qty });
                  loadAndRender();
                });
              });
            });

            // Wire add-all
            var addAllBtn = document.getElementById('scv-add-all');
            if (addAllBtn) {
              addAllBtn.addEventListener('click', function() {
                addAllBtn.textContent = 'Adding...';
                addAllBtn.disabled = true;
                if (typeof window.__scvEmit === 'function') window.__scvEmit('wardrobe_add_to_set_clicked', Object.assign({}, __scvCtxNow || {}, { add_all: true, next_tier: nextLevel ? String(nextLevel) : '' }), { cart_value: currentTotal, cart_units: itemCount });
                var items = [];
                ghostZone.querySelectorAll('.scv-ghost-add').forEach(function(b) {
                  var vid = b.getAttribute('data-variant-id');
                  var qty = parseInt(b.getAttribute('data-qty'), 10);
                  var pNote = b.getAttribute('data-preorder');
                  if (vid) {
                    var item = { id: Number(vid), quantity: qty };
                    if (pNote) item.properties = { "Ships": pNote };
                    items.push(item);
                  }
                });
                if (items.length) addItems(items, function(){
                  if (typeof window.__scvEmit === 'function') window.__scvEmit('wardrobe_add_to_set_succeeded', Object.assign({}, __scvCtxNow || {}, { add_all: true, next_tier: nextLevel ? String(nextLevel) : '' }), { cart_value: currentTotal, cart_units: itemCount + items.length });
                  loadAndRender();
                });
              });
            }
          }
        });
      }
    }
  }

  // ── Cart-state cache (Phase 2 perf) ──
  var cartCache = null;
  var cartCacheKey = '';
  window.__scvBustCartCache = function() { cartCache = null; cartCacheKey = ''; };
  window.__scvGetCart = function() { return cartCache; };
  function fetchCart() {
    return fetch('/cart.js?_=' + Date.now(), { cache: 'no-store' }).then(function(r) { return r.json(); });
  }

  // ── PDP/collection progress sticky ──
  // Home SPA-PDP lives at "/" (v2NoPushState) so the old /products|
  // /collections gate kept the pill dark on the highest-traffic surface.
  function _scvIsShoppingSurface() {
    var path = location.pathname || '';
    if (path.indexOf('/products/') === 0 || path.indexOf('/collections/') === 0) return true;
    if (window.v2HomeMode === true) return true;
    if (document.getElementById('home-spa-pdp')) return true;
    return false;
  }

  function renderProgressSticky() {
    if (!_scvIsShoppingSurface()) return;

    var sticky = document.getElementById('scv-progress-sticky');
    if (!sticky) {
      sticky = document.createElement('div');
      sticky.id = 'scv-progress-sticky';
      sticky.setAttribute('role', 'button');
      sticky.setAttribute('aria-label', 'Open cart');
      sticky.addEventListener('click', function(){
        // Empty cart → route to the pack builder. Architecture-driven, not URL:
        //   Home renders em-ugc-section INLINE (no slideout exists)  → scroll to it.
        //   PDP/collection renders em-ugc-section INSIDE #pack-builder-slideout
        //     (off-canvas drawer, no inline copy)                    → open the slideout.
        //   Neither rendered, or cart has items                       → open the cart drawer.
        var qty = 0;
        if (cartCache && cartCache.items) cartCache.items.forEach(function(it){ qty += it.quantity; });
        if (qty === 0) {
          // Inline = an em-ugc-section that is NOT inside the slideout drawer.
          var inline = null;
          var allSec = document.querySelectorAll('#em-ugc-section');
          for (var i = 0; i < allSec.length; i++) {
            if (!allSec[i].closest('#pack-builder-slideout')) { inline = allSec[i]; break; }
          }
          if (inline) {
            inline.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
          }
          if (document.getElementById('pack-builder-slideout')) {
            window.dispatchEvent(new CustomEvent('scv:openPackBuilder', { detail: { stage: _scvStageCat() } }));
            return;
          }
        }
        window.dispatchEvent(new CustomEvent('scv:open'));
      });
      document.body.appendChild(sticky);
    }

    if (!cartCache) { sticky.classList.remove('scv-show'); return; }

    var qty = 0;
    (cartCache.items || []).forEach(function(it) { qty += it.quantity; });

    // Compute the stage label for the empty-cart CTA. Order of preference:
    function _scvStageLabel() {
      var isUSCA = (window.Shopify && window.Shopify.country &&
        (window.Shopify.country.iso_code === 'US' || window.Shopify.country.iso_code === 'CA'));
      var defaultMum = isUSCA ? 'MOM' : 'MUM';
      // SPA-accurate first (see _scvStageCat) — title/path can't be trusted
      // on the home SPA. pdpLifestage 'mum' has no maternity/postpartum
      // signal so fall through to keep the SHAPEWEAR/default nuance.
      var ls = (window.pdpMeta && window.pdpMeta.pdpLifestage) || window.pdpLifestage || '';
      if (ls === 'pregnant')   return 'MATERNITY';
      if (ls === 'postpartum') return 'POSTPARTUM';
      var titleEl = document.getElementById('v2-title-name');
      var t = '';
      if (titleEl && titleEl.textContent) t = titleEl.textContent.toLowerCase();
      else if (typeof window.pdpTitle === 'string') t = window.pdpTitle.toLowerCase();
      else t = (location.pathname.match(/\/products\/([^\/?#]+)/) || [,''])[1].toLowerCase();
      if (t) {
        if (t.indexOf('shapewear') >= 0) return 'SHAPEWEAR';
        if (t.indexOf('maternity') >= 0 || t.indexOf('pregnancy') >= 0) return 'MATERNITY';
        if (t.indexOf('recovery') >= 0 || t.indexOf('nursing') >= 0 || t.indexOf('post') >= 0) return 'POSTPARTUM';
      }
      var path = location.pathname.toLowerCase();
      if (path.indexOf('/collections/') === 0) {
        if (path.indexOf('shapewear') >= 0) return 'SHAPEWEAR';
        if (path.indexOf('maternity') >= 0) return 'MATERNITY';
        if (path.indexOf('postpartum') >= 0 || path.indexOf('recovery') >= 0 || path.indexOf('nursing') >= 0) return 'POSTPARTUM';
      }
      return defaultMum;
    }
    // Pill persists at every qty (incl. 5+) so it stays a one-tap path back
    // to the slideout bag. 0–4 = build momentum; 5/7/9 = reward; 6/8 = soft
    // next-tier bonus. (Previously hid at 5+, losing both bag access + the
    // 7/9 AOV tiers.)

    var __rungs = cartRungQtys();
    var __firstRung = __rungs[0];
    var slots = [];
    cartCache.items.forEach(function(it) {
      if (slots.length >= __firstRung) return;
      var img = it.image || '';
      for (var i = 0; i < it.quantity && slots.length < __firstRung; i++) slots.push(img);
    });
    var html = '<div class="scv-progress-row">';
    for (var i = 0; i < __firstRung; i++) {
      if (i > 0) html += '<span class="scv-pg-bar"></span>';
      if (slots[i]) html += '<span class="scv-pg-slot scv-pg-filled"><img src="' + slots[i] + '" alt=""></span>';
      else          html += '<span class="scv-pg-slot scv-pg-empty"></span>';
    }
    html += '</div>';

    var labelText, labelClass = 'scv-progress-label';
    if (qty === 0) {
      // Empty cart — pack-builder entry CTA (Mark's copy, 24 Aug: savings
      // framing, no price figure — it was competing with the single-item
      // ATC in the buy box). Locale-aware mum/mom via MUM_LOWER.
      sticky.classList.add('scv-empty');
      labelClass += ' scv-pg-empty-cta';
      labelText = 'get our ' + MUM_LOWER + ' set and save more →';
    } else {
      sticky.classList.remove('scv-empty');
      if (qty < __firstRung - 1) {
        labelText = qty + '/' + __firstRung + ' items in your bag →';
      } else if (qty === __firstRung - 1) {
        labelText = '+ 1 more, unlock set price →';
      } else {
        // At or past the first rung — set complete. Reward at exact rungs,
        // soft next-rung bonus between them. Calm ✓ confirmation (no
        // pressure arrow) for rewards; one actionable → for bonuses.
        var __sw = _scvStageLabel().toLowerCase();
        var __saved = _scvSavedAtQty(qty);
        var __svTxt = __saved ? (' · saved ' + S + __saved) : '';
        var __pt = getTier(qty);
        if (__rungs.indexOf(qty) >= 0) {
          labelText = '✓ ' + qty + '-piece ' + __sw + ' set complete' + __svTxt;
        } else if (__pt.next) {
          var __nextSave = _scvSavedAtQty(__pt.next);
          labelText = '✓ set complete · add ' + (__pt.next - qty) + ' for the ' + __pt.next + '-piece price'
            + (__nextSave ? ' (save ' + S + __nextSave + ')' : '') + ' →';
        } else {
          // Past the deepest rung; pure max-saving confirmation.
          labelText = '✓ ' + __sw + ' set · maximum saving' + __svTxt;
        }
      }
    }
    html += '<span class="' + labelClass + '">' + labelText + '</span>';
    sticky.innerHTML = html;
    // Two-column shrink-to-fit: when circles are visible, shrink the label
    // font until its wrapped column fits the circle-row height, so the pill
    // never grows taller than the circles and text never drops under them.
    // Skipped for the empty-cart CTA (scv-empty) which is intentionally a
    // larger 2-line block with no circles.
    if (!sticky.classList.contains('scv-empty')) {
      var __fitLbl = sticky.querySelector('.scv-progress-label');
      var __fitRow = sticky.querySelector('.scv-progress-row');
      if (__fitLbl && __fitRow) {
        requestAnimationFrame(function(){
          var __cap = __fitRow.offsetHeight || 32;
          var __fs = 13;
          __fitLbl.style.fontSize = __fs + 'px';
          while (__fitLbl.scrollHeight > __cap + 1 && __fs > 9) {
            __fs -= 0.5;
            __fitLbl.style.fontSize = __fs + 'px';
          }
        });
      }
    }
    // Reset stagger before re-showing — strip class then re-add on next frame so the
    // transitions replay (otherwise updates after ATC just snap into place).
    sticky.classList.remove('scv-show');
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){ sticky.classList.add('scv-show'); });
    });
  }
  window.__scvRenderProgressSticky = renderProgressSticky;
  // Update Dawn's header .cart-count-bubble (item count) without forcing a
  // section re-render. Hides the bubble at 0, injects one if it didn't exist on
  // page load (cart was empty then), updates the number otherwise.
  function updateHeaderCartCount(cart) {
    var qty = (cart && cart.item_count) || 0;
    var bubble = document.querySelector('.cart-count-bubble');
    if (qty === 0) { if (bubble) bubble.style.display = 'none'; return; }
    if (!bubble) {
      var iconWrap = document.getElementById('cart-icon-bubble');
      if (iconWrap) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        bubble.innerHTML = '<span aria-hidden="true">' + qty + '</span>';
        iconWrap.appendChild(bubble);
      }
      return;
    }
    bubble.style.display = '';
    var span = bubble.querySelector('span[aria-hidden="true"]');
    if (span) span.textContent = qty < 100 ? qty : '99+';
  }

  // Re-evaluate the progress sticky + header cart count after ANY successful cart
  function refreshAfterCartChange() {
    var prevQty = (cartCache && (cartCache.item_count || 0)) || 0;
    fetchCart().then(function(c) {
      cartCache = c;
      // cartCacheKey intentionally not touched here — see comment above
      renderProgressSticky();
      updateHeaderCartCount(c);
      // Drawer open + cart mutated OUTSIDE our own UI (reconciler PATCH,
      // another surface's add/remove) → repaint the body so line notes and
      // the under-checkout pre-order note reflect the ACTUAL cart. Debounced:
      // reconciler bursts fire several mutations back-to-back.
      if (document.documentElement.classList.contains('scv-open')) {
        if (window.__scvRepaintT) clearTimeout(window.__scvRepaintT);
        window.__scvRepaintT = setTimeout(function(){ try { loadAndRender(); } catch(e){} }, 400);
      }
      // Cart-cleared autoload: when the user goes from non-empty to empty
      var newQty = (c && (c.item_count || 0)) || 0;
      if (prevQty > 0 && newQty === 0 && document.getElementById('pack-builder-slideout')) {
        try { window.dispatchEvent(new CustomEvent('scv:openPackBuilder', { detail: { stage: _scvStageCat() } })); } catch(e){}
      }
    }).catch(function(){});
  }
  window.addEventListener('em:atc:done',    refreshAfterCartChange);
  window.addEventListener('em:cart:changed', refreshAfterCartChange);

  // Re-render from cache (no refetch) after SPA swap / drawer close /
  // bfcache restore — keeps the pill present + stage-CTA accurate.
  function _scvReassertSticky(){ try { renderProgressSticky(); } catch(e){} }
  window.addEventListener('em:v2:swapped', _scvReassertSticky);
  window.addEventListener('scv:close', _scvReassertSticky);
  window.addEventListener('pageshow', function(e){ if (e && e.persisted) _scvReassertSticky(); });

  function loadAndRender() {
    var promises = [];
    if (!bundleConfig) {
      promises.push(
        fetch(cfg.bundleConfigUrl || '').then(function(r) { return r.json(); }).then(function(c) {
          var curCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
          var cc = c[curCode] || c['AUD'] || {};
          bundleConfig = cc;
          if (curCode === 'GBP') S = '\u00A3';
          else if (curCode === 'EUR') S = '\u20AC';
          else if (curCode === 'SGD') S = 'S$';
          // Geo-aware free-ship threshold + standard ship rate for this currency
          FREE_SHIP = FREE_SHIP_MAP[curCode] || 150;
          // Published for the PDP price ladder — read-only, nothing here changes.
          try { window.__emFreeShipThreshold = FREE_SHIP; } catch (e) {}
          STANDARD_SHIPPING = SHIPPING_RATE_MAP[curCode] || 15;
          // Locale: switch "mum" → "mom" for US/CA visitors. AU/NZ/UK/IE/SG keep "mum".
          var __country = (window.Shopify && window.Shopify.country && window.Shopify.country.iso_code) || '';
          IS_MOM = __country === 'US' || __country === 'CA';
          if (IS_MOM) {
            MUM_LOWER = 'mom'; MUM_TITLE = 'Mom'; MUM_UPPER = 'MOM'; MUM_PLURAL = 'moms';
          }
        }).catch(function() {})
      );
    }
    if (!preorderConfig) {
      promises.push(
        fetch(cfg.preorderConfigUrl || '').then(function(r) { return r.json(); }).then(function(c) {
          preorderConfig = Array.isArray(c) ? c : [];
          if (window.EmmacoProductResolver) window.EmmacoProductResolver.loadPreorderConfig(cfg.preorderConfigUrl);
        }).catch(function() { preorderConfig = []; })
      );
    }
    if (!continueSellingSkus.size) {
      promises.push(
        fetch(window.__scvCfgUrls.continueSelling).then(function(r) { return r.json(); }).then(function(d) {
          var skus = Array.isArray(d && d.skus) ? d.skus : [];
          continueSellingSkus = new Set(skus.filter(Boolean));
        }).catch(function() {})
      );
    }
    Promise.all(promises).then(function() {
      // Cache hit → render immediately. Always also fetch fresh in parallel and re-render
      // only if the data changed (key compares items + total_price). Cold cache behaves
      // identically to before — single fetch, single render.
      if (cartCache) {
        ensureTagsForCart(cartCache).then(function() { publishBundleQty(cartCache); render(cartCache); });
      }
      return fetchCart().then(function(cart) {
        mcReconcileMembership(cart); // auto-add/remove the membership line to match the toggle state
        var key = JSON.stringify(cart && cart.items ? cart.items : []) + '|' + (cart && cart.total_price);
        var changed = key !== cartCacheKey;
        cartCache = cart;
        cartCacheKey = key;
        if (changed) {
          return ensureTagsForCart(cart).then(function() { publishBundleQty(cart); render(cart); });
        }
        // Unchanged cart still needs publishing — a reload with a pre-existing
        // cart hits the cache-hit path and would otherwise never publish.
        return ensureTagsForCart(cart).then(function() { publishBundleQty(cart); });
      });
    }).catch(function(e) { console.warn('[scv] loadAndRender failed', e); });
  }

  // Expose for the drawer-mode gate (Phase 2): scv:open re-runs loadAndRender to refresh.
  window.__scvLoadAndRender = loadAndRender;

  // Optimistic add — splice a synthesised line into cartCache + render now.
  window.__scvOptimisticAdd = function(variantId) {
    if (!cartCache || !variantId) return null;
    var d = __pairVariantData[String(variantId)] || __pairVariantData[variantId];
    // The journey fill engine suggests from the WHOLE catalog, not just the 7
    // pre-seeded pair products — synthesize unknown variants from the pack
    // catalog so the optimistic render classifies the journey correctly
    // (without this, a dynamic pick briefly registered as kind "other" and
    // the row re-offered a garment the shopper just added).
    if (!d) {
      try {
        var __cat = window.__emPackCatalog;
        if (__cat && __cat.products) {
          outer: for (var __ci = 0; __ci < __cat.products.length; __ci++) {
            var __cp = __cat.products[__ci];
            var __vs = __cp.variants || [];
            for (var __cj = 0; __cj < __vs.length; __cj++) {
              if (String(__vs[__cj].id) === String(variantId)) {
                d = {
                  handle: __cp.handle,
                  product_id: 0,
                  product_title: __cp.title,
                  variant_title: __vs[__cj].size || '',
                  image: __vs[__cj].img || __cp.image || '',
                  price: Math.round((__vs[__cj].price || 0) * 100),
                  compare_at_price: 0,
                  sku: __vs[__cj].sku || null
                };
                break outer;
              }
            }
          }
        }
      } catch (e) {}
    }
    if (!d) return null;
    // bundleQty is local to render(); compute fresh from cartCache here.
    var __bq = 0;
    (cartCache.items || []).forEach(function(__bi){ if (isBundleEligible(__bi)) __bq += (__bi.quantity || 0); });
    var __perUnitDollars = clampToVariant(priceForQty(__bq + 1), d.price / 100);
    var __perUnitCents = Math.round(__perUnitDollars * 100);
    var optKey = '__optimistic:' + variantId + ':' + Date.now();
    var line = {
      variant_id: Number(variantId),
      product_id: d.product_id,
      product_title: d.product_title,
      variant_title: d.variant_title,
      handle: d.handle,
      image: d.image,
      quantity: 1,
      key: optKey,
      final_price: __perUnitCents,
      final_line_price: __perUnitCents,
      original_price: d.compare_at_price || 0,
      price: __perUnitCents,
      properties: {},
      sku: d.sku || null
    };
    cartCache.items = cartCache.items || [];
    cartCache.items.push(line);
    cartCache.item_count = (cartCache.item_count || 0) + 1;
    cartCache.total_price = (cartCache.total_price || 0) + __perUnitCents;
    cartCacheKey = ''; // force the next real-cart compare to re-render
    // The optimistic line must land INSIDE its journey box on the very first
    // paint. Journey membership requires bundle eligibility (tagCache), which
    // for non-pair handles only arrives with a later fetch — the line briefly
    // rendered OUTSIDE the box, then visibly jumped in (~1.5s). The catalog
    // already knows eligibility, so seed the cache now.
    try {
      if (line.handle && !tagCache[line.handle]) {
        var __ocat = window.__emPackCatalog;
        var __op = __ocat && __ocat.products && __ocat.products.find(function (p) { return p.handle === line.handle; });
        if (__op && __op.bundleEligible !== false) tagCache[line.handle] = ['bundle-test'];
      }
    } catch (e) {}
    // Expand the journey this item lands in — a suggestion-add into a
    // collapsed accordion looked like nothing happened. (Self-contained
    // classifier: render()'s __journeyOf is closure-scoped and unreachable
    // here; keyword rules mirror __categoryOf.)
    try {
      var __oh = (line.handle || '').toLowerCase();
      var __ot = (line.product_title || '').toLowerCase();
      var __osg;
      if (/pregnancy.recovery|^recovery$|recovery-/.test(__oh) || __ot.indexOf('recovery') >= 0) __osg = 'postpartum-recovery';
      else if (__oh.indexOf('nursing') >= 0 || __oh.indexOf('crop') >= 0 || __ot.indexOf('nursing') >= 0) __osg = 'breastfeeding';
      else if (__oh.indexOf('mat-') >= 0 || /\bmat\b|maternity/.test(__oh) || __ot.indexOf('maternity') >= 0) __osg = 'pregnancy';
      else __osg = 'mum-uniform';
      window.__scvOpenJourneys = window.__scvOpenJourneys || {};
      window.__scvOpenJourneys[__osg] = true;
    } catch (e) {}
    // Synchronous render — tags for pair-products are pre-seeded.
    render(cartCache);
    return optKey;
  };

  // Optimistic qty change — mutate the cached line (or remove it when newQty=0)
  // + render synchronously.  Called by both the +pip handler and changeQty().
  window.__scvOptimisticBumpQty = function(lineKey, newQty) {
    if (!cartCache || !cartCache.items || !lineKey || typeof newQty !== 'number' || newQty < 0) return null;
    var idx = -1;
    for (var i = 0; i < cartCache.items.length; i++) {
      if (cartCache.items[i].key === lineKey) { idx = i; break; }
    }
    if (idx < 0) return null;
    var __it = cartCache.items[idx];
    var __prev = __it.quantity || 0;
    var __delta = newQty - __prev;
    if (__delta === 0) return newQty;
    if (newQty === 0) {
      // Remove the line entirely.
      cartCache.items.splice(idx, 1);
      cartCache.item_count = Math.max(0, (cartCache.item_count || 0) - __prev);
    } else {
      __it.quantity = newQty;
      var __bq = 0;
      cartCache.items.forEach(function(__bi){ if (isBundleEligible(__bi)) __bq += (__bi.quantity || 0); });
      if (isBundleEligible(__it)) {
        var __unit = mcUnit(__it, __bq);
        var __uc = Math.round(__unit * 100);
        __it.final_price = __uc; __it.price = __uc;
        __it.final_line_price = __uc * newQty;
      } else {
        var __eu = (__it.final_line_price || 0) / Math.max(1, __prev);
        __it.final_line_price = Math.round(__eu * newQty);
      }
      cartCache.item_count = Math.max(0, (cartCache.item_count || 0) + __delta);
    }
    cartCacheKey = '';
    render(cartCache);
    return newQty;
  };

  // /cart: auto-load. Off /cart: prime cart cache on idle for instant open.
  (function(){
    var p = location.pathname || '';
    if (p === '/cart' || p.indexOf('/cart/') === 0) {
      loadAndRender();
      return;
    }
    function prime() {
      // Pre-load configs + cart in parallel so drawer opens instantly
      var primePromises = [];
      if (!bundleConfig) {
        primePromises.push(
          fetch(cfg.bundleConfigUrl || '').then(function(r){return r.json();}).then(function(c){
            var curCode = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'AUD';
            bundleConfig = c[curCode] || c['AUD'] || {};
            if (curCode === 'GBP') S = '\u00A3';
            else if (curCode === 'EUR') S = '\u20AC';
            else if (curCode === 'SGD') S = 'S$';
            FREE_SHIP = FREE_SHIP_MAP[curCode] || 150;
          // Published for the PDP price ladder — read-only, nothing here changes.
          try { window.__emFreeShipThreshold = FREE_SHIP; } catch (e) {}
            STANDARD_SHIPPING = SHIPPING_RATE_MAP[curCode] || 15;
            var __country = (window.Shopify && window.Shopify.country && window.Shopify.country.iso_code) || '';
            IS_MOM = __country === 'US' || __country === 'CA';
            if (IS_MOM) { MUM_LOWER = 'mom'; MUM_TITLE = 'Mom'; MUM_UPPER = 'MOM'; MUM_PLURAL = 'moms'; }
          }).catch(function(){})
        );
      }
      if (!preorderConfig) {
        primePromises.push(
          fetch(cfg.preorderConfigUrl || '').then(function(r){return r.json();}).then(function(c){
            preorderConfig = Array.isArray(c) ? c : [];
          }).catch(function(){ preorderConfig = []; })
        );
      }
      if (!continueSellingSkus.size) {
        primePromises.push(
          fetch(window.__scvCfgUrls.continueSelling).then(function(r){return r.json();}).then(function(d){
            var skus = Array.isArray(d && d.skus) ? d.skus : [];
            continueSellingSkus = new Set(skus.filter(Boolean));
          }).catch(function(){})
        );
      }
      if (!cartCache) {
        primePromises.push(
          fetchCart().then(function(c) {
            cartCache = c;
            cartCacheKey = JSON.stringify(c && c.items ? c.items : []) + '|' + (c && c.total_price);
          }).catch(function(){})
        );
      }
      Promise.all(primePromises).then(function(){
        if (cartCache) {
          renderProgressSticky();
          updateHeaderCartCount(cartCache);
          // This idle prime is the ONLY cart load on a PDP/home page — the
          // drawer's loadAndRender doesn't run until it's opened. Without
          // publishing here, a shopper arriving with a pre-existing cart left
          // the PDP ladder with no cart quantity to read, so it fell back to
          // the page's own qty and always marked "1 item" as her price.
          ensureTagsForCart(cartCache).then(function () { publishBundleQty(cartCache); });
        }
      });
    }
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(prime, { timeout: 2000 });
    } else {
      setTimeout(prime, 800);
    }
  })();
})();

